export default {
  common: {
    noFace: 'Tidak ada wajah',
    noPermissionTip: 'Anda tidak memiliki izin untuk menggunakan fitur ini. Silakan membeli atau memperpanjang izin untuk melanjutkan.',
    selected: 'Terpilih',
    continue: 'Lanjutkan',
    open1: 'Buka',
    doubleClick: 'Klik Dua Kali',
    inputKeywordSearch: 'Masukkan kata kunci pencarian',
    inputKeywordStartSearch: 'Masukkan kata kunci untuk memulai pencarian',
    searchHistory: 'Riwayat Pencarian',
    clearHistory: 'Hapus Riwayat',
    notFoundRelatedResults: 'Tidak ditemukan hasil terkait',
    switch: 'Beralih',
    searchProductionLine: 'Jalur Produksi',
    selectProductionLine: 'Pilih Jalur Produksi',
    rotateAngleTip: 'Putar {angle}',
    plankText: 'Papan',
    sendToEzSort: 'Kirim ke EzSort',
    downloadEzSort: 'Unduh EzSort',
    notDownloadTip: 'Jika EzSort tidak dapat dibuka dengan normal, mungkin karena Anda belum mengunduhnya. Silakan klik tombol di bawah untuk mengunduh EzSort',
    updateTip: 'Perbaruan perangkat lunak terdeteksi. Silakan restart Guigui!',
    betaTest: 'Gratis selama uji coba beta',
    ersortSpecail: 'Eksklusif untuk Label Warna',
    exclusiveFeature: 'Fitur Eksklusif',
    elementCanBeDragTip: 'Elemen dapat ditarik',
    checkPlankIsConflict: 'Status pelat sedang diuji. Status pelat sedang diuji. Status pelat sedang diuji. Status pelat sedang diuji.',
    preferenceSaveErr: 'Exception in saving preferences',
    guimen: 'Pintu kabinet',
    preferenceLoadTip: 'Memuat preferensi Anda',
    preferenceLoadErrTip: 'Preferensi gagal memuat, silakan menyegarkan dan mencoba lagi untuk menghindari menyebabkan kesalahan preferensi Anda!',
    localFileIsBeingWrite: 'File lokal sedang ditulis',
    taskMonitor: 'Pemantauan tugas',
    downloadByType: 'Unduh {type}',
    slotKnifeErr: 'Untuk slot yang hilang, alat pemrosesan yang ditentukan, silakan periksa pengaturan jalur produksi! 【{Msg}】',
    anewChooseCatalog: 'Pilih direktori',
    downloadSetting: 'Unduh pengaturan',
    attention: 'Melihat',
    unit: 'bagian',
    defaultUse: 'Digunakan secara default',
    defaultChooseUse: 'Dipilih secara default',
    requestFail: 'Permintaan gagal',
    downloadDoneByType: '{type} unduh selesai',
    sysTip: 'Permintaan sistem',
    pleaseChoose: 'Pilih',
    confirmDelete: 'Konfirmasi penghapusan',
    notDataTipByType: 'Belum ada data, tolong {msg} pertama',
    paginationTotalTip: '{current}-{page}/total {total}',
    chooseAmountData: '{number} Data yang dipilih',
    moreOperate: 'Lagi',
    transferByType: 'Transfer {type}',
    clickCopy: 'Klik untuk menyalin {type}',
    currentLine: 'Baris saat ini',
    remark: 'Komentar',
    customFunction: 'Fitur Kustom',
    limitedTimeTrial: 'Limited Free',
    startDate: 'tanggal mulai',
    endDate: 'Tanggal akhir',
    startTime: 'Waktu mulai',
    endTime: 'Waktu akhir',
    lastMonth: 'Bulan lalu',
    lastSixMonth: 'Enam bulan terakhir',
    lastYear: 'Tahun lalu',
    searchByType: 'Harap masukkan {type} untuk meminta permintaan',
    addTime: 'Tambahkan waktu',
    startArrange: 'Mulai tipografi',
    select: 'memilih',
    search: 'Cari',
    name: 'nama',
    plankNo: 'Nomor Dewan',
    plankName: 'Nama Dewan',
    orderNo: 'Nomor pesanan',
    order: 'Memesan',
    partNameWithoutRoomCabinet: 'Nama papan (tanpa ruang/kabinet)',
    plankRemark: 'Catatan pelat',
    room: 'Ruang',
    orderAddress: 'Galeri Proyek',
    matCode: 'Bahan',
    matCode2: 'Bahan',
    plankMatCode: 'Bahan pelat',
    count: 'kuantitas',
    customer: 'klien',
    customerInfo: 'Informasi pelanggan',
    factoryOrderNo: 'Nomor pesanan pabrik',
    roomName: 'Ruang',
    color: 'warna',
    plankColor: 'Warna piring',
    plankThick: 'Ketebalan pelat',
    plankHighGloss: 'Sorot atribut',
    thick: 'ketebalan',
    front: 'depan',
    back: 'Sebaliknya',
    slot: 'alur',
    hole: 'lubang',
    hsInfo: '{hole} hole {slot} slot',
    diameter: 'diameter',
    finishedWidth: 'Lebar produk jadi',
    finishedHeight: 'Panjang produk jadi',
    finishedArea: 'Luas produk jadi (㎡)',
    remarks: 'Catatan',
    remark1: 'Catatan 1',
    remark2: 'Catatan 2',
    remark3: 'Catatan 3',
    remark4: 'Catatan 4',
    remark5: 'Catatan 5',
    remark6: 'Catatan 6',
    remark7: 'Catatan 7',
    remark8: 'Catatan 8',
    remark9: 'Catatan 9',
    remark10: 'Catatan 10',
    remark11: 'Catatan 11',
    remark12: 'Catatan 12',
    remark13: 'Catatan 13',
    remark14: 'Catatan 14',
    remark15: 'Catatan 15',
    remark16: 'Catatan 16',
    texture: 'Tekstur',
    normal: 'Garis vertikal',
    reverse: 'Garis horizontal',
    notCare: 'Tidak ada tekstur',
    holeSlotsStastic: 'Jumlah slot lubang',
    edge: {
      title: 'Segel tepi',
      info: 'Informasi pemblokiran tepi',
      front: 'Segel tepi depan',
      back: 'Segel tepi belakang',
      left: 'Blok sisi kiri',
      right: 'Blok sisi kanan',
      up: 'Segel tepi atas',
      down: 'Segel tepi berikutnya'
      },
    isSpecial: 'Asing',
    notSpecial: 'Tidak berbentuk non-ekstra',
    textOfDoorPlank: 'Panel pintu',
    textOfNotDoorPlank: 'Panel non-pintu',
    isDoorPlank: 'Panel pintu',
    notDoorPlank: 'Panel non-pintu',
    width: 'lebar',
    long: 'panjang',
    plankWidth: 'Lebar piring',
    plankHeight: 'Panjang piring',
    shortLong: 'Panjang sisi pendek',
    shortWidth: 'Lebar sisi pendek',
    plankShape: 'Bentuk piring',
    detail: 'Detail',
    cancel: 'Membatalkan',
    confirm: 'mengonfirmasi',
    alreadyKnow: 'Saya sudah tahu',
    Noprompts: 'Tidak ada lagi peringatan',
    deep: 'kedalaman',
    other: 'lainnya',
    heighGloss: 'Menyorot',
    heighGlossPlank: 'Papan Sorotan',
    heighGlossSide: 'Sisi Sorotan',
    notHeighGloss: 'Non-highlight',
    notHeighGlossPlank: 'Papan non-highlight',
    saveSuccess: 'Simpan dengan sukses',
    deleteSuccess: 'Hapus dengan sukses',
    addSuccess: 'Ditambahkan dengan sukses',
    editSuccess: 'Modifikasi berhasil',
    engraving: 'Mesin ukiran',
    electronicSaw: 'Gergaji elektronik',
    glassEquip: 'Mesin pemotong kaca',
    labelingMachine: 'Mesin pelabelan',
    copy: 'menyalin',
    paste: 'Pasta',
    undo: 'Menarik kembali',
    move: 'bergerak',
    PTP: 'PTP',
    dock56FDrill: 'Berlian lima sisi',
    sideHoleDrill: 'Mesin lubang samping',
    combination: 'Peralatan kombinasi',
    integration: 'Mesin all-in-one',
    standardPlank: 'Papan besar standar',
    standardMaterial: 'Lembar Standar',
    standardMaterialTip: 'CATATAN: Setelah menyelesaikan penyesuaian informasi papan besar, pengguna yang berada dalam produksi tata letak kabinet perlu memulai kembali klien kabinet untuk menerapkan perubahan terbaru!',
    specialMaterial: 'Piring khusus',
    specialPlank: 'Dewan Besar Khusus',
    singlePlank: 'Panel tunggal',
    previous: 'Sebelumnya',
    plankInfo: 'Detail Papan Besar',
    moreResult: 'Lebih banyak solusi pengaturan huruf',
    moreResultTip: 'Ada alur untuk menggiling di pelat besar, dan pelat besar tidak akan berpartisipasi dalam tata letak jenis ulang.',
    ok: 'Tentu',
    dispersePaibanTip: 'Terdeteksi bahwa beberapa papan besar tidak dapat disebarkan dalam tata letak. Anda dapat secara manual menyesuaikan atau mengganti rencana tata letak untuk menghindari menjalankan papan!',
    next: 'Berikutnya',
    rate: 'Tingkat pemanfaatan',
    paibanBatch: 'Batch pengukur huruf',
    return: 'kembali',
    FGNo: 'Nomor kontrak',
    refresh: 'menyegarkan',
    inde: 'Nomor seri',
    productionLine: 'Jalur produksi',
    operation: 'beroperasi',
    colorPlaceHolder: 'Tekan Enter untuk secara otomatis membuat kartu warna',
    saveAndContinue: 'Simpan dan lanjutkan',
    reset: 'Mengatur ulang',
    check: 'Pertanyaan',
    inputPlaceholder: 'Harap masuk',
    filter: 'menyaring',
    all: 'semua',
    exportPDF: 'Ekspor PDF',
    exportPic: 'Ekspor gambar',
    add: 'Tambahkan ke',
    edit: 'edit',
    delete: 'menghapus',
    restore: 'mengembalikan',
    save: 'menyimpan',
    saveSetting: 'Simpan Pengaturan',
    isHeightGloss: 'Pilih apakah itu papan highlight',
    noSync: 'Absen',
    sync: 'sinkronis',
    formatSuccess: '{type} sukses',
    dataLoading: 'Data sedang memuat ...',
    warmTip: 'Tips yang baik',
    importantTip: 'Penting',
    wellcome: 'Selamat Datang di Tata Letak Cloud',
    timeOut: 'Mengatur waktu pengaturan waktu, apakah akan mengetik ulang',
    notSawKnifeTip: 'Perhatian: Mesin ukir pemotong gergaji belum mengatur Pisau Gergaji Potong Melintang, sehingga tidak dapat melakukan nesting. Silakan tambahkan!',
    doorFrameKnifeRadiusErr: 'Anda telah mengaktifkan fitur "Mesin Ukir Pemotong Gergaji - Pemotongan Bingkai Pintu". Radius pisau pemotong lebih besar dari ketebalan pisau gergaji, sehingga nesting tidak dapat dilakukan!',
    doorFrameIrregularPlankErr: 'Anda telah mengaktifkan fitur "Mesin Ukir Pemotong Gergaji - Pemotongan Bingkai Pintu". Fitur ini sementara tidak mendukung nesting panel tidak beraturan!',
    warning: 'memperingatkan',
    export: 'Ekspor',
    mark: 'tanda',
    noMark: 'Tidak ditandai',
    sawArrange: 'Jenis pemotongan melihat',
    directArrange: 'Jenis Potong Lurus',
    area: 'daerah',
    plankNum: 'Barcode papan',
    loc: 'Kabinet',
    cutHeight: 'Panjang pemotongan',
    cutWidth: 'Lebar pemotongan',
    defaultProduction: 'Jalur produksi default',
    surplusNum: 'Kode batang bahan surplus',
    tip: 'petunjuk',
    history: 'Sejarah',
    hinge: 'Lubang engsel',
    hingeScrew: 'Lubang pemandu panel berengsel',
    CCPXHole: 'Lubang eksentrik tiga dalam satu',
    stretchHinge: 'Slot pelurus dan lubang cawan engsel',
    stretch: 'Pelurus',
    stretcher: 'Slot pelurus',
    eccHole: 'Lubang eksentrik',
    preHole: 'Lubang tertanam',
    clothole: 'Pakaian melalui lubang',
    backPlank: 'Slot pelat belakang',
    ALS: 'Slot pegangan gelap',
    doorSlot: 'Alur logam panel pintu',
    drawerSlot: 'Slot logam laci',
    lkSlot: 'Slot kunci',
    KC: 'Hole Tarik Celana',
    stealth: 'Bagian yang tidak terlihat',
    lightSlot: 'Palung cahaya',
    ConventionalHole: 'Lubang konvensional',
    Keyhole: 'Lubang kunci',
    allHole: 'Semua lubang di papan berbentuk khusus',
    allSlot: 'Semua slot di papan berbentuk khusus',
    freedomAllHoleSlot: 'Semua lubang dan slot di papan berbentuk khusus',
    freedomAllHoleSlotTip: 'Papan bebas: papan dengan sudut bukan siku',
    millInfo: 'Pegangan tanduk',
    haiTang: 'Tanduk Begonia',
    FSDrill: 'Berlian lima/enam sisi',
    engraving2: 'Mesin pemotong',
    xyReverse: 'XY Axis Interchange',
    autoXYReverse: 'Perangkat pemrosesan lubang slot otomatis disesuaikan pertukaran',
    autoXYReverseTip: 'Setelah diaktifkan, data pemrosesan mesin bor lima/enam sisi dan mesin bor sisi akan disesuaikan dengan pertukaran sumbu xy mesin tanda',
    autoXYReverseTip2: 'Catatan: PTP tidak didukung',
    xyReverseTip: 'Fungsi pertukaran sumbu xy tidak kompatibel dengan lekukan bahan residu tipe-L ditempatkan dengan benar, silakan gunakan dengan hati-hati',
    rect: 'persegi panjang',
    Ltype: 'Berbentuk l',
    archive: 'Arsip',
    tellPlaceholder: 'Harap masukkan nomor ponsel Anda',
    knivesStore: 'Perpustakaan Alat',
    roll: 'Piring terbalik',
    pause: 'berhenti sebentar',
    editTrans: 'Edit dan Terjemahkan',
    translateManager: 'Manajemen Terjemahan',
    grating: 'Gratis',
    addressEditErr: 'Modifikasi alamat proyek tidak didukung untuk beberapa pesanan',
    customerEditErr: 'Beberapa pesanan tidak mendukung memodifikasi informasi pelanggan',
    factoryEditErr: 'Modifikasi nomor pesanan pabrik tidak didukung untuk beberapa pesanan',
    roomNameEditErr: 'Memodifikasi nama kamar tidak didukung untuk beberapa pesanan',
    remarkEditErr: 'Beberapa pesanan belum mendukung modifikasi pesanan',
    toMaterialList: 'Pergi ke Bill of Material',
    deleteFail: 'Penghapusan gagal, coba lagi nanti!',
    batchRestore: 'Pulihkan Batch',
    batchDelete: 'Hapus Batch',
    workShop: 'Produksi lokakarya',
    FGAdrress: 'Alamat Proyek/Nomor Kontrak',
    cuttingSize: 'Ukuran pemotongan',
    finishedSize: 'Ukuran produk jadi',
    labelImg: 'Label gambar',
    layoutImg: 'Penyusunan huruf',
    file: 'dokumen',
    folder: 'Folder',
    reName: 'Ganti nama',
    to: 'ke',
    plankUnit: 'membuka',
    tagTemp: 'Tag Template',
    roomRemark: 'Catatan kamar',
    noModificationPermission: 'Tidak ada izin modifikasi',
    modificationRecord: 'Ubah catatan',
    page: 'Halaman',
    strip: 'mengupas',
    jump: 'Melompat',
    freeAgreement: 'Penafian Perangkat Lunak',
    preStep: 'Sebelumnya',
    nextStep: 'Langkah selanjutnya',
    upload: 'Mengunggah',
    uploading: 'Mengunggah',
    iAgree: 'Saya setuju',
    pleaseSelectPlank: 'Pilih setidaknya satu papan',
    saveToStoreTip: 'Pilih setidaknya satu bagian yang tidak berpotongan',
    fileIsNotExist: 'File tidak ada',
    selectAll: 'Pilih semua',
    pdfTag: 'Tag PDF',
    tagImage: 'Gambar tag',
    guigui: 'Guigui',
    gratingSlot: 'Slot gril',
    deleteTip: 'Itu tidak dapat dipulihkan setelah menghapus data. Apakah Anda yakin bahwa data dihapus?',
    deleteError: 'Terjadi kesalahan yang tidak diketahui, penghapusan gagal',
    cancelDelete: 'Undelete',
    confirmDeleteTip: 'Setelah menghapus papan, papan akan memasuki "pelat yang akan diketik perpustakaan-tidak dimasukkan" di sudut kanan bawah halaman. Apakah Anda pasti akan menghapus data?',
    confirmDeleteBujianTip: 'Setelah menghapus, bagian akan dimasukkan di sudut kanan bawah halaman di "Perpustakaan Suku Cadang", apakah Anda yakin akan menghapus data?',
    confirmSureDeleteTip: 'Terdeteksi bahwa ada papan kecil dengan bahan yang sama di perpustakaan tata letak saat ini. Apakah Anda yakin ingin melanjutkan menghapus papan besar ini?',
    deleteEmptyTip: 'Apakah akan menghapus papan ini',
    notCanDelete: 'Bahan residu yang dipotong tidak mendukung penyimpanan',
    new: 'New',
    innerBluneFailure: 'Tata letak awan tertanam tidak berlaku.',
    deleteBigPlankTip: 'Piring besar harus disimpan di bawah ketebalan warna bahan saat ini dan tidak dapat dihapus!',
    continueExport: 'Abaikan, terus output file',
    toCheck: 'Periksa',
    pleaseCheck: 'Hasil tata letak saat ini memiliki konflik slot lubang/terbang dari piring kecil/kelainan dalam, silakan periksa!',
    clampHandCheck: 'Ditemukan beberapa lubang slot pada panel Anda tidak dapat menghindari posisi klem, silakan atur secara manual',
    conflictPartDetail: 'Detail panel yang bertabrakan',
    colorNotUndefined: 'Warnanya tidak bisa kosong',
    materialNotUndefined: 'Materi tidak bisa kosong',
    newSetting: 'Fitur baru',
    downImageErrTip: 'Gambar ekspor gagal karena gambar pelabelan dibuka dan dibagi menjadi folder yang berbeda sesuai dengan papan besar. Anda perlu memeriksa label papan kecil untuk mengekspornya bersama.',
    downNcErrTip: 'Unduh NC gagal karena gambar pelabelan dibagi menjadi folder yang berbeda sesuai dengan papan besar. Anda perlu memeriksa label papan kecil untuk mengekspornya bersama.',
    downNcErrTipForSurFolder: 'Unduh NC gagal karena gambar pelabelan dibagi menjadi folder yang berbeda sesuai dengan papan besar. Anda perlu memeriksa label papan kecil untuk mengekspornya bersama.',
    yes: 'Ya',
    no: 'TIDAK',
    checkColorPrint: 'Label warna saat ini dihidupkan, silakan gunakan printer warna untuk mencetak ~',
    colorRules: 'Setelah membuka tag warna yang dihasilkan, pesanan/kamar/kabinet/panel pintu akan dibedakan sesuai dengan warnanya. Saat ini, batas atas tag warna untuk jenis data yang sama adalah 12. Aturan spesifiknya adalah sebagai berikut:',
    greyPart: 'Bagian abu -abu dalam label di sebelah kanan adalah',
    region: 'daerah',
    notSame: 'Daerah yang berbeda dengan warna {regionName} yang berbeda berbeda',
    doorTip: 'Panel pintu abu-abu, putih adalah panel non-pintu',
    exist: 'ada',
    limitNotEffect: 'Lebih dari 12 data, label warna tidak berlaku',
    hoverTip: 'Gambar saat ini memiliki akhiran BMP, format pengkodean berwarna hitam dan putih, dan gambar label warna tidak bisa output.',
    lock: 'mengunci',
    unlock: 'Membuka kunci',
    batchLock: 'Batch Lock/Buka Kunci',
    surplusLock: 'Kunci bahan yang tersisa',
    surplusUnlock: 'Bahan yang tersisa tidak dikunci',
    is: 'Ya',
    not: 'TIDAK',
    savingHistory: 'Menyimpan file historis',
    saveHistorySuccess: 'Menyimpan file historis dengan sukses',
    saveHistoryFail: 'Gagal menyimpan file historis',
    bw: 'Apakah akan mengekspor label hitam putih',
    modular: 'Kabinet unit',
    autoAdjust: 'Penyesuaian otomatis',
    cutOrderTip: 'Kesalahan dalam urutan pemotongan [{{errorCutordersString} sheet Anda terdeteksi! Harap lakukan penyesuaian sebelum mengunduh file NC',
    lockedCutOrderTip: '【{ErrorCutordersString} papan besar】 terkunci, silakan ubah secara manual',
    paibanImgCutOrderTip1: 'Mendeteksi Anda',
    paibanImgCutOrderTip: 'ada kesalahan dalam urutan pemotongan! Silakan pergi ke halaman penataan dan mengekspor ulang file tata letak',
    goAdjust: 'Pergi menyesuaikan',
    autoAdjustWarning: 'Hasil tata letak saat ini tidak mendukung penyesuaian otomatis',
    checkNetwork: 'Silakan periksa jaringannya',
    moreInfo: 'Lihat informasi lebih lanjut',
    continueLayout: 'Lanjutkan mengetik',
    adjustPosition: 'Sesuaikan Pengaturan',
    specialAndFiveSix: 'Saat pengeboran pada pengeboran lima/enam sisi untuk memproses pelat dengan bentuk khusus, menyalakan bentuk khusus yang dapat menyebabkan pemotongan ke pelat. Harap konfirmasi apakah akan terus mengetik?',
    plankPathErr: 'Data bentuk khusus internal papan tidak benar. Silakan periksa apakah itu memenuhi spesifikasi alat! Nomor papan [{plankidlist}]',
    edgeCheck: 'Sistem mendeteksi bahwa pemotongan papan besar telah diubah; silakan ulang susunan untuk memastikan akurasi produksi',
    iKnow: 'Saya mengerti',
    versionErrTip: 'Silakan perbarui kabinet ke versi terbaru!',
    annualFeeExpired: 'Langganan tahunan Anda telah berakhir, silakan perbarui!',
    holeEquipment: 'Peralatan Pengeboran {num}',
    customizedService: 'Dukung layanan yang disesuaikan untuk membuat rencana produksi eksklusif Anda',
    exampleCombination1: 'Mesin ukir + Bor lima/enam sisi + Kombinasi mesin lubang samping',
    exampleCombination2: 'Gergaji elektronik + Bor lima/enam sisi + Kombinasi mesin lubang samping',
    exampleCombination3: 'Lini produksi terintegrasi otomatis penuh + Kombinasi bor lima/enam sisi',
    feedback: 'Anda dapat langsung memberikan kebutuhan Anda kepada penjualan perangkat lunak Guigui atau staf layanan purna jual',
    markModifiedBoards: 'Tandai papan kecil yang dimodifikasi',
    showMoveStep: 'Atur langkah gerakan keyboard',
    moveStep: 'Langkah gerakan keyboard',
    existChangeBoards: 'Ada papan kecil yang berubah',
    crossMaterialBoard: 'Papan silang material & warna',
    skipCrossMaterialTip: 'Jangan tampilkan lagi untuk layout ini',
    crossMaterialConfirmTip: 'Anda sedang memindahkan papan kecil melintasi material atau warna yang berbeda. {highlight} Lanjutkan?',
    crossMaterialConfirmTipHighlight: 'Papan yang dihasilkan mungkin tidak konsisten dengan pesanan split',
    exportHoleSlotPDF: 'Ekspor Gambar Slot',
    pdfFormat: 'Format PDF',
    dxfFormat: 'Format DXF',
    specialShapeKnivesInfo: 'Pengaturan alat pemotongan',
    specialShapeKnivesInfoTips: 'Papan kecil {stockNum}:',
    specialShapeKnivesInfoTips2: 'Pengaturan alat pemotongan otomatis telah diaktifkan, data tata letak tidak normal, silakan lakukan penyesuaian ulang dari daftar pemotongan, atau nonaktifkan pengaturan alat pemotongan otomatis',
    default: 'Pengaturan default',
    exportLanguage: 'Bahasa Ekspor',
    exportLanguageTip: 'Catatan: Beberapa elemen teks tidak dapat diterjemahkan saat diekspor ke PDF.',
    highGlossNameTip: 'Panel kilap tinggi yang disinkronkan dari kabinet dapat dideskripsikan dengan teks lain tanpa memengaruhi sifat kilap tingginya.',
    mixPaibanPlanSetting: 'Pengaturan Tata Letak Campuran',
    mixPaibanPlanSettingTip: 'Sistem mendeteksi bahwa pengaturan tata letak campuran telah berubah, silakan pilih ulang tata letak campuran saat ini!',
    mixPaibanPlanSettingOk: 'Set Mix Paiban Plan',
    mixPaibanPlanSettingCancel: 'No, direct layout',
    noMixPaibanPlan: 'No available mix paiban plan',
    mixColors: 'Mix Colors',
    mixPai: 'Mix Paiban',
    plan: 'Plan',
    mixPaibanTitle: 'Different Color Small Boards to be Placed Together',
    mixColorsTip: 'It is possible to define which color parts can be produced as the same color on a large board, while not changing the original color information of the parts.',
    mixColorsTip2: 'After adding a plan, it needs to be enabled in the cutting list to take effect',
    mixColorsTip3: 'Fungsi tepi warna berbeda ada konflik dan tidak dapat diaktifkan secara bersamaan',
    mixErrTip: 'Pengaturan tata letak campuran tidak lengkap, silakan periksa',
    addPlan: 'Add Plan',
    chooseMatcode: 'Choose Material',
    chooseColor: 'Choose Color',
    defineColor: 'Define as',
    confirmDeletePlan: 'Confirm to Delete the Plan',
    trimmingMethod: 'Metode pemangkasan',
    followStandardTrim: 'Ikuti nilai pemangkasan dari papan standar pada papan asli',
    trimToast: 'Perhatian: Anda menggunakan fungsi pemangkasan khusus untuk sisa bahan, hanya dapat memilih tata letak pemotongan gergaji',
    individualTrimValue: 'Atur nilai pemangkasan secara terpisah',
    topTrimEmptyToast: 'Nilai pemangkasan atas tidak boleh kosong',
    bottomTrimEmptyToast: 'Nilai pemangkasan bawah tidak boleh kosong',
    leftTrimEmptyToast: 'Nilai pemangkasan kiri tidak boleh kosong',
    rightTrimEmptyToast: 'Nilai pemangkasan kanan tidak boleh kosong',
    topTrimBlurToast: 'Silakan masukkan nilai pemangkasan atas',
    bottomTrimBlurToast: 'Silakan masukkan nilai pemangkasan bawah',
    leftTrimBlurToast: 'Silakan masukkan nilai pemangkasan kiri',
    rightTrimBlurToast: 'Silakan masukkan nilai pemangkasan kanan',
    effectToast: 'Fungsi pemangkasan khusus hanya berlaku untuk papan las',
    defaultTrimSetting: 'Pengaturan pemangkasan bawaan sisa bahan',
    enterHere: 'Masukkan di sini',
    permissionTipExportDxf: 'Ekspor Diagram Slot Lubang DXF',
    permissionTipSurplusRecycleBin: 'Tempat Daur Ulang Sisa',
    permissionTipAdvancedNesting: 'Penggabungan Tidak Beraturan Tingkat Lanjut',
    permissionTipPanelGrainAlign: 'Penyelarasan Bijian Panel',
    permissionSeparator: ', ',
    missingPermissionTip: 'Izin berikut tidak tersedia: {permissions}'
    },
  home: {
    head: {
      production: 'PENDAHULUAN PRODUK',
      resolve: 'Larutan',
      about: 'tentang kami',
      equipment: 'Mesin dan peralatan',
      tell: 'Nomor telepon keluhan',
      enter: 'Masukkan tata letak cloud'
      },
    swiper: {
      case1: {
        tag: 'Versi yang ditingkatkan baru',
        subTitle: 'Otak mesin yang cerdas',
        description: 'Mereformasi perangkat lunak optimasi tata letak online cloud industri'
        },
      case2: {
        title: 'Produksi Kabinet',
        subTitle: 'Inovasi Teknologi',
        description: 'Mendukung beberapa mesin pelabelan, mesin pemotong, mesin lubang samping, PTP lima sisi, koneksi pengeboran lima sisi'
        },
      case3: {
        title: 'Otak Industri',
        subTitle: 'Larutan',
        description: 'Algoritma pengaturan huruf yang cerdas untuk mendapatkan tingkat pemanfaatan dewan yang lebih tinggi'
        }
      },
    statistics: {
      today: 'Volume shift hari ini',
      toMounth: 'Volume tata letak bulanan',
      outturn: 'Hasil material',
      cumulative: 'Pengguna Kumulatif'
      },
    intro: {
      title: 'Perangkat Lunak Tata Letak Online Data Besar Level Enterprise',
      subTitle: 'Wawasan tentang tren industri, fokus pada kebutuhan pelanggan, memberdayakan perusahaan untuk mengubah dan meningkatkan secara digital, dan mempromosikan transformasi industri otomatisasi produksi furnitur internet. Menanggapi skenario produksi industri furnitur panel yang ada, algoritma yang dibantu AI diluncurkan untuk terus menyumbangkan pertumbuhan baru ke perusahaan',
      menue: {
        case1: {
          title: 'Tipografi online',
          subTitle: 'Ketik kapan saja',
          description: 'Tidak perlu mengunduh perangkat lunak, itu dapat diketik kapan saja, remote control tidak harus bergantung pada komputer'
          },
        case2: {
          title: 'Produksi multi-line',
          subTitle: 'Sakelar cepat dari jalur produksi',
          description: 'Mendukung beberapa jalur produksi untuk diproses dengan cepat pada saat yang sama, dan dapat dengan cepat beralih di antara jalur produksi'
          },
        case3: {
          title: 'Produksi yang baik',
          subTitle: 'Tata letak halus, pengaturan parameter halus',
          description: 'Tata letak halus dan pengaturan parameter halus untuk membuat produksi papan lebih akurat'
          },
        case4: {
          title: 'Produksi Kustom',
          subTitle: 'Label khusus, latihan lima dan enam sisi, bentuk bahan residu',
          description: 'Label Kustom, Latihan Lima dan Enam Sisi Kustom, Bentuk Bahan Residual Kustom, Pemrosesan Peralatan Gabungan'
          }
        }
      },
    fangan: {
      title: 'Solusi Profesional di Industri',
      subTitle: 'Biaya rendah, nilai output tinggi, algoritma cerdas meningkatkan pemanfaatan papan, kompatibel dengan berbagai perangkat lunak desain, memberikan solusi produksi terbaik kepada pengguna',
      menue: {
        case1: {
          title: 'Integrasi Produksi Pengambilan Pesanan Online',
          description: 'Operasi online jarak jauh, hambatan lintas ruang, pesanan output kapan saja, dan desain lengkap dan sinkronisasi produksi'
          },
        case2: {
          title: 'Jalur produksi switching satu klik',
          description: 'Jalur produksi khusus, mendukung beberapa jalur produksi, dan docking peralatan multi-tipe'
          },
        case3: {
          title: 'Algoritma cerdas meningkatkan pemanfaatan dewan',
          description: 'Pemanfaatan Dewan Algoritma Tradisional Rendah, Pengaturan Parameter Baik Algoritma Cerdas, Rencana Produksi Kustomisasi'
          },
        case4: {
          title: 'Rencana pemotongan profesional',
          description: 'Optimalkan urutan pemotongan dan titik pemotongan untuk membuat jalur lebih pendek dan lebih stabil'
          }
        }
      },
    aboutUs: {
      title1: 'Teknologi Tempat Tinggal Manusia Xingeer',
      subTitle: 'Pemimpin dalam transformasi industri produksi furnitur',
      description: 'Xingeer Enterprise berfokus pada mewujudkan transformasi internet industri produksi furnitur tradisional',
      culture: {
        case1: {
          title: 'Tujuan perusahaan',
          subTitle: 'Membantu pabrik tumbuh tiga kali lipat'
          },
        case2: {
          title: 'Nilai Budaya',
          subTitle: 'Berpusat pada pelanggan, berjuang untuk orang-orang, bekerja keras dan bermanfaat bagi orang-orang'
          },
        case3: {
          title: 'Ideologi membimbing',
          subTitle: 'Jalur massal, membangun tim elit dengan penjualan, produk, dan kekuatan organisasi'
          }
        },
      feature: {
        case1: 'Pemeliharaan Tim Profesional',
        case2: 'Pembaruan dan iterasi berkelanjutan',
        case3: 'Layanan purna jual satu-ke-satu',
        case4: 'Layanan Kustomisasi Fungsional'
        }
      },
    cooperation: {
      title: 'Bekerja sama dengan tulus untuk menciptakan masa depan bersama',
      subTitle: 'Merek peralatan docking mencakup 90% peralatan umum yang digunakan di Cina, dan 107.554 pedagang bepergian bersama kami'
      },
    footer: {
      contact: {
        title: 'Hubungi kami',
        adrres: 'Alamat: No. 50 Xiuxi, Distrik Binhu, Kota Wuxi, Provinsi Jiangsu',
        subAdrres: 'Lantai 16, Bangunan 1, Pusat Layanan K-Park',
        tell: 'Telepon'
        },
      business: {
        title: 'Xingele Core Business',
        department1: 'Departemen Bisnis Pintu dan Windows Perangkat Lunak',
        department2: 'Departemen bisnis perangkat lunak furnitur',
        department3: 'Departemen Majelis dan Konstruksi',
        department4: 'Situs Resmi Markas Xingele'
        },
      brand: {
        title: 'Merek di bawah Xingele',
        brand1: 'Dewa Bahan',
        brand2: 'Jaringan peta pintu',
        brand3: 'Investasi Dingxin',
        brand4: 'Tiga gambar teknologi',
        brand5: 'Teknologi Shanghai Pink'
        },
      organization: {
        title: 'Xingere Global Branch',
        organization1: 'Xingele-South China Bureau (Cabang Foshan)',
        organization2: 'Xingele-Northern Bureau (cabang Linyi)',
        organization3: 'Biro Xingele-Southwest (Cabang Chengdu)',
        organization4: 'Xingele-Coffee Cabinet Western Service Center',
        organization5: 'Xingele-Coffer Eastern Service Center',
        organization6: 'Xingele-Agent Cluster',
        organization7: 'Departemen Pemasaran Xingele-International'
        },
      follow: {
        title: 'Pindai "Ikuti Kabinet"'
        },
      friendLink: {
        link1: 'Perangkat Lunak Xingele',
        link2: 'K Perangkat Lunak Panduan Belanja',
        link3: 'Jaringan peta pintu',
        link4: 'Perangkat Lunak Kabinet All-Aluminium',
        link5: 'Unduh Perangkat Lunak Zol',
        link6: 'Taman Perangkat Lunak Huajun',
        link7: 'Unduh rumah',
        link8: 'Unduh Perangkat Lunak Zol',
        link9: 'Jaringan Sumber Daya Hijau',
        link10: 'Waralaba Lemari',
        link11: 'Waralaba rumah',
        link12: 'Waralaba kamar mandi standar Amerika'
        }
      }
    },
  login: {
    title: 'Masuk',
    tell: 'Nomor telepon',
    password: 'kata sandi',
    passwordPlaceholder: 'Harap masukkan kata sandi Anda',
    forget: 'Lupakan kata sandinya',
    registerAccount: 'Daftar akun',
    backLog: 'Kembali ke login',
    verifyCode: 'Kode verifikasi',
    getVerifyCode: 'Dapatkan kode verifikasi',
    verifyCodeErr: 'Kode verifikasi salah',
    confimPassword: 'Konfirmasi Kata Sandi',
    confimPasswordPlaceholder: 'Harap konfirmasi kata sandi Anda',
    editPassword: 'Ubah Kata Sandi',
    register: 'daftar',
    reSend: 'Acrequire setelahnya',
    loginLoadText: 'Masuk, tunggu ...',
    loadingPageTextL: 'Login berhasil, struktur halaman sedang memuat ...',
    loginSuccess: 'Login berhasil',
    tellErr: 'Format nomor ponsel yang salah',
    passwordErr: 'Harap masukkan kata sandi Anda'
    },
  main: {
    head: {
      title: 'Bluen',
      subTitle: 'Save time, materials, and effort',
      task: 'Mengambil tugas',
      arrange: 'penyusunan huruf',
      surplus: 'Bahan yang tersisa',
      setting: 'mendirikan',
      find: 'Menemukan',
      upgrade: 'Tingkatkan sekarang',
      editNickName: 'Ubah nama panggilan',
      editPassword: 'Ubah Kata Sandi',
      logout: 'Keluar',
      notice: 'pengumuman',
      enterOfficial: 'Kunjungi situs web resmi',
      equipment: 'Mesin dan peralatan',
      help: 'membantu',
      importFunc: 'Lihat fitur ekslusif',
      enterThinkerOfficial: 'Masukkan situs web resmi Xingele',
      history: 'Simpan riwayat',
      plankManager: 'Manajemen Film Asli',
      tagManager: 'Manajemen tag',
      suplumentManager: 'Perpustakaan Pengisian dan Tata Letak',
      fileManager: 'Manajemen file',
      productionLine: 'Docking peralatan',
      workeShop: 'Produksi di Cloud',
      useLesson: 'Tutorial Penggunaan',
      videoLesson: 'Tutorial video',
      prolineManager: 'Manajemen Jalur Produksi',
      materialManager: 'Manajemen Dewan',
      productManual: 'Manual produk',
      medialRelated: 'Terkait gradien'
      },
    sideBar: {
      title: 'Optimasi produksi',
      materialList: 'Daftar materi',
      paibanTask: 'Tugas Tata Letak',
      paibanResult: 'Rencana Pengesahan Penetapan',
      printTag: 'Label cetak',
      history: 'Simpan riwayat',
      limitDate: 'Limited Free',
      surplusManager: 'Manajemen materi yang tersisa',
      translateManager: 'Manajemen Terjemahan',
      moreSettings: 'Lebih banyak pengaturan',
      deepSeekTitle: 'Penasihat Konsultasi',
      paibanCommune: 'Grup Diskusi Tata Letak'
      },
    allRead: 'Semua dibaca',
    learnMore: 'Pelajari lebih lanjut',
    noticeEmpty: 'Belum ada pengumuman ...',
    noticeErr: 'Kesalahan mendapatkan konten pengumuman terperinci',
    feedBack: {
      tab1: 'Kirimkan umpan balik',
      tab2: 'Catatan umpan balik',
      type: 'Jenis komentar',
      typePlaceholder: 'Pilih suatu fungsi',
      description: 'menggambarkan',
      descriptionPlaceholder: 'Hai ~ Harap isi deskripsi skenario penggunaan terperinci tidak kurang dari 15 kata sehingga kami dapat membantu Anda dengan lebih baik. Terima kasih atas kerja sama Anda!',
      uploadPic: 'Tambahkan gambar, hingga 6 gambar dapat ditambahkan, dan ukuran satu gambar tidak boleh melebihi 10m)',
      tell: 'Nomor kontak',
      submit: 'kirim',
      admin: 'Administrator pengaturan huruf cloud:',
      picTip: 'Gambar: (klik untuk memperluas untuk melihat detail gambar)',
      empty: 'Belum ada data umpan balik',
      picErr: 'Ukuran satu gambar tidak boleh melebihi 10m',
      contentErr: 'Jumlah kata harus antara 15 dan 300',
      necessary: 'Opsi ini diperlukan'
      }
    },
  taskPage: {
    tab1: 'Tugas produksi',
    tab2: 'Antrian produksi massal',
    filter: {
      title: 'menyaring',
      unArrange: 'Tidak diketik',
      arranged: 'Diketik',
      allArranged: 'Semua telah diketik',
      preLayout: 'Pra-tipe'
      },
    search: {
      placeholder: 'Harap masukkan konten pencarian',
      orderName: 'Nama pesanan',
      sender: 'Pengirim'
      },
    importTask: 'Impor Tugas',
    refuseTask: 'Tolak tugas',
    refreshList: 'Segarkan daftar',
    refuseRecord: 'Tolak catatan',
    taskCard: {
      sender: 'Daftar materi yang diimpor',
      delivery: 'Tanggal pengiriman',
      delete: 'menghapus',
      addToBatch: 'Tambahkan ke batch',
      save: 'Arsip',
      arrange: 'Tata letak langsung',
      deleteTitle: 'Hapus tugas',
      checkDetail: 'Klik untuk melihat detailnya',
      refuse: 'menolak',
      refuseTime: 'Tolak waktu',
      refuseReason: 'Alasan penolakan',
      refuseTask: 'Tolak tugas',
      refuseTaskPlaceholder: 'Harap masukkan alasan penolakan',
      addErr: 'Menambahkan gagal, coba lagi nanti!'
      },
    batchNo: 'Nomor batch',
    batchArrange: 'Tata letak batch',
    clearBatch: 'Hapus antriannya',
    taskCount: 'Jumlah tugas saat ini:',
    checkAllTask: 'Lihat semua daftar material',
    clearSuccess: 'Berhasil dibersihkan',
    record: {
      batchNo: 'kelompok',
      saveDate: 'Hemat waktu',
      materialList: 'Daftar materi',
      arrangedRecord: 'Rencana Pengesahan Penetapan',
      searchPlaceholder: 'Harap masukkan nomor batch',
      tipText: 'Haruskah saya menghapus arsip?'
      },
    errTip: 'Tidak ada data tugas untuk diproses, silakan buka daftar tugas untuk menambahkannya!',
    emptyErr: 'Pesanan tugas ini tidak memiliki data papan dan tidak dapat diketik dan diproduksi!',
    operationSuccess: 'Operasi berhasil',
    operationFail: 'Operasi gagal, coba lagi nanti!',
    saveSuccess: 'Arsip berhasil',
    plankMaxLimit: 'Jumlah papan kecil melebihi batas tata letak maksimum',
    batchWorning: 'Silakan lakukan produksi dalam batch',
    batchEmptyErr: 'Daftar pesanan tidak memiliki data papan dan tidak dapat diproduksi secara massal!',
    noRoomTip: 'Tidak ada ruang dan tidak bisa diproduksi secara massal!',
    refuseHistory: 'Menolak sejarah'
    },
  materialPage: {
    specialProcess: 'Proses Khususс',
    distanceFromTop: 'Jarak dari atas',
    distanceFromRight: 'Jarak dari kanan',
    hingeData: 'Data sambungan',
    labelBackProcTip: 'Pembaruan ini telah mengoptimalkan metode pengaitan pada bagian belakang papan besar. Sekarang, Anda dapat langsung menutup sisi dan membuat lubang sesuai dengan informasi pada label. Silakan informasikan!',
    openDir: 'Arah pembukaan pintu',
    edgeEmptyTip: 'Nilai batas tidak bisa kosong',
    edgeNumberLimit: 'Hanya angka yang dapat dimasukkan dalam nilai finishing',
    chooseSurplusQuantity: 'Ada {total} jenis bahan residu yang tersedia, dan {kuantitas} tipe telah dipilih',
    noCanSaveInfo: 'Tidak ada informasi untuk disimpan',
    chooseBujianStoreQuantity: 'Ada {total} blok untuk pengisian ulang, dan papan dapat diisi ulang dalam blok total {kuantitas}, dan blok {{{choosequantity} telah dipilih.',
    isConfirmPushToAwaitStore: 'Apakah Anda pasti akan menambahkan papan yang dipilih ke perpustakaan untuk diketik?',
    enterAutoCreateMatCode: 'Tekan Enter untuk membuat materi secara otomatis',
    chooseAwaitStoreQuantity: 'Ada {total} blok secara total. Papan yang akan diketik adalah blok {kuantitas}. Blok {pilihan}} telah dipilih.',
    defaultFold: 'Data papan ditutup secara default',
    startArrange: 'Mulai tipografi',
    importMaterial: 'Impor Bill of Material',
    saveToHistory: 'Simpan ke Sejarah',
    addPlank: 'Tambahkan papan',
    addBujian: 'Tambahkan bahan pengganti',
    deletePlank: 'Hapus papan',
    batchEdit: 'Modifikasi batch',
    moreSetting: 'Lebih banyak pengaturan',
    plankSize: 'Ukuran piring',
    plankSize2: 'Dimensi (panjang*lebar*ketebalan)',
    searchPlaceholder: 'Pencarian nama papan/nomor papan',
    checkArranged: 'Lihat tata letaknya',
    checkErr: 'Tidak diketik, tidak bisa dilihat!',
    downloadSheet: 'Unduh Tabel Sampel',
    downloadSheetShowScientific: 'Unduh Tabel Sampel (Menampilkan Metode Notasi Ilmiah)',
    exportHoleSlotPDF: 'Diagram slot lubang pelat ekspor',
    style1: 'Gaya satu',
    style2: 'Gaya 2',
    style2PDF: 'Gaya 2 (PDF)',
    style2DXF: 'Gaya 2 (DXF)',
    style3: 'Gaya tiga',
    importNoCover: 'Tidak menimpa impor',
    openBujianPlankRecommend: 'Disarankan untuk membuka papan suplemen',
    openAwaitStorePlankRecommend: 'Buka papan kecil untuk rekomendasi perpustakaan tata letak',
    openSurplusPlankRecommend: 'Disarankan untuk membuka pelat material yang tersisa',
    pushToAwaitStore: 'Simpan di perpustakaan yang to-type',
    setTableHead: 'Menyiapkan header Bill of Material',
    syncConfirm: 'Data kabinet kabinet dan tata letak cloud film asli tidak konsisten! Apakah data asli blok kabinet?',
    handleSync: 'Catatan: Sinkronisasi manual dapat dilakukan dalam manajemen film asli',
    noMoreTip: 'Tidak ada lagi yang diminta',
    checkMore: 'Lihat lebih banyak',
    noHistory: 'Tidak ada sejarah untuk dilestarikan ...',
    sameOrder: 'Ada pesanan yang telah mengekspor file produksi, harap perhatikan masalah produksi duplikat!',
    markOrder: 'Apakah produksi ditandai pada halaman pesanan?',
    editErrTip: 'Beberapa pesanan tidak mendukung informasi modifikasi',
    autoSaveSuccess: 'Secara otomatis disimpan ke sejarah!',
    goAdd: 'Pergi ke Add',
    noProductionLine: 'Jalur produksi catatan ini telah dihapus. Silakan buka daftar materi untuk mengetikkan ulang.',
    fileErr: 'Parsing konten file gagal, harap konfirmasi konten file!',
    noCheckData: 'Tidak ada data yang ditemukan!',
    noArrangeTip: 'Jika Anda tidak dapat melihat paket tata letak secara langsung, silakan klik untuk memulai tata letak!',
    tooOld: 'Berlian lima dan enam sisi terlalu tua',
    contactUs: 'Silakan hubungi staf layanan purna jual untuk terhubung kembali dengan',
    pathErr: 'Ada data abnormal di dalam papan (nomor papan: {errorpathplankid}), silakan periksa!',
    sizeErr: 'Piring besar yang berlebihan! Ukuran papan kecil: {width}-{height}',
    noKnife: 'Diameter alat pemotong tidak diatur, silakan pergi ke mesin ukiran untuk mengatur alat!',
    noKnifeDiameter: 'Diameter pisau pemotong lini produksi ({name}) kosong, silakan pergi untuk menambahkan diameter pisau yang sesuai',
    openDifferentMaterialCuttingKnives: 'Pisau pemotong material berbeda telah diaktifkan',
    sendFactorySuccess: 'Berhasil dikirim ke lokakarya',
    sendFactoryErr: 'Lokakarya pengiriman gagal, silakan hubungi staf setelah penjualan untuk bantuan',
    createTaskCard: 'Apakah kartu tugas yang sesuai dibuat?',
    surplusStatistics: 'Total bahan residu dapat digunakan',
    surplusStatistics2: 'Terpilih',
    suplementStatistic: 'Pengisian blok, dapat digunakan secara keseluruhan',
    expand: 'Memperluas',
    packUp: 'Menutup',
    importErr: 'Pilih file yang benar!',
    sendLoadingText: 'Memproses dan mengirim file NC ...',
    arrangeLoading: 'total',
    arrangeLoading2: 'Zhang Xiaoban mengoptimalkan tata letak ...',
    dealing: 'Pengolahan...',
    deleteConfirm: 'Setelah dihapus, material sisa akan dipindahkan ke Tempat Sampah. Apakah Anda yakin ingin menghapus material sisa ini?',
    copyTip: 'Akan menyalin material sisa yang dipilih',
    copyTip2: 'Harap konfirmasi jumlah yang akan disalin',
    surplusHead: {
      shape: 'membentuk',
      type: 'jenis',
      remark: 'Komentar',
      area: 'Area',
      area1: 'Pembaruan ini telah mengoptimalkan metode pengaitan pada bagian belakang papan besar. Sekarang, Anda dapat langsung menutup sisi dan membuat lubang sesuai dengan informasi pada label. Silakan informasikan!'
      },
    surplusTip: 'Tidak ada bahan yang tersisa yang tersedia, Anda bisa pergi dulu',
    creatSurplus: 'Bahan baru yang tersisa',
    orderInfo: 'Informasi pesanan',
    suplement: {
      statistic: 'Total {total} blok digunakan, dan total {} blok} digunakan. {Pilihan} blok dipilih.',
      exportSuplement: 'Ekspor daftar suplemen',
      suplementLoading: 'Data suplemen sedang memuat',
      exportSuplementIng: 'Daftar suplemen sedang diekspor',
      noMatchSup: 'Gagal mencocokkan data suplemen yang tersedia',
      exportTip: 'Pilih setidaknya satu pengisian sebelum mengekspor'
      },
    empty: 'Belum ada data papan',
    paibanSetting: {
      title: 'Penyusunan huruf',
      createTask: 'Buat Tugas Penyusunan Huruf',
      selectProduction: 'Pemilihan lini produksi',
      arrangeWay: 'Pemilihan Solusi Pengesahan',
      suitText: 'Berlaku untuk：',
      surplusTrimTip: 'Catatan: Anda telah menggunakan fungsi pemangkasan kustom untuk bahan sisa, hanya tata letak gergaji yang dapat dipilih',
      suitEquipmentNormal: 'Mesin ukiran konvensional',
      suitEquipmentSpecial: 'Mesin pemotong kaca, mesin pemotong pisau gergaji',
      lessRoll: 'Lebih sedikit cetak ulang',
      computedSpecial: 'Hitung bentuknya',
      specialTip: 'Mempengaruhi kecepatan tata letak',
      irregularNesting: 'Bersarang khusus',
      primaryNesting: 'Bersarang normal',
      specialShapedPanel: 'Papan biasa tertanam berbentuk khusus',
      limitedTimeTrial: 'Limited Free',
      seniorShape: 'Sarang lanjutan',
      heteromorphicInlay: 'Bentuk khusus tertanam',
      autoCutSurplus: 'Pemotongan bahan residu otomatis',
      cutWay: 'Metode penanaman',
      maxRect: 'Dipotong ke persegi panjang terbesar',
      fixedRect: 'Potong ke ukuran tetap',
      minRectSetting: 'Ukuran minimum untuk pemangkasan',
      firstCutL: 'Potong bahan residu berbentuk L',
      firstCutLTip: 'Setelah membuka, kombinasi pelat persegi panjang yang memenuhi kondisi akan dipotong menjadi bahan residu berbentuk L.',
      shortLine: 'Sisi pendek lebih besar dari',
      longLine: 'Sisi panjangnya lebih besar dari',
      setDifferentThickness: 'Atur Ukuran Pemotongan Minimum untuk Papan dengan Ketebalan Berbeda',
      defaultRuleTip: 'Ketika ketebalan papan tidak sesuai dengan aturan, potong sesuai aturan default',
      panelThickness: 'Ketebalan panel',
      duplicateMinCutSize: 'Ketebalan saat ini sudah memiliki ukuran pemotongan minimum yang sama',
      templateEmpty: 'Data template untuk mengatur ukuran pemotongan minimum untuk papan dengan ketebalan berbeda tidak boleh kosong!',
      duplicateThicknessData: 'Data ketebalan yang duplikat ada dalam template untuk mengatur ukuran pemotongan minimum untuk papan dengan ketebalan berbeda!',
      atLeastOne: 'Setidaknya satu item harus dipertahankan!',
      maxAddFive: 'Anda hanya dapat menambahkan hingga lima item!',
      surplusTemplate: 'Template umum untuk bahan yang tersisa',
      add: 'Tambahkan ke',
      templateErr: 'Pilih tanaman ke ukuran umum dan perlu memilih setidaknya satu templat data',
      cutLong: 'Panjang tanaman',
      cutWidth: 'Lebar tanaman',
      baseInfo: 'Informasi dasar',
      continue: 'Konfirmasi dan lanjutkan',
      standardSelect: 'Pilihan Papan Besar Standar',
      customPlankOrder: 'Kustomisasi urutan tata letak papan besar',
      customPlankOrderDetail: 'Tidak terdaftar di papan kecil',
      customPlankOrderTip: 'Tata letak awan tertanam tidak berlaku.',
      customPlankOrderBrandTip: 'Pesanan yang menunggu tata letak berisi papan kartu warna merek, fitur ini diaktifkan secara default',
      surplusPlank: 'Daftar papan kecil yang tersisa',
      overSizePlank: 'Daftar bagian papan ukuran super',
      plankOrder: 'Pesanan pengukur huruf',
      plankType: 'Jenis pelat',
      plankSize: 'Ukuran piring',
      plankEdgeOff: 'Nilai perbatasan',
      amount: 'Kuantitas memotong',
      amountMax: 'Jumlah maksimum pelepasan',
      numAndOverSizeTip: 'Ada papan kecil yang melebihi penggaris dan papan besar tidak cukup untuk mengetik',
      numErrorTip: 'Penggunaan papan besar yang tidak cukup tidak dapat diketik',
      overSizeTip: 'Ada papan kecil yang tidak bisa diketik',
      restPartList: 'Tidak terdaftar di papan kecil',
      layoutOrder: 'Pesanan pengukur huruf',
      arrangeAmount: 'Kuantitas memotong',
      specialShapeTip: 'Bahan sisa bentuk khusus tidak dapat menggunakan tata letak pemotongan',
      surplusConflictTip: 'Pemotongan bahan sisa bertentangan dengan garis panel, silakan potong ulang',
      stackingMethod: {
        title: 'Metode Pengaturan Tumpukan',
        long: 'Tumpukkan oleh Panjang',
        short: 'Tumpukkan oleh Panjang Pendek'
        },
      seniorShapeTip: '【Pengaturan Anak Lantai Lanjutan】Batas percobaan gratis telah berakhir, Anda dapat melihat hasil tata letak anak lantai lanjutan (Anda juga dapat beralih ke anak lantai normal untuk produksi normal); jika Anda perlu mengekspor file produksi anak lantai lanjutan, silakan hubungi staf penjualan untuk membeli~'
      },
    filter: {
      title: 'Filter pelat',
      search: 'mencari',
      all: 'Pilih semua',
      diskSize: 'Ruang yang digunakan oleh data historis tata letak telah digunakan',
      resetFilter: 'Batalkan filter'
      },
    edit: {
      title: 'Modifikasi batch',
      target: 'Ubah objek',
      onlineSelectRow: 'Hanya baris yang dipilih',
      allRow: 'Semua',
      editKey: 'Perlu memodifikasi konten',
      editValue: 'Dimodifikasi menjadi',
      warningTip: 'Catatan: Setelah modifikasi, slot lubang dan bentuk khusus akan secara otomatis dihapus.',
      allEdge: 'Semua segel perbatasan'
      },
    add: {
      title: 'Tambahkan papan',
      continue: 'Konfirmasi dan lanjutkan',
      matCodeErr: 'Materi tidak bisa kosong',
      thickErr: 'Ketebalan tidak bisa kosong',
      colorErr: 'Warnanya tidak bisa kosong',
      longErr: 'Panjang produk jadi tidak bisa kosong',
      widthErr: 'Lebar produk jadi tidak bisa kosong',
      countErr: 'Angka setidaknya 1'
      },
    delete: {
      tip: 'Itu tidak dapat dipulihkan setelah menghapus data. Apakah Anda yakin bahwa data dihapus?',
      errTip: 'Pilih setidaknya satu papan sebelum melakukan operasi ini!',
      errTip1: 'Pilih setidaknya satu papan dan ketik',
      confirm: 'Konfirmasi penghapusan'
      },
    restore: {
      confirm: 'Konfirmasi pemulihan'
      },
    restoreConfirm: 'Setelah dipulihkan, material sisa akan dipindahkan kembali ke daftar atau gudang sisa. Apakah Anda yakin ingin memulihkan material sisa ini?',
    restoreBatchConfirm: 'Apakah Anda yakin ingin memulihkan material sisa yang dipilih?',
    save: {
      errTip: 'Tidak ada informasi untuk disimpan!',
      title: 'Simpan rencananya',
      subTitle: '(Catatan: Sejarah hanya disimpan selama satu tahun)',
      name: 'Nama program',
      historyName: 'Rencana Sejarah',
      successTip: 'Simpan dengan sukses!',
      fieldTip: 'Menyimpan Gagal!'
      },
    exportErr: 'Belum ada papan, ekspor tidak dapat dilakukan',
    exportPicErr: 'Kesalahan yang tidak diketahui ditemui saat mengekspor diagram slot lubang pelat, silakan hubungi kami untuk menyelesaikannya',
    plankNotFound: 'Tidak ada papan yang relevan yang ditemukan! Harap konfirmasi apakah akan menggambar papan!',
    noPlankName: 'Tidak ada nama papan yang ditemukan',
    plankDataErr: 'Kesalahan data papan, silakan periksa dengan cermat untuk menghindari kerugian produksi',
    exportThreeViewErr: 'Tiga tampilan slot lubang gagal, silakan hubungi layanan purna jual',
    heighGlossWarning: 'CATATAN: Ketika materi adalah highlighter, papan tidak akan dapat mengembalikannya ke stabilo setelah memodifikasi materi!',
    reset: 'Kembalikan default',
    settingHead: {
      title: 'Menyiapkan header Bill of Material',
      head: 'Header',
      customHeadName: 'Nama header kustom',
      example: 'Mencicipi',
      tip: 'Tip Operasi: Anda dapat menyeret posisi label data tabel kiri dan kanan',
      headerNameEmpty: 'Nama header tidak boleh kosong',
      duplicateHeader: 'Nama header duplikat'
      },
    copyLine: 'Klik untuk menyalin baris saat ini di bawah ini',
    copySuccess: 'Menyalin {name} Data berhasil',
    arranging: 'Total {Count} Zhang Xiaoban sedang dioptimalkan dan diketik ...',
    overSize: {
      title: 'Penguasa super untuk piring',
      subTitle: 'Daftar bagian papan ukuran super',
      overSizeTip: 'Tips untuk piring dengan penguasa tambahan',
      nonWorkInfo: 'Detail pelat yang belum diproses',
      mergeFrameDoorWholeTip: 'Catatan: Bagian ini adalah keseluruhan dari pintu frame yang digabungkan',
      conflictWorkInfo: 'Detail Dewan Konflik',
      warning: 'Terdeteksi bahwa papan kecil terlalu panjang, yang membuatnya tidak mungkin untuk mengetik! Harap sesuaikan ukuran papan kecil atau tambahkan lembar asli ukuran yang sesuai',
      checkInfo: 'Lihat detail papan',
      tipContent: 'Sistem memeriksa apakah ada papan super berukuran di papan tata letak. Di bawah ini adalah saran untuk menambahkan papan khusus. Anda dapat memodifikasi panjang dan lebar papan secara manual dan mengklik tombol <span class = "Bold Color-0"> "satu klik tambah" di bagian bawah tabel. Setelah dengan cepat menambahkan, Anda dapat terus mengetik. Anda juga dapat menambahkan papan secara manual di <span class = "Bold Color-0"> Papan khusus lembar-lembar </span>',
      add: 'Tambahkan dengan satu klik',
      addPlank: 'Tambahkan film asli',
      error: 'Dewan adalah penguasa super, tata letak gagal',
      successTip: 'Dewan ditambahkan dengan sukses! Diketik ulang',
      warningTip: 'Silakan isi panjang dan lebar papan!'
      },
    arrangeErr: 'Ada kelainan dalam data internal papan dan tidak dapat diketik dan diproduksi',
    nonDelete: 'Tidak dapat dihapus',
    addOverSizeTip: 'Ada penguasa tambahan, tambahkan lagi',
    addPlankSuccess: 'Menambahkan papan khusus dengan sukses',
    addPlankFail: 'Gagal menambahkan papan khusus',
    paibanFeedback: 'Penyusunan Huruf',
    cuttingAndPaoban: 'Pemotongan dan Penyusunan Huruf',
    lowUtilizationRate: 'Tingkat Pemanfaatan Rendah',
    unreasonableLayout: 'Penyusunan Huruf Tidak Rasional',
    feedbackSuccessTip: 'Berhasil mengirimkan umpan balik!',
    feedbackFailTip: 'Gagal mengirimkan umpan balik!',
    mixedLayoutScheme: 'Skema penggabungan ini'
    },
  arrangedPage: {
    subtleDownloadCheckTip: 'Data papan telah berubah tetapi rencana belum disimpan. Silakan klik OK untuk menyimpan rencana sebelum melanjutkan operasi selanjutnya',
    paibanRequestFailed: 'Permintaan tata letak gagal, silakan coba lagi',
    accordingPlankCountOrder: 'Urutkan berdasarkan jumlah papan besar dari tinggi ke rendah',
    editOrder: 'Edit nomor urut',
    dragOrder: 'Seret untuk mengurutkan',
    inputOrder: 'Masukkan urutan',
    editOrderTip: 'Sesuaikan urutan',
    range: 'Rentang',
    unsupportRotateTip: 'Beberapa papan telah diputar, saat ini tidak mendukung penataan ulang. Nomor papan yang telah diputar:',
    slotErrTip: 'Papan saat ini memiliki alur untuk pemrosesan pegangan, dan tidak mendukung tata letak jenis ulang!',
    lockedPaibanTip: 'Papan terkunci dan tidak dapat diurutkan ulang.',
    batchBujianErrTip: 'Papan saat ini tidak ada dalam data asli lembar material. Anda dapat memilih tipe ulang di perpustakaan suplemen/tipe.',
    useFolderIsNot: 'Lokasi unduhan dan penghematan file Anda terdeteksi oleh "{type}" tidak ada! Silakan periksa apakah foldernya telah dihapus. Jika Anda menggunakan drive USB seluler, silakan periksa apakah drive USB terhubung dengan benar.',
    useFolderIsNot1: 'Terdeteksi bahwa Anda belum mengatur lokasi unduhan file, silakan pilih direktori terlebih dahulu.',
    downloadNC: 'Unduh NC',
    downloadNC1: 'Unduh File NC',
    reArrange: 'Jenis ulang',
    reArrangeSpecifiedMaterialGroup: 'Atur ulang grup panel yang ditentukan',
    specifiedMaterialRelayoutMoreResultTip: 'Setelah grup panel yang ditentukan diatur ulang, hasil tata letak tambahan tidak akan disediakan lagi',
    searchMaterialGroup: 'Cari grup panel',
    saveToHistory: 'Simpan ke Sejarah',
    moreSetting: 'Lagi',
    cutIndexRe: 'Gunakan pintasan ctrl+z untuk membatalkan langkah sebelumnya',
    followExportTag: 'Unduh NC dan Ekspor File Tag',
    followExportPaibanImg: 'Unduh NC dan ekspor file tata letak sekaligus',
    followExportWorkerShop: 'Unduh surat pembelian ekspor NC',
    tagTemplateSelect: 'Pilihan Tag Template',
    showCuttingSequence: 'Tampilkan pesanan pemotongan',
    showPlankSize: 'Tampilkan ukuran papan kecil',
    sendToFactory: {
      title: 'Kirim ke lokakarya',
      fileType: 'Jenis File Tag'
      },
    checkData: 'Memeriksa integritas data ...',
    dataLoading: 'Bekerja untuk memuat ...',
    addToBujianStore: 'Menambahkan ke gudang pengisian ...',
    updateTaskStatus: 'Perbarui status tugas ...',
    sending: 'Kirim ke lokakarya',
    waitLoadding: 'Tunggu',
    loadding: 'Sedang berlangsung',
    finish: 'Menyelesaikan',
    loadSetting: 'Pengaturan Memuat',
    loadPreference: 'Preferensi pemuatan',
    dealTemplate: 'Templat pemrosesan',
    initTagData: 'Inisialisasi data tag',
    prepareDrawData: 'Siapkan Data Gambar Label',
    drawDataText: 'Tag Menggambar Data',
    genPdfTagFile: 'Menghasilkan file tag pdf',
    genPicTagFile: 'Hasilkan file gambar tag',
    uploadFile: 'Unggah file',
    dealNCFile: 'Memproses file NC',
    zipFile: 'Menghasilkan file terkompresi lokal',
    plankCount: 'Jumlah papan besar',
    rollCount: 'Jumlah cetak ulang',
    totalRate: 'Tingkat optimasi keseluruhan',
    rate: 'Tingkat optimasi',
    useArea: 'Area yang dioptimalkan',
    materialList: 'Daftar materi',
    saveSurplus: 'Bahan yang tersisa ke gudang',
    workeShop: 'Pesanan pembelian',
    batchTagging: 'Label tambahan batch',
    batchTaggingTip: 'Silakan pilih pelat yang membutuhkan label tambahan di bawah ini',
    holeSlotErr: 'Kedalaman lubang pelat yang abnormal terdeteksi!',
    knivesErr: 'Alat pemrosesan terdeteksi bahwa pelat tidak ditemukan!',
    checkDetail: 'Periksa detailnya',
    deepErr: {
      title: 'Kedalaman abnormal slot lubang pelat',
      errStatistic: 'Ada kelainan di papan kedua',
      errText: 'Bagian pengecualian',
      markErrPart: 'Kotak bagian pengecualian'
      },
    warningTip: 'Pelat Double-Sided High-Gloss: Proses Pertama <Span class = "Font-style"> Permukaan gloss tinggi </span>, lalu proses <span class = "font-style"> permukaan matte </span>; Pelat Klos Tinggi Single-Side: Proses Langsung <Span Class = "Font-Style"> Permukaan Matte </span>',
    showDetail: {
      tip1: 'Klik untuk memilih satu papan',
      tip2: 'Lihat label papan'
      },
    arrangeTip: '(Mendukung pengaturan huruf slinging berbentuk lebar)',
    plankOpration: 'Operasi pelat',
    rotate: 'Putar 90 derajat',
    notCare: 'Tidak ada tekstur di papan tulis',
    editRemark: 'Edit Catatan',
    clearRemark: 'Catatan yang jelas',
    recalcIndex: 'Hitung ulang titik potong dan pemotongan',
    recalcIndexSuccess: 'Menghitung ulang titik potong dan pemotongan dengan sukses',
    storageArea: {
      title: 'Area penyimpanan sementara',
      empty: 'Bagian tanpa papan disimpan sementara',
      storageTip: 'Anda dapat menyeret pelat di sini untuk penyimpanan pelat sementara'
      },
    subtleArrange: 'Tata letak yang bagus',
    addPlank: 'Tambahkan papan besar',
    deletePlank: 'Hapus papan besar',
    deletePlankErr: 'Ada papan kecil saat ini, dan papan besar tidak dapat dihapus!',
    useSurplus: {
      title: 'Gunakan bahan residu'
      },
    dragWarning: 'Harap seret piring ke pelat besar!',
    areaWarning: 'Tidak dapat menempatkan papan, perhatikan ukuran ruang cadangan',
    subtlePage: {
      cut: 'Pemotongan bahan yang tersisa',
      lineTip: 'Jika pemotongan manual salah, Anda dapat menggunakan ctrl+z untuk kembali ke titik pemotongan sebelumnya',
      cancelCut: 'Akhiri potongannya',
      cutPoint: 'Titik adsorpsi pemotongan bahan yang tersisa',
      storageArea: 'Bagian pelat yang harus diatur',
      cutErr: 'Anda hanya bisa memotong piring besar dan tidak bisa menyentuh piring kecil!',
      saveErr: 'Pilih bahan potong',
      cutErr2: 'Cut hanya bisa dilakukan di piring besar dan tidak bisa melebihi pelat besar!',
      selectTip: 'Pilih potongan cadangan',
      noCutPath: 'Bentuknya tidak dapat dipotong menjadi persegi panjang',
      cutOperate: 'Operasi pemotongan material yang tersisa',
      line: 'Stroke manual',
      cutErrtip: 'Ada masalah persilangan pada titik pemotongan, silakan potong ulang',
      cutErrtip2: 'Titik pemotongan akan melebihi batas titik: 9, silakan potong ulang'
      },
    shortCut: 'Kunci Pintasan',
    updownRoll: 'Menggesek ke atas dan ke bawah',
    leftRightRoll: 'Geser ke kiri dan kanan',
    zoomScale: 'Zoom masuk dan keluar',
    dragCanvas: 'Seret halaman',
    mouseRoll: 'Roda gulir tikus',
    mouseRight: 'Tombol mouse kanan',
    mouseMultiSelect: 'Pilih beberapa papan sekaligus',
    mouseLeft: 'Tombol mouse kiri',
    doublePlank: 'Klik dua kali di papan besar',
    keyboard: 'keyboard',
    picSymble: 'legenda',
    funished: 'Produk jadi',
    holeSlotConflict1: 'Konflik lubang',
    plankErr: 'Konflik piring',
    frontSlot: 'Slot tarik depan',
    backSlot: 'Slot tarik terbalik',
    frontHole: 'Posisi wajah depan',
    backHole: 'Posisi wajah terbalik',
    resetScale: 'Setel ulang zoom',
    maxLong: 'terpanjang',
    tempErr: 'Gagal menambahkan, posisi template yang salah atau template terlalu besar!',
    sendErr: 'Lokakarya pengiriman gagal. Silakan periksa apakah template label dan data papan sudah benar sebelum mengirimnya lagi.',
    someTips: 'Anda sedang mencoba fungsi sisa bahan tidak beraturan/penyusunan tidak beraturan cloud layout untuk waktu terbatas, harap perhatikan untuk menghindari masalah produksi!',
    nestingTips: 'Uji coba gratis terbatas untuk [Tata Letak Penyusunan Bentuk Tidak Beraturan Lanjutan] telah berakhir. Untuk terus menggunakan, silakan hubungi tim sales untuk membeli!',
    frameDoorTip: 'Terdeteksi bahwa layout ini memiliki pintu rangka yang digabungkan, harap perhatikan bahwa pintu rangka perlu disekat sebelum proses pengolahan kedua di mesin pemotong!',
    cutOrderErr: 'Pesanan pemotongan tidak benar, silakan klik untuk menghitung ulang titik pemotongan dan pesanan pemotongan!',
    holeSlotConflict: 'Terdeteksi bahwa konflik lubang dan slot pelat terbang keluar dari pelat kecil',
    exportSetting: 'Pengaturan Ekspor',
    currentTagTemp: 'Templat label saat ini',
    specialPaibanErr: 'Bagian berlapis memiliki proses khusus atau alur pemrosesan tepi, dan diketik ulang belum didukung!',
    moreResult: 'Lebih banyak hasil',
    moreResultTip: 'Ada alur untuk menggiling di pelat besar, dan pelat besar tidak akan berpartisipasi dalam tata letak jenis ulang.',
    batchBujian: 'Pengisian Batch',
    batchOperation: 'Operasi Batch',
    batchEditPlankSize: 'Ubah Ukuran Papan Besar Secara Batch',
    editPlankSize: 'Edit Ukuran',
    editWay: 'Cara Edit',
    editByType: 'Edit Berdasarkan Tipe',
    editByPlankNumber: 'Edit Berdasarkan Nomor Papan Besar',
    editContent: 'Konten Edit',
    editContentTip: 'Silakan pilih jenis papan besar yang perlu diedit',
    editContentTip1: 'Silakan pilih nomor papan besar yang perlu diedit',
    editStart: 'Mulai',
    editEnd: 'Akhir',
    bigPlank: 'Papan Besar',
    editSize: 'Ukuran Diubah Menjadi',
    bigPlankWidth: 'Lebar Papan Besar',
    bigPlankHeight: 'Panjang Papan Besar',
    bigPlankLengthMarking: 'Penanda Panjang Papan Besar',
    markedAs: 'Ditandai Sebagai',
    maxAddTen: 'Maksimal menambahkan 10 item',
    minValue: 'Nilai Minimum',
    differentKnifeErr: 'Papan besar dengan pisau pemotong berbeda dipilih, ukuran tidak dapat diubah',
    noEditablePlank: 'Tidak ada papan besar yang memenuhi syarat untuk diubah',
    skipBrandPlankTip: 'Ada {count} papan besar bermerek dalam rentang yang dipilih yang tidak mendukung perubahan ukuran dan telah dilewati',
    nonBrandToBrandTip: 'Papan kecil ini tidak dapat diseret ke papan besar kartu warna bermerek!',
    brandToNonBrandTip: 'Papan kecil ini tidak dapat diseret ke papan besar kartu warna non-merek!',
    brandToOtherBrandTip: 'Papan kecil ini tidak dapat diseret ke papan besar kartu warna merek lain!',
    editNo: 'No.',
    editAllPlank: 'Semua Papan Besar',
    editBigPartSize: 'Modifikasi Ukuran Papan Besar',
    disPlaySetting: 'Tampilkan Pengaturan',
    stored: 'Telah dimasukkan ke dalam gudang',
    onlySurplus: 'Lihat saja bahan yang tersisa',
    UnuseSurplus: 'Bahan yang tersisa tidak berpartisipasi dalam perhitungan tingkat pemanfaatan',
    usePlankAdsorption: 'Fungsi adsorpsi plat',
    dataDefaultCollapsed: 'Data ditutup secara default',
    unit: 'bagian',
    cutSurplus: 'Potong bahan yang tersisa',
    frontWarningTip: 'Pelat Double-Side High-Gloss: Proses Pertama Permukaan Matte, lalu proses pelat gloss tinggi; Pelat gloss tinggi satu sisi: Langsung memproses permukaan gloss tinggi',
    selectTip: 'Pilih papan kecil di bawah ini untuk membutuhkan suplemen!',
    plankKeyWordPlaceholder: 'Harap masukkan nama papan atau nomor papan',
    surplusStoreSuccess: 'Berhasil memasuki gudang',
    editCutOrder: 'Ubah Pesanan Pemotongan',
    setCutPoint: 'Atur titik cut-down',
    specialPaibanChangeErr: 'Bagian berlapis memiliki proses khusus atau alur pemrosesan bekas, dan skema tata letak switching belum didukung!',
    storedSuccess: 'Pengisian yang sukses! Dewan yang dipilih telah ditempatkan di manajemen pengisian!',
    noSurplus: 'Tidak ada bahan yang tersisa yang ditemukan',
    selectErrTip: 'Pelat yang tersisa tidak diizinkan untuk diisi ulang, silakan pilih piring kecil normal terlebih dahulu',
    noRoomIDTip: 'Papan ini tidak memiliki ID kamar dan tidak dapat diisi ulang. Pilih papan lain terlebih dahulu',
    noPlank: 'Tidak ada papan yang ditemukan',
    noPaibanData: 'Tidak ada data pengaturan huruf, tidak dapat dilakukan',
    historyNameErr: 'Harap masukkan nama rencana',
    tempErrTip: 'Terdeteksi bahwa Anda tidak menambahkan templat yang digunakan untuk bor lima/enam sisi, sehingga file pemrosesan bor lima/enam sisi tidak dapat diekspor. Catatan: Anda perlu mengetik ulang setelah penambahan selesai.',
    changeDataTip: 'Catatan: Apakah Anda membuat file historis baru untuk menyimpan konten perubahan ini ketika Anda mendeteksi bahwa data Anda telah berubah?',
    upgrade: 'meningkatkan',
    upgradeTip: ', Anda dapat mengklik tombol di bawah ini untuk meningkatkan versi',
    plankOverEdge: 'Unduh NC Gagal! Silakan periksa apakah pelat yang tumpang tindih atau pelat berada di luar pelat besar',
    useSurplusTip: 'Apakah akan mengurangi bahan yang tersisa',
    noDataExport: 'Tidak ada data tipografi yang diekspor',
    noPlankExport: 'Tidak ada data papan kecil yang dapat diekspor',
    lockTip1: 'Klik untuk membuka kunci, setelah membuka kunci',
    lockTip2: 'Edit Posisi dan Properti Papan',
    unlockTip1: 'Klik untuk mengunci, itu tidak dapat dikunci setelah mengunci',
    unlockTip2: 'Pengeditan posisi dan atribut papan',
    plankLockErr: 'Piring besar telah dikunci dan tidak dapat ditempatkan',
    lockPartEditTip: 'Piring terkunci dan tidak dapat diedit',
    glassEquipmentTip: 'Saat jalur produksi adalah mesin pemotong kaca, pelat tidak dapat dipindahkan',
    expandedTip: 'Proses pemotongan panel khusus, operasi pengeditan tidak didukung!',
    sameWidthPlankTip: 'Panel memiliki proses pemotongan khusus dan perlu diurutkan ulang!',
    expandedArrangeTip: 'Panel memiliki proses pemotongan khusus dan perlu diurutkan ulang!',
    dragErrTip: 'Itu tidak dapat ditempatkan, silakan periksa sifat material, warna dan ketebalan piring!',
    subtleSaveTip: 'Dewan telah dioperasikan tetapi belum disimpan. Apakah itu keluar?',
    rollTip: 'Ada melalui lubang/palung di piring besar, dan tidak disarankan untuk mencetak ulang!',
    glossRollErr: 'Papan gloss tinggi dilarang',
    lockDeleteErr: 'Piring terkunci dan tidak dapat dihapus',
    deleteConfirmTip: 'Hapus operasi tidak dipulihkan',
    deleteContinueTip: 'Apakah Anda ingin melanjutkan?',
    deleteConfirm: 'Harap konfirmasi apakah akan menghapus',
    selectPlankTip: 'Pilih papan terlebih dahulu sebelum melakukan operasi ini',
    storeFailTip: 'Bahan yang tersisa gagal memasuki gudang! Silakan periksa apakah pelat yang tumpang tindih atau pelat berada di luar pelat besar',
    repeatStoreErr: 'Pelat material residu yang saat ini dipotong telah dimasukkan ke dalam gudang',
    surplusStoreFail: 'Jika penyimpanan gagal, silakan periksa apakah pelatnya persegi panjang atau piring berbentuk L!',
    plankConfilictErr: 'Itu tidak didukung untuk menempatkan poin di sini, yang akan bertentangan dengan piring lain.',
    surplusErrTip: 'Tidak didukung untuk menempatkan poin di sini, bahan residu kesalahan akan dihasilkan',
    changeArrageSuccess: 'Beralih Skema Tata Letak dengan sukses',
    trialProduction: {
      trialProductionSample: 'Kabinet sampel produksi percobaan',
      trialProduced: 'Saya sudah mencoba produksi',
      trialWarning: '{fontStyleStart}Jika{fontStyleEnd} Anda gagal melakukan verifikasi produksi kabinet sampel, semua kerugian dan konsekuensi yang merugikan bagi diri Anda sendiri, orang lain dan perangkat lunak tata letak cloud akan ditanggung oleh Anda sendiri',
      trialSlotTip: 'Selama produksi uji coba, silakan periksa apakah ukuran, kedalaman, permukaan, dan lokasi slot wajah depan dan belakang sudah benar.',
      trialSlotTip1: 'Hindari mirroring kabinet',
      trialSlotTip2: 'Masalahnya',
      pleaseUploadTrial: 'Harap unggah foto kabinet sampel produksi percobaan yang dirakit',
      uploadTrial: 'Unggah Kabinet Sampel'
      },
    awaitPlankStore: {
      store: 'Bagian papan yang akan diatur di Perpustakaan Dewan',
      notTip: 'Tidak ada lagi yang diminta yang belum dimasukkan',
      justLookCurrent: 'Hanya lihat papan pesanan saat ini',
      notInPushStorage: 'Tidak termasuk dalam gudang',
      beInStorage: 'Telah dimasukkan ke dalam gudang',
      searchPlaceholder: 'Masukkan pesanan untuk mencari papan kecil dari perpustakaan yang berkepentingan',
      plankUploading: 'Dewan diselamatkan',
      oneClickStorage: 'Penyimpanan satu klik untuk diurutkan',
      notUsePlank: 'Tidak ada papan kecil yang tersedia',
      notPlank: 'Bagian tanpa papan disimpan sementara',
      dragPlankInHere: 'Anda dapat menyeret pelat di sini untuk penyimpanan pelat sementara',
      surplusCannotBeStorage: 'Bahan yang tersisa tidak dapat disimpan',
      plankHasBeenDeduction: 'Dewan telah dikurangkan atau tidak ada data asli dan tidak dapat disimpan dalam database.',
      plankLoadErr: 'Informasi papan gagal memuat',
      taskTitle: 'Unggah papan di perpustakaan untuk diketik',
      dataGenErr: 'Kesalahan pembuatan data',
      pushSuccess: 'Berhasil memasuki gudang',
      pushErr: 'Terjadi kesalahan yang tidak diketahui dan gagal memasuki database',
      awaitBoxExistPlank: 'Perpustakaan tata letak tidak termasuk dalam papan kecil, dan disarankan untuk mengoperasikannya setelah memasuki perpustakaan.',
      mergeFrameDoorWholeTip: 'Bagian ini adalah komponen pintu frame yang digabungkan, dan setelah penyimpanan, sistem akan secara otomatis memecahkannya menjadi blok-blok individu untuk pengelolaan',
      checkPlankStatus: 'Memverifikasi status papan ...'
      },
    batchSetCut: 'Atur titik cut-down dalam batch',
    applyTo: 'Berlaku untuk:',
    ncDownloadLifeText: {
      checkData: 'Data sedang terdeteksi',
      checkDone: 'Deteksi data selesai',
      checkDataText: 'Deteksi Data',
      loadSetting: 'Pengaturan Memuat',
      settingLoadDone: 'Pengaturan pemuatan selesai',
      loadSettingText: 'Mengatur pemuatan',
      downloadNc: 'Mengunduh NC',
      ncDownloadDone: 'NC Download selesai',
      downloadText: 'Unduh NC',
      loadPreferenceSetting: 'Preferensi pemuatan',
      PreferenceSettingLoadDone: 'Preferensi Memuat Lengkap',
      loadPreferenceText: 'Preferensi pemuatan',
      dealTemp: 'Bekerja dengan template',
      TempDealDone: 'Pemrosesan template selesai',
      dealTempText: 'Templat pemrosesan',
      beBeingGenTagFile: 'Menghasilkan file {filetype}',
      genTagFileDone: 'Menghasilkan file {filetype} untuk menyelesaikan',
      genTagFileText: 'Menghasilkan file {filetype}',
      zip: 'Menghasilkan file terkompresi lokal',
      zipDone: 'Menghasilkan file terkompresi lokal untuk diselesaikan',
      genZipText: 'Menghasilkan file terkompresi',
      fileTypeText: 'gambar'
      },
    surplusCommonTemp: 'Template umum untuk bahan yang tersisa',
    plankErrTip: 'Ada papan kecil dan tidak ada papan besar yang dapat digunakan untuk tata letak!',
    brandPlankErrTip: 'Ada komponen merek tanpa papan merek yang tersedia untuk tata letak!',
    overSizeTip: 'Jumlah papan besar yang tidak mencukupi atau melebihi penguasa',
    uselessPart: 'Saat ini tidak ada papan kecil yang tersedia di papan besar, harap tata ulang',
    splitArranged: 'Ada terlalu banyak papan kecil, harap tata ulang atau susun dalam batch',
    arrangedErrTip: 'Pengesahan huruf gagal, tidak ada cukup banyak papan besar atau papan kecil yang melebihi penguasa',
    knivesModalTitle: 'Alat tidak dapat ditemukan di slot lubang',
    cannotDownloadByKnivesErr: 'NC tidak dapat diunduh, sistem mendeteksi bahwa lubang berikut ada, alat tidak dapat ditemukan',
    viewPart: 'Lihat papan pertanyaan',
    deductionModalTitle: 'Pilih objek pengurangan',
    bujianDeduction: 'Kurangi papan suplemen',
    paibanDeduction: 'Mengurangi area penyimpanan sementara papan kecil',
    surplusDeduction: 'Mengurangi pelat besar bahan residu',
    unlockPaiban: 'Buka kunci bahan yang tersisa yang terlibat dalam tata letak',
    maintain: 'Pertahankan penguncian bahan residu yang terlibat dalam pengaturan huruf',
    lockModalText: 'Ada sepiring besar bahan residu yang digunakan untuk ditempati oleh pesanan lain. Apakah ini diketik ulang?',
    lockNewSModalText: 'Saat ini menggunakan pelat besar bahan residu ditempati oleh pesanan lain. Haruskah saya terus mengunduh NC?',
    rePaibanWarn: 'Piring besar bahan residu ditempati oleh pesanan lain, dan pelat besar tidak mencukupi. Silakan pergi ke daftar materi untuk mengaturnya kembali.',
    sawRePaiban: 'Catatan: Anda menggunakan pemotongan bilah gergaji, dan tata letak pelat berbentuk khusus telah ditambahkan. Anda perlu mengetik ulang file NC untuk menjadi output.',
    togglePlankTip: 'Papan memiliki proses khusus slot tarik, tidak mendukung operasi pergantian sisi depan dan belakang!',
    stepCuttingMsg: 'Kedalaman pemotongan berlapis harus lebih kecil dari ketebalan papan',
    stepCuttingMsg2: 'Kedalaman pemotongan berlapis hanya dapat memasukkan angka yang lebih besar dari 0',
    flipPlankTip: 'Operasi pembalikan tidak diizinkan karena proses pemotongan slot lubang pemotongan mesin pemotongan papan tunggal diaktifkan!',
    genNoCutTagNotSupportExportPic: 'Tag tanpa potong diaktifkan, ekspor gambar tidak didukung',
    allSmallPlanksAreNoCutNotInLayout: 'Semua papan kecil adalah papan tanpa potong dan tidak berpartisipasi dalam tata letak',
    canStillExportHoleSlotOrPrintTag: 'Anda masih dapat mengekspor file pemrosesan lubang dan slot, atau mencetak tag',
    desMaterialNoCutNotSupportSwitchLine: 'Garis produksi saat ini telah mengaktifkan material papan kecil yang ditentukan tanpa potong, pengalihan garis langsung tidak didukung',
    desMaterialNoCutSettingChanged: 'Sistem mendeteksi bahwa pengaturan material papan kecil yang ditentukan tanpa potong telah dimodifikasi, harap tata ulang untuk memastikan akurasi produksi',
    continueDownload: 'Lanjutkan Unduh',
    desMaterialNoCutErrorTip: 'Ada lubang, slot dan bentuk tidak beraturan yang ditugaskan ke pemrosesan mesin ukir dalam papan dengan material papan kecil yang ditentukan tanpa potong. Semua lubang, slot dan bentuk tidak beraturan dalam unduhan ini ditugaskan ke pemrosesan bor 5/6 sisi. Apakah Anda ingin melanjutkan mengunduh file?',
    clearReuseRelation: 'Klik untuk menghapus hubungan penggunaan ulang',
    layoutReuseTip: 'Replikasi cepat tata letak papan besar; perubahan papan otomatis menghapus hubungan penggunaan ulang',
    hasBeenReused: 'Sudah digunakan ulang',
    layoutReuse: 'Penggunaan ulang tata letak',
    specialProcessNotSupported: 'Papan memiliki proses khusus, operasi ini tidak didukung',
    conflictNotSupported: 'Terjadi konflik papan, operasi ini tidak didukung',
    noAvailablePlankForReuse: 'Tidak ada papan yang tersedia untuk digunakan ulang',
    noMatchingPlankFound: 'Tidak ditemukan papan yang cocok',
    reuseBoard: 'Gunakan papan ke-{number}',
    influenceTip: {
      title: 'Fitur yang memengaruhi tingkat optimasi',
      empty: 'Tidak ada',
      groupParams: 'Parameter tata letak',
      surplusNoRoll: 'Sisa tidak dibalik',
      surplusCustomTrim: 'Nilai potong tepi individual',
      otherPlateCustomTrim: 'Nilai potong tepi khusus papan besar',
      knifeDiameter: 'Diameter pisau',
      surplusNoFlip: 'Sisa tidak dibalik',
      surplusNotLayout: 'Papan sisa tidak diatur papan tertentu',
      plankEdgeOff: 'Potong tepi',
      surplusCustomTrim2: 'Pemangkasan kustom surplus',
      other: 'Fitur lain yang mungkin terpengaruh',
      enabled: 'Diaktifkan',
      plankThicknessStacking: 'Pemangkasan tebal papan',
      edgePreMilling: 'Pemangkasan tepi papan',
      multiMaterialCuttingBlade: 'Pisau pemotong multi-material',
      sawSpecialShapePart: 'Panel takik berbentuk khusus untuk mesin gergaji dan ukir',
      longPlankCutting: 'Pemangkasan papan panjang kedua'
      }
    },
  paibanImg: {
    title: 'Manajemen tipografi',
    exportCustomPaibanImg: 'Ekspor tata letak khusus',
    customPaibanImg: 'Tata letak khusus',
    isCustomName: 'Nama tata letak khusus',
    template: 'Templat grafik tipografi',
    addTem: 'Tambahkan Template',
    canvasIndexSearch: 'Pencarian nomor seri papan besar',
    symbol: 'Identifikasi Grafik Tipografi',
    frontSlot: 'Slot depan',
    backSlot: 'Slot belakang',
    frontHole: 'Lubang depan',
    backHole: 'Lubang belakang',
    printNum: 'Mencetak satu kertas maksimal tampilan',
    printUnit: 'Sebuah diagram tata letak',
    edit: 'Editor Templat Grafik',
    temName: 'Nama Templat',
    rotate: 'Putar grafik tipografi',
    showOverflow: 'Baris identifikasi menampilkan data panel kecil saat teks melempah',
    showHoleSlot: 'Tampilkan informasi slot lubang',
    bigPartCss: 'Penyesuaian gaya tipografi papan besar',
    partCss: 'Penyesuaian gaya tipografi papan kecil',
    addTemTip: 'Hanya bisa menambahkan hingga 10 template tipografi!',
    exportTip: 'Silakan pilih setidaknya satu template tipografi untuk diekspor!',
    editSaveTip: 'Pastikan semua bidang yang diperlukan diisi dan simpan!',
    exportDXF: 'Ekspor DXF',
    exportDxfGeneral: 'DXF Umum 2D',
    exportDxf3d: 'DXF Khusus 3D',
    exportDxfGeneralTip: 'Cocok untuk pemrosesan manual, melihat gambar untuk pemotongan, atau memeriksa hasil tata letak',
    exportDxf3dTip: 'Cocok untuk diimpor ke sistem pihak ketiga untuk produksi; mendukung mesin pemotong laser terintegrasi Huiya'
    },
  historyPage: {
    matchErrBySpecialTip1: 'Papan khusus berikut tidak dapat lagi menemukan item yang cocok, akan ada masalah dengan tata letak ulang di halaman tata letak',
    specialPlankInfoErrTip2: 'Kesalahan dalam memperoleh informasi papan khusus, yang akan mempengaruhi fungsi tata letak ulang halaman tata letak',
    download: 'Unduh secara lokal',
    allType: 'Simpan semua',
    handleSave: 'Simpan secara manual',
    specialPlank: 'Spesial',
    surplusPlank: 'Surplus',
    autoSave: 'Simpan secara otomatis',
    allArrange: 'Semua pengaturan huruf',
    searchPlaceholder: 'Cari nama pesanan / batch tata letak / nomor pesanan',
    saveHistoryName: 'Nama riwayat tersimpan',
    trailProduction: {
      title: 'Kabinet sampel produksi percobaan',
      lastTime: 'Tanggal Produksi Percobaan Terakhir',
      recordList: 'Catatan Produksi Percobaan',
      start: 'Mulai produksi percobaan',
      date: 'waktu',
      outputFrom: 'Lokasi Output',
      empty: 'Belum ada data',
      record: 'Catatan gambar yang diunggah dari Kabinet Sampel Produksi Percobaan',
      tip1: 'Catatan: Urutan produksi uji coba saat ini menggunakan data produksi default',
      tip2: 'Catatan: Urutan produksi uji coba saat ini tidak menggunakan parameter pengaturan proses terbaru, sehingga Anda dapat pergi ke ruang produksi uji coba untuk menyimpannya lagi!',
      download: 'Unduh file pemrosesan'
      },
    deleteTip: 'Apakah Anda pasti akan menghapus sejarah berikut?',
    startDate: 'tanggal mulai',
    endDate: 'Tanggal akhir',
    lastWeek: 'Minggu terakhir',
    lastMonth: 'Bulan lalu',
    lastSeason: 'Maret lalu',
    toArrangePage: 'Pergi ke halaman tata letak',
    notArrangedTip: 'Catatan ini belum diketik, silakan pergi ke daftar materi terlebih dahulu!',
    toMaterialPage: 'Pergi ke halaman Bill of Material',
    lessSelectTip: 'Pilih setidaknya satu catatan sebelum melakukan operasi ini',
    downloadNc: 'Unduh file pemrosesan'
    },
  workShopPage: {
    warningTip: 'Fungsi ini adalah uji coba waktu terbatas, atur produksi pesanan Anda secara wajar!',
    fileManager: 'Manajemen File Produksi',
    selected: 'Terpilih',
    suplement: 'Penambahan',
    size: 'ukuran',
    saveToStore: 'Tambahkan ke gudang pengisian',
    enterArrange: 'Memasuki tipografi ...',
    deleteTip: 'Itu tidak dapat dipulihkan setelah menghapus data. Apakah Anda yakin bahwa data dihapus?',
    arrangeTip: 'Resolusi data suplemen, harap tunggu ...',
    store: 'Gudang Pengisian',
    downloadFile: 'Unduh file produksi',
    notBujianFile: 'File suplemen tidak dapat ditemukan',
    productLineDelete: 'Baris produksi telah dihapus dan file NC tidak dapat diunduh!'
    },
  basePlankManager: {
    saveTip: 'Catatan: Tekan Enter untuk menyimpan',
    offsetSize: 'Ukuran trim',
    overSizeTip: 'Ketika ukurannya terlalu besar, papan ukuran dan ukuran yang lebih besar akan dipilih secara otomatis untuk tata letak.',
    addTip: 'Jika papan dikuasai selama tata letak, jendela pop-up papan besar khusus akan ditambahkan secara otomatis ke pop up.',
    defaultOversizePlankValue: 'Atur ukuran bahan khusus yang lebih besar secara default',
    onlyLayoutTooBig: 'Piring besar ukuran ekstra hanya berbaris dengan piring kecil ukuran ekstra',
    settingRemark: 'Catatan: Fungsi asli di sini disesuaikan dengan pengaturan yang tepat',
    searchPlaceholder: 'Cari materi/warna papan',
    syncData: 'Sinkronisasi data kabinet',
    syncDataM: 'Sinkronisasi Data Pintu Kabinet',
    deletePlank: 'Hapus papan khusus',
    addPlank: 'Dewan Khusus Baru',
    matCodePlaceholder: 'Pilih piring',
    thickPlaceHolder: 'Pilih ketebalannya',
    widthErr: 'Lebar pelat tidak bisa kosong',
    heightErr: 'Panjang pelat tidak bisa kosong',
    matCodeErr: 'Bahan papan tidak bisa kosong',
    colorErr: 'Warna pelat tidak bisa kosong',
    editPlank: 'Edit papan',
    deleteTip: 'Itu tidak dapat dipulihkan setelah menghapus data. Apakah Anda yakin bahwa data dihapus?',
    plankKnifeSelect: 'Pilihan pisau pemotongan lembar asli',
    plankKnifeSelectTip: 'Ketika suku panel memenuhi beberapa aturan, prioritas ketebalan lempeng lebih tinggi daripada jenis bahan lempeng',
    knifeSelectTip: 'Catatan: Fitur ini belum didukung dalam pengaturan huruf tertanam',
    knife: 'Alat pemotongan',
    matcodeInput: 'Harap masukkan materi papan',
    thickInput: 'Harap masukkan ketebalan papan',
    default: 'Default Sistem',
    unessential: 'Kolom ini adalah: tidak diperlukan',
    emptyTip: 'Catatan: Jika Anda tidak mengisi item ini, Anda tidak akan membedakan item ini saat mencocokkan karya asli!',
    defaultUse: 'Dipilih secara default',
    editMatcode: 'Edit materi',
    syncTip: 'Data dalam {frommc} akan diperoleh dan menimpa data tata letak cloud zhongyuan yang ada. Apakah itu disinkronkan?',
    sameErr: 'Data yang sama sudah ada',
    cancelDelete: 'Undelete',
    syncErr: 'Sinkronisasi gagal',
    syncSuccess: 'Sinkronisasi berhasil',
    syncDataTip: 'Menyinkronkan data {frommc}',
    editErrTip: 'Ada informasi yang tidak terisi, silakan periksa!',
    numberCheck: '{type} hanya bisa memasukkan angka!',
    deleteStandardPlate: 'Hapus papan standar',
    createStandardPlate: 'Papan Standar Baru',
    editStandardPlate: 'Edit papan standar',
    trimmingDimension: 'Ukuran trim',
    front: 'Atas',
    back: 'Bawah',
    left: 'Kiri',
    right: 'Kanan',
    frontTrim: 'Atas pemotongan',
    backTrim: 'Bawah pemotongan',
    leftTrim: 'Kiri pemotongan',
    rightTrim: 'Kanan pemotongan',
    customTrim: 'Nilai pemotongan khusus',
    trimValue: 'Nilai pemotongan',
    notEmpty: '{type} tidak boleh kosong!',
    edgeDir: 'Pemotongan ({type})',
    brandPlank: 'Papan Merek',
    brandPlankTip: 'Catatan: Penghapusan dan modifikasi papan merek dilakukan di pustaka sumber daya papan klien Cabinet',
    brand: 'Merek',
    supplier: 'Pemasok',
    brandPlaceholder: 'Silakan pilih merek',
    supplierPlaceholder: 'Silakan pilih pemasok',
    brandInput: 'Silakan masukkan merek',
    supplierInput: 'Silakan masukkan pemasok',
    addBrandPlank: 'Tambah Papan Merek',
    deleteBrandPlank: 'Hapus Papan Merek',
    editBrandPlank: 'Edit Papan Merek',
    searchBrandPlaceholder: 'Cari merek/pemasok/material/warna'
    },
  bujianAndStore: {
    bujianStore: 'Gudang Pengisian',
    awaitStore: 'Papan untuk diketik perpustakaan',
    depositAwaitStore: 'Simpan di perpustakaan yang to-type',
    pushToAwaitStore: 'Masukkan ke dalam perpustakaan untuk diketik',
    useTwoTableArrange: 'Gunakan dua bentuk untuk mengetik',
    confirmUseTwoTableTip: 'Papan kecil yang saat ini dipilih berisi perpustakaan tambahan dan perpustakaan yang toype. Akankah papan kecil terus mengetik?',
    confirmAddPlankToAwaitStore: 'Apakah Anda pasti akan menambahkan papan yang dipilih ke perpustakaan untuk diketik?',
    pushStoreSuccess: 'Berhasil memasuki gudang',
    dataGenErr: 'Kesalahan pembuatan data',
    unknownErr: 'Terjadi kesalahan yang tidak diketahui dan gagal memasuki database'
    },
  surplusPage: {
    surplusMaterial: 'Daftar bahan yang tersisa',
    surplusStore: 'Gudang bahan yang tersisa',
    recycleBin: 'Tempat sampah bahan yang tersisa',
    recycleBinTip: 'Data material sisa di recycle bin akan dihapus otomatis setelah lebih dari 90 hari',
    "deleteReason-0": 'Penghapusan manual',
    "deleteReason-1": 'Pengurangan karena typesetting',
    "deleteReason-2": 'Pengeluaran melalui operasi seluler Guigui',
    surplusShape: 'Bentuk bahan yang tersisa',
    batchTransfer: 'Transfer batch',
    createNewSurplusStore: 'Gudang Bahan Surplus Baru',
    pushStoreSetting: 'Pengaturan penyimpanan material yang tersisa',
    surplusStoreName: 'Nama silo',
    surplusStoreName2: 'Nama Gudang Bahan Surplus',
    addSurplusStore: 'Tambahkan sisa gudang material',
    inventoryCeiling: 'Tutup stok',
    autoTransferTip: 'Setelah dihapus, bahan residu di gudang bahan residu akan secara otomatis ditransfer ke daftar bahan residu.',
    asIndexPushStore: 'Masukkan gudang agar penyimpanan',
    pushToSurplusMaterial: 'Simpan daftar materi yang tersisa',
    surplusStoreTable: {
      number: 'nomor seri',
      name: 'Nama Gudang Bahan Surplus',
      quantity: 'Jumlah bahan yang tersisa (potongan)',
      capacity: 'Batas atas inventaris material yang tersisa (potongan)',
      rules: 'Aturan penyimpanan material yang tersisa',
      remark: 'Komentar',
      operation: 'beroperasi'
      },
    editSurplusStore: 'Edit Perpustakaan Surplus',
    addSurplus: 'Tambahkan bahan yang tersisa',
    importSurplus: 'Impor bahan yang tersisa',
    downloadSurplusTemplate: 'Unduh template bahan residu',
    batchExportSurplus: 'Ekspor daftar bahan residu saat ini',
    surplusBatchImportExport: 'Impor/ekspor bahan residu secara batch',
    surplusMaterialStorageCode: 'Kode Penyimpanan Bahan Sisa',
    generateQRCodeSuccess: 'Kode QR berhasil dibuat',
    generateQRCodeFailed: 'Gagal membuat kode QR',
    refreshQRCode: 'Segarkan Kode QR',
    refreshQRCodeFailed: 'Gagal menyegarkan kode QR',
    cancelRefresh: 'Pembaruan dibatalkan',
    refreshQRCodeTip: 'Apakah Anda yakin ingin menyegarkan kode QR? Kode QR saat ini akan menjadi tidak valid setelah disegarkan.',
    refreshQRCodeConfirm: 'Konfirmasi',
    refreshQRCodeCancel: 'Batal',
    wechatScanTip: 'Buka WeChat untuk memindai QR code untuk menambahkan bahan sisa secara manual',
    deletSurplus: 'Hapus bahan yang tersisa',
    editSurplus: 'Ubah bahan yang tersisa',
    surplusNoRoll: 'Aktifkan bahan residu tanpa mencetak ulang',
    type: {
      all: 'Semua bentuk'
      },
    allMatcode: 'Semua bahan',
    allThick: 'Semua ketebalan',
    surplusName: 'Nama bahan yang tersisa',
    rectSurplus: 'Bahan residu persegi panjang',
    LTypeSurplus: 'Bahan residu berbentuk L.',
    noMatchSup: 'Tidak ada data yang relevan yang ditemukan',
    jumpTo: 'Melompat ke',
    page: 'Halaman',
    newMatcode: 'Bahan bangunan baru',
    newColor: 'Buat Warna Baru',
    autoCreateColor: 'Tekan Enter untuk secara otomatis membuat kartu warna',
    nameLimit: 'Masukkan hingga 10 kata dengan nama materi yang tersisa',
    nameLimitNameErr: 'Nama materi yang tersisa tidak bisa kosong',
    tempLongTip: 'Hanya angka yang dapat dimasukkan dalam panjang papan',
    minLongLimit: 'Hanya angka yang dapat dimasukkan dalam panjang sisi pendek',
    minLongEmptyTip: 'Panjang sisi pendek tidak bisa kosong',
    minLongLimitMax: 'Panjang sisi pendek tidak dapat melebihi panjang papan',
    widthLimit: 'Hanya angka yang dapat dimasukkan dalam lebar papan',
    minWidthLimit: 'Hanya angka yang dapat dimasukkan dalam lebar sisi pendek',
    minWidthEmptyLimit: 'Lebar sisi pendek tidak bisa kosong',
    minWidthLimitMax: 'Lebar sisi pendek tidak dapat melebihi lebar papan',
    thickLimit: 'Hanya angka yang dapat dimasukkan dalam ketebalan papan',
    thickEmptyLimit: 'Ketebalan pelat tidak bisa kosong',
    countInputLimit: 'Jumlahnya hanya bisa menjadi bilangan bulat positif',
    countEmptyLimit: 'Kuantitasnya tidak bisa kosong',
    remarkMaxlimit: 'Masukkan hingga 50 kata dalam catatan',
    orderAddressMaxlimit: 'Masukkan hingga 100 kata dari alamat pesanan sumber',
    orderIdMaxlimit: 'Masukkan hingga 100 kata dari nomor pesanan sumber',
    createTime: 'Tambahkan waktu',
    deleteTime: 'Hapus Waktu',
    deleteReason: 'Alasan Penghapusan',
    branchName: 'Gudang bahan yang tersisa',
    orderAddress: 'Alamat Pesanan Sumber',
    orderId: 'Nomor pesanan sumber',
    lockStatus: 'Keadaan terkunci',
    lockOrder: 'Pesanan kunci',
    enableSurplusLock: 'Aktifkan fungsi penguncian bahan residu',
    isCloseSurplusLock: 'Setelah fungsi dimatikan, semua bahan residu akan dibuka. Apakah akan melanjutkan',
    confirm: 'Konfirmasi untuk menutup',
    surplusTransfer: 'Transfer materi yang tersisa',
    targetSurplusStore: 'Gudang bahan residual target',
    enableSurLockTip: 'Setelah menyala, setiap tata letak akan mengunci bahan yang tersisa yang digunakan untuk mencegah pesanan lain dari menempati.',
    addMainRule: 'Tambah Aturan Utama',
    surplusRules: 'Aturan Penyimpanan Sisa Bahan ',
    mainRulesTip: 'Aturan utama adalah hubungan atau, yaitu jika hanya memenuhi satu aturan utama, sisa akan disimpan',
    mainRulesTip1: 'Setelah menambahkan aturan, sisa yang memenuhi aturan akan disimpan terlebih dahulu di gudang tersebut, dan setelah gudang tersebut penuh, akan disimpan di gudang sisa lainnya yang kosong',
    rule: 'Aturan',
    addSubRule: 'Tambah Aturan Sub',
    subRuleTip: 'Aturan sub adalah hubungan dan, yaitu harus memenuhi semua aturan sub di bawah aturan utama, baru akan disimpan',
    bigPlankMatCode: 'Kode Material Plat Besar',
    bigPlankThick: 'Ketebalan Plat Besar',
    bigPlankColor: 'Warna Plat Besar ',
    greaterEqual: 'Lebih dari atau sama dengan ',
    lessEqual: ' Kurang dari atau sama dengan ',
    capNumberCheck: 'Batas Stok Hanya Boleh Diisi dengan Angka Bulat! ',
    capEmptyCheck: 'Batas Stok Tidak Boleh Kosong!',
    surNameEmptyCheck: 'Nama Gudang Sisa Tidak Boleh Kosong!',
    mainRuleLimit: 'Batas Aturan Utama Telah Tercapai ',
    delMainRuleTip: 'Apakah menghapus aturan utama ini?',
    matCodeEmptyCheck: 'Kode Material Plat Besar Tidak Boleh Kosong!',
    thickEmptyCheck: 'Ketebalan Plat Besar Tidak Boleh Kosong!',
    textureEmptyCheck: 'Warna Plat Besar Tidak Boleh Kosong! ',
    enableWarehouseSecondCon: 'Aktifkan Konfirmasi Pendukung Penyimpanan Sisa',
    surplusWarehouseConfirm: 'Konfirmasi Penyimpanan Sisa',
    surplusWarehouseConfirm1: 'Konfirmasi Penyimpanan',
    closeSurplusConfirm: 'Tutup Konfirmasi Penyimpanan (Dapat diaktifkan kembali di pengaturan halaman penyimpanan sisa)',
    position: 'Posisi Penyimpanan ',
    nameRepeatTip: 'Sudah ada nama sisa saat ini, silakan ubah dan lakukan penyimpanan ulang ',
    surLimitTip: 'Gudang sisa saat ini telah mencapai batas atau tidak memenuhi aturan penyimpanan ',
    surFailTip: 'Penyimpanan gagal, ada nama sisa yang berulang atau gudang sisa telah mencapai batas atau tidak memenuhi aturan penyimpanan',
    surplusExistTip: 'Beberapa bahan residu telah disimpan, operasi ini gagal',
    surplusExistTip2: 'Bahan residu saat ini telah disimpan, operasi ini gagal',
    currentPage: 'Halaman Saat Ini',
    totalPage: 'Pilih Semua'
    },
  printPage: {
    goto: 'Pergi sekarang',
    surplusSizeTittle: 'Peringatan Ukuran Sisa Terlalu Kecil',
    surplusSizeErrTip: 'Ukuran sisa terlalu kecil, silakan pergi ke jalur produksi yang sesuai untuk mengatur ukuran minimum sisa!',
    opacityTip: 'Didukung secara teknis oleh EZsort',
    opacityTip2: 'Akun saat ini belum membeli Smart Color Label; jika sudah membeli, harap hubungkan akun kabinet di perangkat lunak Color Label',
    loadFontTip: 'Memuat file sumber font yang diperlukan, silakan tunggu',
    leftAlign: 'Kiri cetak',
    rightAlign: 'Kanan cetak',
    topAlign: 'Atas cetak',
    bottomAlign: 'Bawah cetak',
    horizontalAlign: 'Cetak horisontal tengah',
    verticalAlign: 'Cetak vertikal tengah',
    horizontalSplit: 'Pembagian horisontal sama rata',
    verticalSplit: 'Pembagian vertikal sama rata',
    norTag: 'Tag asli biasa',
    surTag: 'Tag bahan residu',
    genTag: 'Menghasilkan tag',
    all: 'Pilih semua',
    deleteWarning: 'Tips yang baik',
    print: 'Mencetak',
    defaultTemplate: 'Template default (60 x 40)',
    editTemplate: 'Edit Template',
    deleteTip: 'Itu tidak dapat dipulihkan setelah menghapus template. Apakah Anda pasti akan menghapus template?',
    tagSetting: 'Pengaturan Tag',
    rememberSetting: 'Setelah modifikasi, pengaturan akan diingat',
    genCutingTag: 'Hasilkan label kliping',
    genSurplusTag: 'Menghasilkan label bahan residu',
    genPlankTag: 'Menghasilkan label papan besar',
    genPartTag: 'Menghasilkan tag papan kecil',
    genNoCutTag: 'Menghasilkan tag papan tidak memotong',
    tagPosition: 'Lokasi Pelabelan',
    tagPositionTip: '(Mesin pelabelan perlu mengisi koordinat x/y di bawah)',
    Xposition: 'X Koordinat',
    Yposition: 'Koordinat y',
    genPlankSuffix: 'Label papan besar menghasilkan akhiran nama file',
    arrangeMirror: 'Tag Image Mirror',
    drillPlankBase: 'Pengeboran lima sisi dan referensi pelat',
    drillPlankBaseTip: 'Gagal mengambil data dasar untuk peletakan papan. Silakan coba lagi nanti!',
    suitAuto: 'Penyortiran tag beradaptasi dengan pemuatan dan pembongkaran otomatis:',
    colorLabel: 'Menghasilkan tag warna',
    colorRevert: 'Membuat tag warna refleks panel kecil',
    displayEnAndZh: 'Tampilkan nama ruang/kabinet/panel dalam bahasa Inggris dan Cina',
    displayEnAndZhTip: 'Hanya mendukung nama ruang/kabinet/panel default. Fitur ini tidak akan berfungsi setelah diubah ke nama kustom',
    up: 'ke atas',
    down: 'turun',
    default: 'bawaan',
    printSetting: 'Pengaturan cetak',
    oneToMore: 'Beberapa halaman per gambar',
    perPage: 'Setiap',
    coloumn: 'Daftar',
    tagMargin: 'Label Gap',
    coloumnMargin: 'Jarak kolom',
    specialMark: 'Tanda khusus',
    opacity: 'transparansi',
    opacityTip3: 'BMP format images need to select true color to support transparency',
    suite: 'Adaptif',
    svgListTip: 'Tag papan generasi tidak diaktifkan, silakan periksa di sebelah kiri',
    size: 'ukuran',
    lightSide: 'Tepi cahaya',
    locFrontSide: 'Depan kabinet',
    openSide: 'Arah pembukaan pintu',
    extraTip: 'Kiat: Saat Anda menggunakan pencetakan langsung untuk pertama kalinya, silakan tambahkan selembar kertas dengan ukuran dan panjang dan lebar yang sama seperti yang digunakan dalam pengaturan printer, dan kemudian gunakan kertas baru untuk dicetak (Contoh: Ukuran kertas asli 60 × 40, ukuran kertas baru 40 × 60)',
    noMore: 'Tidak lebih',
    prepareData: 'Siapkan data ...',
    genTagFile: 'Saat pembuatan tag sedang dihasilkan, tolong jangan lakukan switching halaman, meminimalkan browser, menggulir tag ke atas dan ke bawah, dll.!',
    waitGen: 'Harap tunggu tag dimuat sebelum mengunduh',
    tempLoading: 'Template tag sedang dimuat, harap tunggu',
    front: 'maju',
    open: 'membuka',
    toEdit: 'Pergi ke Edit',
    simplifyOneCodeTip: 'Catatan: Atribut barcode yang ditetapkan oleh template tag ini tidak mendukung penggunaan fungsi "barcode sederhana". Harap Ubah Atribut Barcode (Atribut Barcode yang Disarankan: Code128)',
    plankTemp: 'Template label papan kecil',
    surplusTemp: 'Template label material yang tersisa',
    enableSubTag: 'Aktifkan label sekunder',
    enableSubTagTip: 'Anda dapat mengatur di Pengaturan Lainnya > Pengaturan label sekunder papan kecil > Atur sumber data efektif untuk pembuatan label sekunder. Setelah diaktifkan, label sekunder hanya dibuat jika sumber data yang diatur memiliki nilai pada label sekunder; jika tidak, tidak akan dibuat.',
    goSet: 'Pergi ke pengaturan',
    mainTag: 'Label utama papan kecil',
    subTag: 'Label sekunder papan kecil',
    downloadSubTagTip: 'Label yang diekspor memiliki label sekunder. Jalur produksi pelabelan otomatis sementara tidak dapat menghasilkan label sekunder. Lanjutkan output?',
    embeddedSubTagTip: 'Fungsi label sekunder tidak didukung. Silakan buka layout awan web untuk menggunakan fungsi tersebut.',
    subTagPerSaveTip: 'Izin label sekunder telah kadaluarsa. Silakan tutup label sekunder dan simpan kembali.',
    subTagPerexportTip: 'Label sekunder yang dibayar termasuk dalam file produksi. Fitur ini telah kadaluarsa dan perlu ditutup dan dikeluarkan kembali.',
    tempNamePlaceHolder: 'Harap masukkan nama template',
    editTip: 'Anda dapat menyelesaikan pengeditan template label dengan menyeret tombol kiri ke kertas label kanan sesuai dengan kebutuhan Anda',
    oneCode: 'Barcode',
    image: 'gambar',
    arrow: 'panah',
    editPage: {
      digitLimitation: 'Batasan digit',
      title: 'Pengeditan Tag Template',
      reset: 'Kembalikan default',
      exit: 'EXIT EDIT',
      tagInfo: 'Informasi tag',
      tagName: 'Nama tag',
      tagSize: 'Ukuran label',
      tagData: 'Tag data',
      dragTip: 'Tahan tombol kiri mouse untuk menyeret keluar label data',
      dataTip: 'Pilih informasi data di bilah properti di sebelah kanan',
      text: 'teks',
      dataSource: 'Informasi data',
      graph: 'Grafik',
      typograpyPic: 'Penyusunan huruf',
      barCode: 'Barcode',
      QRCode: 'Kode QR',
      plankMark: 'Tanda pelat',
      holeSlotPic: 'Diagram slot lubang',
      edgeBandPic: 'Diagram tepi',
      visibleEdgePic: 'Tepi terlihat',
      holeSlotPicZoom: 'Zoom Diagram Slot Lubang',
      rotateDeg: 'Sudut rotasi',
      colorDeep: 'Kedalaman warna',
      surplusMark: 'Tanda materi yang tersisa',
      surplusSizePic: 'Diagram ukuran bahan yang tersisa',
      dataSize: 'Ukuran data',
      extraList: 'Daftar tambahan',
      QRCodeFormat: 'Format Kode QR',
      formatQR: 'Format QR',
      formatDM: 'Format DM',
      locIndex: 'Nomor Seri Kabinet',
      plankFrontSign: 'Penanda panel',
      genNCSuffix: 'Menghasilkan akhiran NC',
      table: 'lembaran',
      inputPlaceholder: 'Harap klik dua kali untuk memasukkan teks',
      attribute: 'milik',
      fontFamily: 'Jenis font',
      fontSize: 'Ukuran font',
      fontWeight: 'Font yang lebih tebal',
      flipOverProcessing: 'Pemrosesan sisi balik',
      showSideMachiningSequenceDiagramBorder: 'Tampilkan batas diagram urutan pemrosesan sisi',
      showSideMachiningSequenceNumber: 'Tampilkan nomor urutan pemrosesan sisi',
      autoRow: 'Bungkus garis otomatis',
      rowMargin: 'Jarak garis',
      autoFontSize: 'Ubah Ulang Font Ubah Ulang Secara Otomatis',
      statisticsDimension: 'Dimensi statistik',
      noLimit: 'Tidak ada batasan',
      sameOrderNo: 'Pesanan yang sama',
      sameRoom: 'Kamar yang sama',
      sameWardrobe: 'Kabinet yang sama',
      alignWay: 'Penyelarasan',
      JustifyLeft: 'Sejajarkan kiri',
      JustifyRight: 'Sejajar dengan benar',
      JustifyCenter: 'Pusat Align',
      otherOpration: 'Operasi Lainnya',
      attributeReset: 'Parameter Reset',
      barCodeSize: 'Ukuran barcode',
      installPic: 'Diagram instalasi',
      plankCode2: 'Papan Barcode (Nomark)',
      frontCode: 'Kode mie positif',
      backCode: 'Kode mie terbalik',
      orderRemark: 'Catatan pesanan',
      NCFileName: 'Memotong nama file',
      NCFileNameTip: 'Jangan termasuk Cina dalam nama file dan panjang tidak boleh melebihi 10 digit.',
      showOpenSide: 'Tunjukkan arah pembukaan pintu',
      limitFixed: 'Batasi jumlah titik desimal',
      showFrontHS: 'Tampilkan slot wajah depan',
      showBackHS: 'Tunjukkan slot wajah terbalik',
      showPartEdge: 'Tampilkan viền cạnh tấm',
      showPlankSize: 'Ukuran panel tampilan',
      tempNamePlaceholder: 'Harap masukkan nama tag',
      deleteAreaTip: 'Pilih blok yang akan dihapus',
      suitShunt: 'Pengaturan shunt yang cocok',
      suitShuntTip: 'Setelah memilih, bagian lubang yang tidak memiliki proses berikutnya setelah分流 tidak akan menghasilkan barcode',
      noHoleSlot: 'Tidak ada slot lubang juga menampilkan barcode',
      rotate: 'Barcode berputar',
      barcodeAtrribute: 'Atribut Barcode',
      imgSize: 'Ukuran gambar',
      graphStyle: 'Grafik Style',
      noEdgeDisplay: 'Tepi adalah 0 dan tidak akan ditampilkan',
      allEdgeNoDisplay: 'Pemblokiran tepi tidak ditampilkan',
      isShowDiffEdgeColor: 'Tampilkan warna tepi yang berbeda',
      hideSameEdgeColorAsPlank: 'Sembunyikan warna tepi saat sama dengan warna papan',
      hideSameEdgeColorAsPlankTip: 'Tata letak awan tertanam belum didukung',
      imgRotate: 'Rotasi Gambar',
      circleD: 'Diameter bingkai lingkaran',
      roomNo: 'Nomor kamar',
      roomOrder: 'Nomor kabinet (diurutkan berdasarkan kamar)',
      alphabetically: 'Urutkan berdasarkan huruf',
      numberOrder: 'Urutkan berdasarkan nomor',
      specialMarkup: 'Simbol tanda khusus',
      smallPlateMarking: 'Tanda papan kecil',
      arrow: 'Panah',
      triangle: 'Segitiga',
      sixSideDrillPlankBase: 'Dasar pemposisi bor enam sisi',
      boldSettingTip: 'PDF bold font is not supported',
      frontEdge: 'Tampilkan depan kabinet',
      visibleEdge: 'Tampilkan pinggir terlihat',
      lineCount: 'Jumlah karakter per baris'
      },
    autoSaveToHistory: 'Secara otomatis disimpan ke sejarah!',
    firstPrintTip: 'Saat Anda menggunakan pencetakan langsung untuk pertama kalinya, tambahkan selembar kertas dengan ukuran dan panjang dan lebar yang sama seperti yang digunakan dalam pengaturan printer, dan kemudian cetak dengan kertas baru.',
    tagDownloading: 'Tag sedang diunduh ...',
    cutLaveEnd: 'Nama label untuk setiap lembar besar dibuat di belakang setiap lembar besar',
    deleteTemplate: 'Hapus Template',
    copyTemplateRenderUrl: 'Salin Tautan Template',
    noPermission: 'Template yang diimpor telah menutup fitur berikut tanpa izin',
    moreOperation: 'Operasi Lebih Banyak',
    importTemplate: 'Impor Template',
    importTemplateLink: 'Salin tautan template ke kotak input di bawah ini, dan template dapat diimpor',
    importTemplateLinkPlaceholder: 'Silakan masukkan tautan template',
    noDeleteTemplate: 'Template default tidak dapat dihapus',
    tip1: 'Template saat ini tidak memiliki tautan salin',
    tip2: 'Tautan data template saat ini telah disalin.',
    tip3: 'Gagal menyalin tautan template, silakan coba lagi nanti',
    tip4: 'Tautan template impor tidak dapat dikenali. Silakan unduh ulang lalu impor.'
    },
  fileManagerPage: {
    folderClassifyByTextureColorThickSize: 'Klasifikasikan ke dalam folder yang berbeda berdasarkan material, warna, ketebalan, dan ukuran papan besar (termasuk file pelabelan)',
    notOpeFolderPermission: 'Operasi Direktori ini yang tidak sah',
    notFindFolder: 'Direktori ini tidak dapat dideteksi pada klien saat ini',
    productLineUniversal: 'Semua jalur produksi bersifat universal',
    effectCondition: 'Pengaturan ini perlu diperbaiki sebelum dapat berlaku setelah mengubahnya',
    addPath: 'Tambahkan jalur',
    downloadPositionChangeByType: 'Lokasi unduhan file yang dihasilkan telah diubah menjadi {type}',
    isDeleteFolder: 'Apakah Anda pasti akan menghapus lokasi penyimpanan file yang digunakan?',
    netWorkIsNotSafe: 'Lingkungan jaringan Anda tampaknya tidak aman dan kami tidak dapat mengaktifkan fitur ini, Anda dapat memberi umpan balik kepada kami',
    NotSupportBrowse: 'Browser Anda belum mendukung fitur ini. Silakan unduh versi terbaru <a href = "https://www.microsoft.com/zh-cn/edge/download" target = "_ blank"> edge </a> Untuk menggunakan browser',
    notSupportDisk: 'Direktori tingkat sistem tidak dapat dipilih, seperti [desktop] [C drive]',
    useFolderDownload: 'File produksi diunduh dalam bentuk dekompresi',
    downloadPosition: 'Unduh lokasi file',
    changeUseFolder: 'Mengubah',
    folderNameSetting: 'Pengaturan Folder',
    mainFolder: 'Folder Level 1',
    exportNameSetting: 'Ekspor memproses file untuk menyebutkan nama dengan nomor pesanan',
    fileMax: 'Nama file maksimum adalah',
    char: 'karakter',
    overTip: 'Bagian berlebih tidak akan ditampilkan (paket kompresi gambar tag dan file JSON akan mengikuti nama folder tingkat pertama)',
    example: 'Mencicipi',
    engravingFolder: 'Folder Mesin Ukiran',
    electronicSawFolder: 'Folder gergaji elektronik',
    labellingFolder: 'Folder Mesin Pelabelan',
    sideHoleDrillFolder: 'Folder mesin lubang samping',
    fiveDrillFolder: 'Folder bor lima sisi',
    sixDrillFolder: 'Folder bor enam sisi',
    PTPFolder: 'Folder PTP',
    labellingTagFolder: 'Folder gambar label',
    surplusFolder: 'Pengaturan file lembar besar sisa',
    surplusBigPlankSetting: 'File pemotongan lembar besar sisa/gambar label/file label ditempatkan secara terpisah',
    surplusBigPlankSettingTip: 'Setelah membuka, file NC sisa, gambar label dan file label akan ditempatkan dalam folder terpisah',
    folderMergeSetting: 'Pengaturan gabungan folder',
    folderMerge: 'Gabungan folder',
    mergeName: 'Gabungkan nama',
    subMergeFolder: 'Gabungkan menjadi subfolder dengan ketebalan warna material',
    subFolderName: 'Nama subfolder',
    splitChar: 'Karakter pemisahan',
    splitTip: '(Karakter input seperti /:? <> . ” * Tidak didukung)',
    folderAutoAdd: 'Jumlah folder ditingkatkan dengan nilai awal',
    resetTip: '(Setel ulang ke nilai awal setiap hari)',
    emptyErrTip: 'Informasi tidak bisa kosong',
    repeatErrTip: 'Nama file duplikat',
    mergeDataTip: 'Warna, ketebalan, panjang dan lebar bahan papan atau jumlah file harus ditingkatkan secara otomatis.',
    engravingFileSetting: 'Pengaturan File Mesin Ukir',
    engravingSplitZF: 'Tempatkan file positif / balik mesin ukir dengan folder yang berbeda',
    engravingSplitZFTip: 'Berlaku untuk mesin label otomatis satu dua tiga,',
    engravingSplitWorkstation: 'Mesin ukir berdasarkan posisi kerja',
    engravingSplitWorkstationTip: 'Catatan: Hanya didukung untuk mesin ukir dan mesin ukir sawing',
    holeFileSetting: 'Pengaturan file lubang',
    holeFileSingle: 'File punching ditempatkan secara terpisah dalam subfolder dalam urutan yang berbeda'
    },
  moreSettings: {
    generalSetting: 'Pengaturan Umum',
    outSyncTip: 'Hasilkan jendela pop-up saat Data Film Asli Tata Letak Cloud tidak disinkronkan dengan kabinet kabinet',
    secondarySwitchShow: 'Kandungan sekunder dari kontrol sakelar di pengaturan mesin ukiran masih ditampilkan setelah mematikan sakelar.',
    isFrameDoorTip: 'Menghasilkan pop-up prompt saat memproses pintu rangka',
    exPaibanTip: 'Menghasilkan pop-up prompt saat menggunakan tata letak sisa bahan tidak beraturan/penyusunan tidak beraturan',
    isDesMaterialNoCutTip: 'Untuk bahan papan kecil yang ditentukan yang tidak dipotong, ketika ada lubang, slot atau bentuk tidak beraturan yang ditugaskan ke mesin ukiran, jendela pop-up prompt akan dihasilkan',
    surpTagThresholdTextHalf1: 'Apabila luas sisa bahan (bukan sisa pemotongan) kurang dari',
    surpTagThresholdTextHalf2: 'Tidak menghasilkan label sisa',
    innerShapeToolMatch: 'Mesin ukiran memilih alat yang sesuai untuk memproses bentuk internal tidak rata',
    innerShapeToolMatchTip: '（Ketika mesin ukiran memproses bentuk internal yang lebih kecil dari diameter alat pemotong, ukuran kesalahan tidak dapat diproses. Fungsi ini dapat diaktifkan untuk memecahkan masalah）',
    innerShapeToolMatchTip2: 'Catatan: Setelah diaktifkan, mesin ukiran akan menggunakan pisau slot terkecil, silakan atur "panjang pisau" dan "kedalaman maksimum pemrosesan tunggal" pisau slot terkecil dengan hati-hati, hanya berlaku di pengaturan cloud',
    surNotLayout: 'Mendefinisikan sisa papan besar tanpa menyusun papan yang ditentukan',
    surNotLayoutTip: 'Setelah diaktifkan 1. Papan besar sisa tidak dapat menyusun papan kecil yang berisi nama di bawah ini 2. Anda dapat memilih apakah tipografi ini berfungsi saat tipografi',
    addPlank: 'Tambahkan Nama Papan',
    addPlankTip: 'Menambahkan setidaknya satu nama panel kecil',
    thisInput: 'Masukkan di sini',
    surNotLayoutMat: 'Sisa tidak menyusun papan kecil',
    subTagSetting: 'Pengaturan label sekunder papan kecil',
    subTagDataSource: 'Atur sumber data efektif untuk pembuatan label sekunder',
    subTagDataSourceTip: 'Setelah diaktifkan, Anda dapat menambahkan sumber data yang mengontrol pembuatan label sekunder. Label sekunder akan dibuat jika label sekunder memiliki sumber data tersebut dan sumber data memiliki nilai.',
    addSubTagDataSource: 'Tambah Sumber Data',
    addSubTagDataSourceTip: 'Sumber data duplikat tidak diizinkan',
    addSubTagDataSourceTip1: 'Silakan tambahkan setidaknya satu sumber data',
    addSubTagDataSourceTip2: 'Sumber data tidak boleh kosong, silakan pilih',
    reuseMatchingPlankName: 'Pencocokan kembali berdasarkan nama papan',
    reuseMatchingPlankNameTip1: 'Saat fitur ini dinonaktifkan, guna ulang tata letak mencocokkan panel dengan material, warna, ketebalan, dimensi, tekstur, dan properti kilau tinggi yang sama',
    reuseMatchingPlankNameTip2: 'Saat fitur ini diaktifkan, selain kondisi pencocokan di atas, pencocokan nama papan juga ditambahkan'
    },
  lineManager: {
    add: 'Tambahkan jalur produksi',
    engraving: 'Peralatan pemotongan',
    holeSlotEquip: 'Peralatan pemrosesan slot lubang',
    workSetting: 'Pengaturan pemrosesan',
    noUse: 'Tidak diaktifkan',
    warningTip: '* Catatan: Setelah mengatur fungsi -fungsi berikut, jangan simpan di halaman docking perangkat klien kabinet di masa depan untuk menghindari mengatur ulang parameter!',
    engravingSetting: 'Pengaturan mesin pemotong',
    workWay: 'Metode pemrosesan',
    cutedSpecial: 'Slot lubang khusus untuk diproses:',
    noWork: 'Opsi ini tidak berlaku pada template default bor lima/enam sisi.',
    onlyCut: 'Potong saja',
    onlyFrontHoleSlot: 'Hanya alur wajah depan piring',
    onlyHoleSlot: 'Hanya alur wajah depan dan belakang dari bagian pelat',
    sideHoleSetting: 'Pengaturan mesin lubang samping',
    cutHoleSlot: 'Alur lubang olahan',
    minSize: 'Ukuran sisi pendek',
    maxSize: 'Ukuran sisi panjang',
    minSize2: 'Semua slot lubang dan bagian berbentuk khusus di pelat mm',
    minSize3: 'Dan bagian Alien',
    onlyFrontHoleSlotTip: 'Hanya alur wajah depan piring',
    onlyFrontHoleSlotTip2: 'Tidak termasuk slot lubang samping',
    holeAndSlot: 'Lubang dan slot',
    empty: 'Kosong',
    singleHole: 'Lubang tunggal',
    singleSlot: 'Slot tunggal',
    diameterRange: 'Rentang Diameter Lubang',
    hDeepRange: 'Kisaran kedalaman lubang',
    widthRange: 'Kisaran lebar slot',
    sDeepRange: 'Kisaran kedalaman alur',
    to: 'tiba',
    specialHS: 'Slot lubang khusus dan bentuk khusus',
    allowRoll: 'Memungkinkan mesin pemotong untuk mencetak ulang dan memproses alur lubang khusus',
    engravingPath: 'Memproses bagian pelat pada mesin pemotong',
    curve_range: 'Sisi panjang bagian berbentuk khusus lebih besar dari',
    curve_range2: 'semua bagian berbentuk khusus dari papan',
    curveArea: 'Luas bentuk aneh',
    drillSetting: 'Pengaturan bor lima sisi',
    engravingCuted: 'Slot lubang yang diproses pada mesin pemotong dibor di sisi kelima/keenam',
    engravingCutedSpecial: 'Bagian khusus yang diproses pada mesin pemotong dibor di sisi kelima/keenam',
    genCuttingPath: 'Menghasilkan data pemotongan',
    otherCuted: 'Lubang dan slot yang diproses oleh peralatan lain pada bor lima/enam sisi',
    noGen: 'Tidak dihasilkan',
    genCut: 'Menghasilkan dan memproses',
    genNoCut: 'Menghasilkan tetapi tidak diproses',
    cutTip: 'Catatan: Opsi ini hanya efektif untuk file bor lima dan enam sisi khusus',
    maxShortSize: 'Ukuran sisi pendek maksimum',
    maxLongSize: 'Ukuran sisi panjang maksimum',
    normalSlot: 'Slot normal',
    specialSlot: 'Slot khusus',
    combinSetting: 'Pengaturan Perangkat Kombinasi',
    allowShortSize: 'Izinkan ukuran sisi pendek',
    equipment1: 'Peralatan satu',
    equipment2: 'Peralatan 2',
    noSameTip: 'Catatan: Hal yang sama tidak dapat dipilih untuk kedua perangkat.',
    workRange: 'Rentang slot lubang mesin peralatan',
    rangeWarning: 'Catatan: Hanya rentang pemrosesan peralatan yang dapat ditetapkan, dan semua rentang pemrosesan peralatan yang akan diproses pada peralatan dua. Harap beroperasi dengan hati -hati!',
    deleteWarning: 'Setelah menghapus jalur produksi, itu tidak dapat dipulihkan (semua pengaturan di bawah jalur produksi akan dihapus). Apakah Anda pasti akan menghapus jalur produksi?',
    top: 'atas',
    inputCheck: '{msg} nilai minimum tidak boleh lebih besar dari nilai maksimum',
    lockTip: 'Jalur produksi terkunci, operasi dilarang!',
    reNameTip: 'Nama jalur produksi default tidak dapat dimodifikasi',
    permissonTip: 'Informasi identitas telah kedaluwarsa, buka halaman ini dari kabinet lagi!',
    permissonErr: 'Belum ada izin seperti itu, silakan tingkatkan versi akun!',
    permissionOneMacErr: 'Jumlah lini produksi all-in-one yang dapat Anda gunakan adalah {idx}. Jika Anda perlu menambahkannya, silakan hubungi tenaga penjualan!',
    permissionSawErr: 'Tidak ada izin pemotongan mesin ukir, silakan hubungi layanan purna jual untuk membeli paket tambahan pemotongan elektronik!',
    getAuthError: 'Gagal mendapatkan izin perangkat!',
    sawAddNumber: 'Jumlah lini produksi gergaji elektronik yang tersedia telah habis. Jika perlu menambah, silakan hubungi penjualan!',
    newLine: 'Buat jalur produksi baru {idx}',
    deleteCheck: 'Tidak bisa menghapus semua',
    deving: 'Dalam pengembangan',
    combinTip: 'Silakan klik yang berikut untuk menggabungkan pengaturan perangkat untuk mengatur',
    noUseEquip: 'Pemrosesan peralatan tidak diaktifkan',
    equipmentSelectTip: 'Ketika mesin pemotong dipilih untuk peralatan gabungan, mesin pemotong tidak dapat memilih gergaji elektronik.',
    lineLoading: 'Data sedang memuat',
    strenchType: 'Jenis slot pelurus',
    aioProcessTip: 'Anda telah mengaktifkan perangkat "all-in-one", dan metode pemrosesan adalah memproses alur wajah depan dan belakang dari bagian pelat secara default',
    aioProcessTip2: 'Alur lubang khusus yang diproses di mesin ukiran setelah mesin all-in-one diaktifkan',
    aioProcessTip3: 'Catatan: Fungsi ini tidak kompatibel dengan mesin ukiran yang memungkinkan pertukaran sumbu XY. Harap gunakan dengan hati -hati.',
    specialHoleTip: 'CATATAN: Saat menggunakan fungsi di atas dari "slot lubang khusus yang diproses", silakan atur "melalui metode pukulan lubang" dan "melalui metode meninju slot" untuk ditinju pada satu waktu.',
    specialHoleTip2: 'Catatan: Saat menggunakan fungsi "slot lubang khusus yang diproses di atas, silakan atur mesin ukiran" melalui metode pengeboran lubang "dan" melalui metode pengeboran alur "untuk ditinju pada satu waktu.',
    fiveSixNotTake: 'Opsi ini tidak berlaku pada template default bor lima/enam sisi.',
    onlyFrontSide: 'Proses hanya depan',
    onlyBackSide: 'Memproses sisi terbalik saja',
    less: 'Kurang dari',
    equal: 'setara',
    greater: 'Lebih besar dari',
    or: 'atau',
    and: 'Dan',
    bothFrontBack: 'Memproses bagian depan dan sebaliknya',
    shareDataErrTip: 'Bagian data ini diterapkan oleh {OperatorPhone}, IP: {actip}',
    restoreParams: 'Pulihkan parameter',
    loadMore: 'Memuat lebih banyak',
    currentCombinationEquipment: 'Peralatan kombinasi yang dipilih saat ini tidak mengizinkan peralatan pemotong beralih ke mesin pemotong kaca',
    selectEquipmentType: 'Silakan pilih jenis peralatan',
    ruleRemark: 'Catatan aturan',
    remarkPlaceholder: 'Ini adalah informasi catatan, dapat menulis catatan aturan ini untuk memproses teknologi apa, agar tidak lupa',
    onlyNoSideHoleSlotSmallPlank: 'Hanya papan kecil tanpa lubang/slot samping'
    },
  cuttingDock: {
    title: 'Memotong docking',
    autoStockCode: 'Kode pemuatan dan pembongkaran otomatis',
    stationStart: 'Workstation dimulai',
    stationStartCode1: 'Workstation 1 Mulai Kode',
    stationStartCode1Placeholder: 'Masukkan Kode Mulai Workstation 1',
    stationStartCode2: 'Workstation 2 Mulai Kode',
    stationStartCode2Placeholder: 'Masukkan Kode Mulai Workstation 2',
    stationEnd: 'Workstation berakhir',
    stationEndCode1: 'Workstation 1 Kode Akhir',
    stationEndCode1Placeholder: 'Masukkan Kode Akhir Workstation 1',
    stationEndCode2: 'Workstation 2 Kode Akhir',
    stationEndCode2Placeholder: 'Masukkan Kode Akhir Workstation 2',
    frontBackStart: 'Mulailah di depan dan belakang',
    frontBackEnd: 'Ujung depan dan belakang',
    frontStartCode: 'Kode Mulai Depan',
    frontStartCodePlaceholder: 'Masukkan kode start depan',
    frontEndCode: 'Kode ujung depan',
    frontEndCodePlaceholder: 'Masukkan kode ujung depan',
    backStartCode: 'Kode Mulai Terbalik',
    backStartCodePlaceholder: 'Masukkan kode start terbalik',
    backEndCode: 'Kode akhir terbalik',
    backEndCodePlaceholder: 'Masukkan kode akhir terbalik',
    plankStart: 'Piring dihidupkan',
    plankEnd: 'Piring dibatalkan',
    plankRollCode1: 'Workstation 1 Kode Flip',
    plankRollCode1Placeholder: 'Masukkan stasiun kerja 1 kode flip',
    plankRollCode2: 'Workstation 2 Flip Code',
    plankRollCode2Placeholder: 'Masukkan stasiun kerja 2 kode flip',
    autoBaitingCode: 'Kode pelepasan otomatis',
    autoBaitingCode1: 'Kode pemotongan workstation 1',
    autoBaitingCode1Placeholder: 'Masukkan stasiun kerja 1 kode pemotongan',
    autoBaitingCode2: 'Kode pemotongan workstation 2',
    autoBaitingCode2Placeholder: 'Masukkan stasiun kerja 2 kode pelepasan',
    thickMarkPermission: 'Anda saat ini tidak memiliki izin penandaan ketebalan papan besar, silakan hubungi penjualan untuk membeli sebelum digunakan',
    thickMark: 'Marking tebal papan besar',
    preStartEquipment: 'Perangkat pra-awal',
    firstKnifePreCode: 'Kode pra-awal pisau pertama terlebih dahulu',
    secondKnifePreCode: 'Pisau kedua dan kode pra-awal pisau berikutnya adalah sebelumnya',
    rowInsert: 'Penyisipan baris',
    pumpPause: 'Jeda pompa vakum',
    pumpPauseTip: 'Catatan: Peralatan stasiun tunggal membutuhkan "kode pemuatan otomatis" yang sama dan "kode komentar frontal pemrosesan dua sisi" untuk mengisi stasiun 1 dan stasiun 2.',
    pumpPause2Tip: 'Catatan: Peralatan stasiun tunggal perlu mengisi stasiun 1 dan stasiun 2 dengan "kode suspensi pompa vakum" yang sama',
    pumpPauseCode1: 'Kode suspensi pompa vakum 1 workstation 1',
    pumpPauseCode1Placeholder: 'Silakan isi kode suspensi pompa vakum stasiun 1',
    pumpPauseCode2: 'Kode Suspensi Workstation 2 Vakum',
    pumpPauseCode2Placeholder: 'Harap isi kode suspensi pompa vakum stasiun 2',
    annotationCode1: 'Workstation 1 Kode Anotasi Frontal Pemrosesan Sisi Ganda',
    annotationCode1Tip: 'Cocok untuk peralatan dengan instruksi yang berbeda di bagian depan makan otomatis',
    annotationCode1Placeholder: 'Masukkan kode anotasi frontal pemrosesan dua sisi untuk workstation 1',
    annotationCode2: 'Kode anotasi frontal pemrosesan dua sisi pemrosesan',
    annotationCode2Placeholder: 'Masukkan kode anotasi depan untuk pemrosesan dua sisi workstation 2',
    upSpeedTip: 'Silakan isi kecepatan akselerasi dari tepi yang sama',
    cutThickTip: 'Harap isi ketebalan pemotongan tepi yang umum',
    sizeErrTip: 'Harap atur ukuran tata letak ekspor yang benar di mesin pelabelan!',
    offEdgeKnifeDiameter: 'Harap masukkan diameter alat pemangkasan',
    slowDownSpeedTip: 'Parameter input deselerasi sudut pemotongan salah',
    permissionErr: 'Versi gratis saat ini, tidak dapat disimpan',
    labellingTempErr: 'Pilih template mesin pelabelan',
    autoRollInputTip: 'Nyalakan tag untuk berputar secara otomatis, dan Anda harus memasukkan nilai yang valid',
    offlineTempFormat: 'Format file mesin pelabelan saat ini telah offline, harap konfirmasi',
    autoStockCode1: 'Stasiun 1 kode pemuatan otomatis',
    autoStockCode1PlaceHolder: 'Masukkan kode pemuatan workstation 1 otomatis',
    autoStockCode2PlaceHolder: 'Masukkan kode pemuatan otomatis workstation 2',
    autoStockCode2: 'Stasiun 2 kode pemuatan otomatis',
    pauseCode: 'Kode jeda',
    pauseCodePlaceHolder: 'Masukkan kode jeda',
    cuttingToolMaxDepthTip: 'Kedalaman pemotongan maksimum {errKey} pisau dalam perpustakaan pisau tidak boleh lebih besar dari panjang pisau',
    cuttingParams: {
      title: 'Parameter pemotongan',
      stationWidth: 'Lebar stasiun',
      stationWidthTip: 'Ketika menggunakan panel besar sisa, arah lebar hanya dapat disusun dalam rentang ukuran yang ditetapkan',
      holeSlotMainSide: 'Slot lubang permukaan terkonsentrasi',
      holeMainSide: 'Permukaan konsentrasi lubang',
      slotMainSide: 'Groove permukaan terkonsentrasi',
      workPriority: '(Fungsi Prioritas: Permukaan di mana slot berlubang terletak mengikuti slot yang tidak diperkuat pada pelat kecil> pelurus dan lubang cangkir engsel ditempatkan di belakang pelat besar untuk memproses> permukaan konsentrasi alur> permukaan konsentrasi lubang)',
      holeSlotSet: 'Pengaturan pemotongan slot berlubang',
      hingeRollWork: 'Lubang pelurus dan cangkir engsel ditempatkan di bagian belakang piring besar untuk diproses',
      followWork: 'Permukaan slot berlubang mengikuti slot yang tidak diperoleh pada pelat kecil.',
      autoMatchSide: 'Mendistribusikan alur wajah positif dan negatif secara proporsional',
      backHSRate: 'Proporsi slot wajah terbalik',
      matchTip: '(Pengaturan ini tidak akan berlaku ketika papan highlight, skema tata letak yang memungkinkan perhitungan bentuk, atau pencocokan pola)',
      specIalHoleAndSlotSurface: 'Pengaturan permukaan pemotongan khusus untuk slot dan lubang khusus',
      specialRuleTip: 'Tempat ini tidak boleh kosong',
      specialSlotsHoles: 'Jenis lubang dan slot',
      holeType: 'Jenis Lubang',
      specialRules: 'Aturan',
      normalHole: 'Lubang konvensional',
      normalSlot: 'Slot konvensional',
      holeDiam: 'Diameter lubang',
      slotLongSide: 'Sisi panjang slot',
      slotShortSide: 'Sisi pendek slot',
      FixedmachSurface: 'Permukaan pemrosesan tetap',
      deleteRuleTip: 'Apakah Anda ingin menghapus aturan ini?',
      blankFront: 'Sisi depan piringan besar',
      blankBack: 'Sisi belakang piringan besar',
      addRules: 'Tambahkan aturan',
      addRulesTip: 'Ketika beberapa aturan dipenuhi oleh piringan kecil yang sama, aturan dengan nomor urut efektif terawal berlaku. Anda dapat menyeret baris mana saja untuk mengubah urutan aturan.',
      highGlossSetting: 'Sorotan pengaturan papan',
      heighGlossFront: 'Saat mengetik, papan kecil memiliki permukaan gloss tinggi dan diatur di papan besar',
      highGlossPlankNoRotate: 'Papan gloss tidak diputar',
      highGlossAutoRoll: 'Hanya papan besar dengan lubang dan slot belakang yang membalik otomatis',
      highGlossAutoRollTip: "<span class='color-o-4'>(Setelah diaktifkan, hanya papan besar dengan lubang dan slot belakang yang akan membalik otomatis saat mengatur, menjadi papan satu sisi. Gunakan bersama dengan data nama file kustom \"Balik dan letakkan papan permukaan gloss tinggi\")</span>",
      customHighGlossReverse: 'Balik dan letakkan papan permukaan gloss tinggi',
      sideSlotPut: 'Tempatkan alur pelat tepi',
      optimize: 'Optimasi fungsional',
      sysDefault: 'Default Sistem',
      plankInSide: 'Di dalam piring besar',
      plankOutSide: 'Di luar piring besar',
      specialNotWork: 'Fungsi ini tidak berlaku pada piring berbentuk khusus',
      commonSide: 'Pemotongan tepi umum',
      commonSetting: 'Pengaturan tepi umum',
      plankThickRange: 'Ketebalan pelat kurang dari atau sama',
      useCommonSide: 'Gunakan pemotongan tepi yang umum',
      zeroTip: '(Kesenjangan tata letak perlu diubah secara manual menjadi 0. Saat memproses sampai tepi telah dipotong, angkat pisau untuk melewatkan tepi)',
      useTip: 'Setelah fungsi ini dihidupkan, pemotongan ke bawah tidak akan didukung, harap perhatikan!',
      commonSpeed: 'Percepatan tepi umum',
      highSpeed: 'Kecepatan penggilingan berkecepatan tinggi',
      min: 'menit',
      notWorkTip: '(Ketika pemrosesan pelat memenuhi pemotongan tepi yang umum, akselerasi tepi umum tidak akan berlaku)',
      changeStartPoint: 'Beralih dari titik awal stasiun ganda',
      changeStartPointTip: 'Setelah mengaktifkan sakelar titik awal stasiun ganda, tidak sesuai dengan fungsi pertukaran sumbu XY. Harap gunakan dengan hati -hati',
      flatOffset: 'Offset Pesawat Mesin',
      xRowChange: 'Penyelarasan referensi koordinat sumbu x',
      bigplankPointChange: 'Penyesuaian referensi koordinat terbalik dari pelat besar',
      reverseXRowChange: 'X Kontras koordinat',
      changebigplankPointTips: 'Setelah mengaktifkan fungsi ini, tidak kompatibel dengan fungsi "XY Axis Interchange, Dual-Station Start Start Switching". Harap gunakan dengan hati -hati',
      reverseYRowChange: 'Koordinat y',
      plankMirrorTip: 'Gunakan fungsi ini saat mirroring plate yang diproses pada pengumpan',
      notSameSize: 'Countertops stasiun ganda ukuran berbeda',
      maxSize1: 'Workstation satu ukuran maksimal',
      notSameSizeTip: '(Setelah mengaktifkan berbagai ukuran meja stasiun ganda, tidak sesuai dengan fungsi penggabungan file stasiun ganda, silakan gunakan dengan hati-hati)',
      maxSize2: 'Workstation 2 ukuran maksimum',
      autoSelectTip: '(Jika dua meja dari peralatan stasiun ganda berbeda dalam ukuran yang sama, fungsi ini akan dipilih secara otomatis untuk memproses pelat besar di stasiun yang sesuai)',
      bigFlatLimit: 'Stasiun besar hanya memproses pelat besar yang tidak dapat diproses oleh stasiun kecil:',
      surplusSetting: 'Pengaturan materi yang tersisa',
      surplusPosition: 'Penempatan bahan yang tersisa',
      cutHoleWay: 'Metode pemotongan dan meninju',
      knifeFlat: 'Tatap muka',
      flat: 'Mesa',
      plankFlat: 'Permukaan pelat besar',
      freeHeightZ: 'Z Tinggi Dalam Idle',
      relativeHeight: 'Relatif terhadap ketinggian permukaan atas pelat besar',
      cutDeepZ: 'Potong throughput z kedalaman',
      cutDeepH: 'Melalui metode pengeboran lubang',
      setDisableDoubleSidedThroughHole: 'Setel nonaktifkan pengeboran lubang tembus dua sisi',
      addHolesToRulesDisableDoubleSided: 'Setelah menambahkan lubang tembus yang sesuai (lubang yang menembus) ke aturan di bawah, membalik dua kali untuk mengebor tembus tidak akan berlaku',
      onceThrough: 'Meninju sekaligus',
      rollThrough: 'Balikkan wajah dua kali',
      cutDeepS: 'Cara menembus melalui alur',
      plankCutDirection: 'Arah pemotongan pelat kecil',
      clockDirSwitch: 'Pengaturan tepi umum',
      millHoleSlotDir: 'Pengaturan arah phay lubang/slot',
      millInternalCurveDir: 'Pengaturan arah profil dalam',
      sDirection: 'Searah jarum jam',
      nDirection: 'Berlawanan arah jarum jam',
      curveReplenish: 'Perintah interpolasi busur untuk memotong pelat busur',
      curveReplenishTip: 'Fungsi ini dapat digunakan saat gerigi muncul dalam pemotongan pelat melengkung',
      noGen: 'Tidak ada perintah wajah G17/G18/G19',
      arcInstruction: 'Awalan instruksi interpolasi busur',
      example: 'Contoh',
      arcExample: 'G17G03 X100 Y100',
      curveCutTip: 'Pemotongan busur diwakili oleh i dan j',
      coverRate: 'Laju tumpang tindih pemotongan selama alur penggilingan adalah:',
      roughTip: 'Gunakan fungsi ini saat ada gerombolan residual di dalam alur saat menggiling alur pahat',
      clearCurve: 'Secara otomatis membersihkan sudut bundar dari slot yang tidak ditarik selama penggilingan:',
      curveUseTip: 'Fungsi ini diperlukan untuk membersihkan sudut bundar saat menggiling slot. Harap dicatat bahwa fungsi ini tidak berlaku pada konektor.',
      slotCutWay: 'Metode perkakas slot penggilingan',
      outToIn: 'Slot penggilingan dari luar ke dalam',
      inToOut: 'Slot penggilingan dari dalam ke luar',
      zShapProcess: 'Slot penggilingan berbentuk Z atas dan ke bawah untuk slot melalui',
      zShapProcessTip: 'Hanya efektif untuk alur alur tarik-tarik depan dan belakang alur, laju tumpang tindih jalur pahat default ke jari-jari pahat',
      zSlotCuttingOverlapRate: 'Tingkat tumpang tindih dari pemotongan alur penggilingan berbentuk Z adalah',
      zSlotCuttingOverlapRateTip: 'Laju tumpang tindih pemotongan alur penggilingan berbentuk Z dapat menyebabkan kecepatan pemrosesan menjadi lebih lambat, silakan coba lagi setelah mesin dihidupkan.',
      slotWorkLimit: '(Hanya efektif ketika jumlah lapisan pemotongan alur penggilingan adalah> 1)',
      minKnifeChange: 'Pemotongan Reduksi Perubahan Pahat',
      preventBreakage: 'Pencegahan Patah Separator Slot Tepi',
      preventBreakageTip: 'Pengaturan ini hanya berlaku untuk slot di sisi depan saat layout, dan dapat digunakan bersama fungsi "Pengaturan permukaan pemotongan khusus untuk slot dan lubang khusus"',
      preventBreakageTip1: 'Dapat menyelesaikan situasi di mana slot terlalu dekat dengan tepi panel, dan separator bar (bagian sambungan yang tersisa) pada posisi ini akan mudah patah karena konsentrasi tegangan saat pemotongan',
      preventBreakageDistance: 'Jarak dari Tepi Panel',
      preventBreakageLength: 'Panjang Bagian Tepi',
      preventBreakageSlot: 'slot',
      preventBreakageCutDeep: 'Kedalaman Potongan Pertama',
      workSpeedOp: 'Kecepatan pemrosesan yang dioptimalkan',
      obliqueCut: 'Memotong ujung tombak',
      obliqueCutTip: 'Ketika ketebalan papan tidak ditentukan, efektif untuk semua ketebalan papan kecil',
      obliqueThickLabel: 'Ketebalan efektif pemotongan miring yang disesuaikan',
      obliqueThick: 'Ketebalan pemotongan miring yang disesuaikan',
      backObliqueThick: 'Ketebalan pemotongan miring yang disesuaikan',
      effectiveThickness: 'Ketebalan efektif',
      effectiveThicknessTip: 'Ketebalan efektif tidak boleh kosong, silakan masukkan!',
      effectiveThicknessDuplicateTip: 'Ketebalan efektif tidak boleh duplikat, silakan ubah',
      obliqueCutData: 'Jarak potong miring ke bawah',
      backOblique: 'Membalikkan pemangkasan secara diagonal diturunkan',
      obliqueSpeed: 'Kecepatan down-down',
      obliqueSpeedTip: 'Pemotongan dan pemangkasan sisi belakang',
      arcSpeed: 'Kecepatan pemesinan kurva',
      cuttingPreDistance: 'Keluar dari pisau sebelumnya',
      backKnife: 'Memotong pisau untuk mengurangi kecepatan',
      openKnifeSpeed: 'Kecepatan pengumpulan pisau',
      retractionCompensation: 'Kompensasi pengambilan pisau',
      retractionCompensationTip: 'Nilai maksimum 20',
      cutCornerSlow: 'Pengurangan sudut pemotongan',
      addRow: 'Baru',
      bettwenDistance: 'Jarak sebelum dan sesudah sudut',
      cuttingSpeed: 'Kecepatan pemotongan',
      stepCutting: 'Pemotongan berlapis',
      splitSlot: 'Potong alur dua kali',
      splitPlank: 'Potong papan kecil dua kali',
      splitPlank2: 'Potong papan kecil dua kali',
      minSafeThick: 'Ketebalan lebih besar dari',
      splitPlankTip: '（Papan tidak berbentuk khusus tidak berlaku untuk fungsi ini）',
      splitPlankTip2: '(Tidak kompatibel: Pengimbangan Pisau)',
      cutPlankMethod: 'Metode pemotongan papan',
      cutPlankMethodTip: 'Potong empat sisi dua kali',
      cutPlankMethodTip2: 'Hanya sisi terakhir yang dipotong dua kali',
      specialShapCut: 'Potong piring khusus dua kali',
      specialShapCutTip: '（Papan tidak berbentuk khusus tidak berlaku untuk fungsi ini）',
      bridgeRetention: 'Metode jembatan dengan titik penahan',
      bridgeRetentionTip: '(Catatan: 1. Fitur ini sementara tidak mendukung papan berbentuk khusus eksternal. 2. Tidak mendukung pemotongan miring ke bawah. 3. Ukuran minimum papan untuk menghasilkan jembatan penghubung adalah 30mm.)',
      bridgeRetentionDesc: 'Dapat menyelesaikan masalah getaran atau bergesernya papan saat jalur pemotongan kurang ditopang karena banyak area kosong di dalam papan.',
      bridgePunchArea: 'Bagian yang ditembus melebihi total area',
      bridgeSize: 'Ukuran jembatan',
      bridgeGenMethod: 'Metode pembuatan',
      bridgeAddTip: 'Tambahkan hingga 10 data',
      bridgeCount: 'Jumlah jembatan',
      bridgePlankLength: 'Panjang papan (L)',
      maxWH: 'Panjang atau lebar lebih kecil dari',
      areaLimit: 'Dan area ini lebih kecil dari',
      secondDeep: 'Kedalaman pemotongan kedua',
      splitPlankThickSetting: 'Pengaturan pemotongan berlapis',
      saveCustomSpeedTip: 'Kecepatan pengolahan tidak boleh kosong',
      saveLayeredCuttingTip: 'Jumlah dari tiga lapisan pemotongan pemotongan harus sama dengan ketebalan pelat',
      saveLayeredRepeatTip: 'Tidak disarankan untuk mengatur data berlapis yang berbeda untuk memotong dan melapisi bahan yang sama dengan ketebalan atribut highlight. Harap hapus kelebihan data!',
      splitPlankThick: 'Pemotongan berlapis dengan ketebalan pelat yang berbeda',
      movePlankSetting: 'Pengaturan Papan Anti-Run',
      newCutSequence: 'Versi baru dari algoritma pemotongan',
      newCutSequenceText: 'Gaya hisap vakum di tengah pelat besar adalah yang terkuat, dan pelat kecil di daerah ini akhirnya dipotong',
      positionTip: 'Klik pada area yang sesuai untuk membuat pilihan',
      suctionPosition: 'Posisi hisap vakum',
      strongArea: 'Zona pengisapan yang kuat',
      minSuctionPlank: 'Pelat hisap minimum',
      safeWidth: 'lebar',
      safeHeight: 'panjang',
      safeTip: 'Pelat akan dipotong terlebih dahulu jika Anda tidak dapat menyerapnya',
      scattered_layout: 'Tata Letak Papan Kecil Tersebar',
      lastCutPointEnable: 'Kustomisasi titik potong papan kecil potongan terakhir pada papan besar',
      lastCutPointEnableTip: 'Jika diaktifkan, titik potong papan kecil potongan terakhir pada setiap papan besar akan dihasilkan sesuai posisi titik yang ditetapkan',
      lastCutPoint: 'Posisi titik potong',
      lastCutPointTip: 'Jika diaktifkan, papan kecil potongan terakhir pada setiap papan besar akan menggunakan titik potong ini',
      leftTop: 'Kiri atas',
      rightTop: 'Kanan atas',
      leftBottom: 'Kiri bawah',
      rightBottom: 'Kanan bawah',
      specifyTheMaterial: 'Bahan yang ditentukan',
      shapeSecondCutenable: 'Pemotongan kedua plat berbentuk khusus',
      addMaterial: 'Tambahkan bahan',
      plankMaterial: 'Bahan papan',
      specifyTheMaterialTip: 'Setelah diaktifkan, fungsi pemotongan kedua hanya akan berlaku untuk panel yang memenuhi persyaratan bahan dari tabel.',
      dispersePaibanTipOne: '1. Setelah aktivasi, setidaknya satu pelat pada setiap papan besar akan memenuhi ukuran minimum yang dapat diserap.',
      dispersePaibanTipTwo: '2. Perhatikan kemungkinan meningkatkan volume pelat besar setelah digunakan',
      totalThickLimit: 'Jumlah dari tiga lapisan pemotongan harus sama dengan ketebalan pelat',
      offsetFollowStep: 'Pemangkasan tepi juga diikuti oleh pemotongan lapisan',
      longPlankTip1: '1. Setelah mengaktifkan atau menonaktifkan fungsi ini, catatan tata letak yang tersimpan dalam riwayat perlu ditata ulang saat mengunduh NC.',
      longPlankTip2: '2. Setelah mengaktifkan fungsi ini, Anda harus mengatur kode jeda pompa vakum di [Memotong docking - Jeda pompa vakum]; jika tidak, masalah lentur saat memotong pelat panjang tidak dapat diselesaikan.',
      longPlankTip3: '3. Kondisi filter yang diaktifkan di bawah divalidasi secara berurutan menurut tingkat; hanya papan yang memenuhi kondisi filter tingkat sebelumnya yang dapat masuk ke kondisi filter tingkat berikutnya untuk dinilai.',
      secondCutting: 'Objek pemotongan sekunder',
      normalPlank: 'Dewan reguler',
      normalPlankTip: 'Papan konvensional: Partisi horizontal dan vertikal di badan kabinet dan pintu dan papan non-kabinet lainnya ditambahkan langsung ke daftar material',
      designatedTarget: 'Objek yang ditentukan',
      filterLevel1Label: 'Filter tingkat 1',
      filterLevel1Category: 'jenis papan',
      filterLevel2Label: 'Filter tingkat 2',
      filterLevel2Category: 'batas ukuran',
      filterLevel3Label: 'Filter tingkat 3',
      filterLevel3Category: 'lainnya',
      specifiedBoardForceEnable: 'Abaikan ukuran/filter lain, paksa aktifkan',
      curveMaterialFilterTip: '(Setelah centang "Papan tidak beraturan", papan harus memenuhi syarat papan tidak beraturan sebelum filter material)',
      cuttingSettings: 'Pengaturan pemotongan',
      plankSizeLimitSuffix: ' papan',
      specifiedBoard: 'Tentukan nama pemotongan papan',
      specifiedBoardTip: 'Pemotongan kedua berlaku setelah dibuka jika nama pelat berisi nama pelat yang ditambahkan di bawah ini',
      addPlankName: 'Tambahkan Nama Papan',
      plankNameEmpty: 'Nama papan tidak boleh kosong, silakan masukkan',
      plankNameRequired: 'Silakan tambahkan setidaknya satu nama papan',
      plankLongLimit: 'Ketika sisi panjang papan melebihi',
      plankShortLimit: 'Sisi pendek melebihi',
      cuttingSplit: 'Potong dua kali',
      longExpand: 'Volume Potong Pertama: Volume Sisi Panjang',
      firstExpand: 'Volume pemotongan pertama',
      longExpandTip: 'Volume Sisi Panjang',
      longLimit: 'Sisi panjang melebihi',
      cuttingSplitTip: 'Piring panjang dipotong dalam dua kali',
      shortExpand: 'Volume sisi pendek',
      expandTip: '(Ukuran sisi panjang/pendek meningkat x mm, dan panjang dan sisi pendek dari pelat panjang berbentuk khusus semuanya meningkat di sisi panjang)',
      pumpOffWay: 'Metode shutdown vakum',
      afterOnePlank: 'Setelah memotong satu pelat panjang',
      afterAllPlank: 'Setelah memotong seluruh pelat',
      numberFixed: 'Jumlah tempat desimal dicadangkan',
      bufferCode: 'Menyiapkan perintah buffer',
      layoutGap: 'Pengaturan kesenjangan yang mengeset',
      layoutGapTip: 'CATATAN: Kesenjangan yang setel diatur ke 0 dapat menyebabkan pengesahan huruf tumpang tindih',
      wasteCutting: 'Pemotongan limbah otomatis',
      zkPointCustomize: 'Titik referensi rotasi yang disesuaikan untuk pemesinan lubang z-buckle miring',
      sawSetting: 'Melihat pengaturan pemotongan',
      cuttingLimit: 'Ukuran cutoff lebih besar dari',
      waste: 'Buang -buang',
      wasteSizeLimit: 'Ukuran minimum tidak boleh kurang dari 100mm',
      topLeft: 'Kiri, atas',
      topLeftD: 'Sudut kiri atas',
      bottomLeft: 'Kiri, bawah',
      bottomLeftD: 'Sudut kiri bawah',
      topRight: 'Benar, atasnya',
      topRightD: 'Sudut kanan atas',
      bottomRight: 'Kanan, bawah',
      bottomRightD: 'Sudut kanan bawah',
      firstTime: 'Pertama',
      secondTime: 'Kedua kalinya',
      thirdTime: 'Ketiga kalinya',
      startCutting: 'Pemotongan dimulai',
      thickRange: 'Ketebalan ≥',
      longCut: 'Pemrosesan Longboard',
      edgeSetting: 'Pengaturan Pemangkasan',
      cuttingOrder: 'Pesanan pemotongan:',
      cuttingOrderTip: 'Metode ini memiliki risiko menjalankan papan, silakan gunakan dengan hati -hati',
      plankFirst: 'Potong papan terlebih dahulu',
      wasteFirst: 'Potong limbah terlebih dahulu',
      offTip: 'Saat ditutup, pengaturan pemangkasan akan diikuti dalam parameter pemotongan.',
      edgeCutDirection: 'Arah pemangkasan',
      lGapTip: 'Posisi pelat besar berlekuk dari bahan residu berbentuk L secara otomatis disesuaikan dalam arah diagonal silinder penentuan posisi, kecuali untuk pelat besar bahan residu gloss tinggi, yang tidak kompatibel dengan fungsi pertukaran sumbu XY.',
      cylinderDir: 'Arah silinder penentuan posisi',
      onlyLong: 'Hanya sisi ramping',
      backCutOrder: 'Reverse Tripming Order',
      backFirst: 'Bagian depan sebaliknya adalah yang pertama',
      backSecond: 'Reverse Face Groove Processing dan Tripming',
      frontReCut: 'Retouch bagian depan',
      frontReCutTip: '(Buat tepi silinder posisi lebih halus untuk mencegah jejak)',
      useNewCut: 'Aktifkan versi baru aturan pemangkasan tepi',
      newCutTip: 'Gunakan fungsi ini ketika bagian depan pelat besar dua sisi akan diperbaiki dengan satu ukuran pemangkasan lagi.',
      fixedTip: 'CATATAN: Mungkin ada teseettings yang tumpang tindih ketika jumlah digit yang ditahan adalah 0 atau 1.',
      cuttingSlow: 'Buffer permukaan pelat pemotongan',
      holeSlow: 'Meninju bantal permukaan pelat',
      slotSlow: 'Menarik alur/lubang penggilingan/buffer permukaan pelat alur milling',
      slowCode: 'Penggunaan instruksi buffering',
      code: 'petunjuk',
      bufferOffset: 'Offset tinggi bantal permukaan pelat',
      zkRotatePoint: 'Putar titik referensi',
      zkRotateDir: 'Arah kenaikan sudut rotasi',
      restSizeLimit: 'Ukuran yang tersisa dari bahan yang tersisa lebih kecil dari',
      useSaw: 'Menggunakan bilah gergaji',
      unGenSawPath: 'Tidak ada jalur pemotongan bilah gergaji longitudinal yang dihasilkan',
      suitMachine: 'Cocok untuk memproses semua pelat yang dilas aluminium',
      plankBack: 'Sisi belakang piring besar',
      plankLeft: 'Sisi kiri papan',
      plankRight: 'Sisi kanan papan',
      plankFront: 'Sisi depan piring besar',
      frontSide: 'Sisi depan',
      backSide: 'Sisi belakang',
      rightSide: 'Sisi kanan',
      leftSide: 'Sisi kiri',
      singleMachineLimit: 'Bagian depan papan pemesinan satu sisi menghasilkan jalur pemangkasan dan memangkasnya terlebih dahulu',
      singleMachineLimitTip: 'Mesin all-in-one dan pemotongan bilah tidak berlaku.',
      setBatchPositionWaring: 'Kiat: Jika Anda perlu membatalkan modifikasi cepat dari mode titik alat, silakan hapus centang modifikasi kanan dari tombol titik alat',
      setBatchPosition: 'Titik modifikasi batch',
      setBatchPositionAs: 'Ubah arah alat berikutnya ke:',
      activeBatchPosition: '{ActivePartCount} Board telah dipilih',
      specialFrontSide: 'Slot khusus yang disetel dalam slot diversion didasarkan pada urutan prioritas pada sisi depan panel besar',
      rollCountTip: 'Hitung jumlah lembaran berdasarkan pemrosesan sebenarnya oleh mesin pemotong',
      specialFrontSideTip: 'Baris produksi saat ini tidak mendukung pemindahan karena memungkinkan fungsi slot khusus pada sisi depan panel besar dalam slot diversion atau menghitung jumlah lembaran berdasarkan pemrosesan slot belakang sebenarnya dalam mesin pemotong setelah slot diversion diaktifkan.',
      doubleTrim: 'Pemotongan panel dua sisi',
      trim: 'Pemotongan',
      trimTwoSide: 'Pemotongan kedua sisi',
      trimFourSide: 'Pemotongan empat sisi',
      rightInmShow: 'Seperti yang ditunjukkan pada gambar di sebelah kanan',
      currentTrimDir: 'untuk arah pemotongan yang saat ini dipilih',
      cylinderTip: 'untuk menentukan posisi silinder',
      onlyShort: 'Hanya memperbaiki tepi pendek',
      singleTrim: 'Pembuatan jalur pemotongan untuk panel tunggal',
      hierarchyCutTwice: 'Pemotongan slot dan slot dengan indeks berlapis',
      knifeDia: 'Diameter pisau kurang dari atau sama dengan',
      slotDeep: 'dan kedalaman slot lebih dari atau sama dengan',
      cutTwiceSlot: 'Saat melakukan pemotongan berlapis slot',
      twiceSlotDeep: 'Kedalaman pemotongan lapisan kedua adalah',
      cutTwiceCondition: 'Kondisi pemotongan',
      zkPointCustomizeTip: 'Mengaktifkan pertukaran sumbu XY akan menyebabkan arah pemrosesan dan titik referensi menjadi terbalik',
      zkPointCustomizeTip1: 'Fungsi ini tidak berfungsi untuk perangkat yang mengaktifkan pertukaran sumbu XY',
      isCustom: 'Aktifkan pengustomisasian',
      useCutCon: 'Menggunakan kondisi pemotongan',
      singleSetPlankSizeSpeed: 'Atur Kecepatan Pemrosesan untuk Rentang Ukuran Papan Spesifik',
      singleSetPlankSizeSpeedTip: '(1. Ketika tepi kecil memenuhi pengaturan ukuran di bawah ini, ia akan diproses dengan kecepatan yang ditentukan. 2. Jika tepi kecil memenuhi beberapa aturan sekaligus, aturan dengan nomor urutan yang lebih awal berlaku. 3. Fitur ini tidak berlaku untuk pemotongan dengan pisau gergaji.)',
      addSpeedRules: 'Tambahkan Aturan',
      speedRules: 'Aturan',
      shortSideSize: 'Ukuran Tepi Pendek',
      lessThanEqual: 'Kurang Dari atau Sama Dengan',
      and: 'Dan',
      longSideSize: 'Ukuran Tepi Panjang',
      processingSpeed: 'Kecepatan Pemrosesan',
      trimLenCompensation: 'Kompensasi panjang pemotongan:',
      trimGenerateAPath: 'Nilai potong 0 tidak menghasilkan jalur:',
      cuttingMethod: 'Metode pemotongan',
      horizontalCutting: 'Pemotongan horizontal',
      verticalCutting: 'Pemotongan vertikal',
      openKnifeDistance: 'Jarak pelambatan'
      },
    labelingSettings: {
      title: 'Pengaturan Pelabelan',
      output: 'File pelabelan otomatis output',
      specification: 'Format File Label',
      codeFrontGenerate: 'Kode pemuatan otomatis dihasilkan sebelum kode pelabelan',
      templateOffline: 'Template yang digunakan telah offline!',
      rollLabelling: 'Pengaturan pelabelan flip',
      flipSetting: {
        title: 'Pengaturan flip',
        engravingFlipProcess: 'Aktifkan mode pelabelan pemrosesan flip mesin ukiran',
        flipTip: 'Aktifkan fungsi ini ketika mesin ukiran perlu dibalik.'
        },
      rotateSetting: {
        title: 'Pengaturan Rotasi Tag',
        rotateTip: 'Nyalakan kondisi rotasi sesuai dengan persyaratan. Jika dihidupkan pada saat yang sama, pilih nilai yang ditetapkan untuk pilihan terbaik',
        horizontal: 'Tepi horizontal pelat ≤',
        vertical: 'Tepi vertikal pelat ≤',
        either: 'Horizontal Tepi vertikal ≤'
        },
      countertopSetting: {
        title: 'Pengaturan Desktop',
        startPoint: 'Titik awal stasiun',
        upLeft: 'Sudut kiri atas',
        upRight: 'Sudut kanan atas',
        downLeft: 'Sudut kiri bawah',
        downRight: 'Sudut kanan bawah',
        baseExchange: 'Koordinat Penyelarasan Referensi',
        exchangeX: 'Penyesuaian sumbu x',
        exchangeY: 'Sakelar sumbu y'
        },
      offset: 'Label Offset Koordinat',
      offsetTip: 'Secara umum, koordinat label berada di tengah papan kecil, dan beberapa peralatan perlu disesuaikan.',
      label_rotate_offset: 'Koordinat offset setelah rotasi label',
      label_rotate_offset_tip: 'Ketika perbedaan posisi offset antara label sebelum dan sesudah rotasi besar, itu perlu disesuaikan.',
      label_rotate_offset_err_tip: 'Setelah offset koordinat dihidupkan setelah label diputar, offset koordinat sumbu X dan Y diperlukan.',
      imgSetting: {
        title: 'Pengaturan gambar pelabelan',
        suffix: 'Sufiks gambar label:',
        code: 'Metode pengkodean gambar:',
        codeTip: 'Catatan: PNG dan JPEG akan secara bersamaan memodifikasi format pengkodean diagram tata letak, dan tata letak awan yang tertanam belum mendukung fungsi ini.',
        imgRatio: 'Labeling Resolusi Gambar:',
        slowDown: 'Akan mengurangi efisiensi mengekspor gambar tag',
        color: 'Sangat berwarna',
        bit: 'Hitam dan putih',
        resolution: 'Label resolusi gambar',
        resolutionPlaceholder: 'Resolusi',
        labelPool: 'Kumpulan tag data',
        showKey: 'Bidang Tampilan',
        dragTip: 'Tag drag-drop di tag pool',
        labelImgName: 'Nama gambar berlabel',
        labelImgNameErrTip: 'Nama gambar label tidak bisa kosong',
        labelTip1: 'Saat menyesuaikan, Anda harus menggunakan salah satu dari "papan barcode papan" atau "nomor seri label", jika tidak akan ada masalah cakupan gambar;',
        labelTip3: '【Nomor Seri Label】 adalah nomor seri papan dari atas ke bawah dalam daftar pemotongan, dan papan yang ditambahkan di halaman pengaturan tidak memiliki data ini',
        labelTip2: '3. Template sistem mesin pelabelan tidak berlaku.',
        delimiter: 'Pembatas',
        inputTip: 'Input /:? <> . ” * Dan karakter lain tidak didukung',
        numStart: 'Nilai mulai dari nomor seri berlabel',
        example: 'Nama Gambar Pelabelan Kustom (Contoh)',
        stockNumOffset: 'Digit kompensasi nomor seri papan besar telah diterima.',
        divideFolders: 'Gambar tag dibagi menjadi folder yang berbeda sesuai dengan papan besar',
        foldersTip1: 'Catatan: 1. Fungsi ini tidak mendukung penggunaan dengan fungsi "Spinder File Gabungan";',
        foldersTip2: '2. Fungsi ini belum efektif untuk pengaturan huruf awan tertanam',
        stickIntoFolders: 'Masukkan file pelabelan ke dalam folder gambar pelabelan dari papan besar yang sesuai',
        stickTip1: 'Catatan: 1. Fungsi ini perlu digunakan bersama dengan fungsi "Unduh NC dan Ekspor";',
        stickTip2: '2. Aturan pembuatan file dalam templat pelabelan yang digunakan perlu memilih "menghasilkan satu file" untuk berlaku;',
        stickTip3: '3. Fungsi ini belum efektif untuk pengaturan huruf awan tertanam'
        },
      pdfSetting: {
        title: 'Pengaturan PDF Label',
        pdfLabelName: 'Nama File PDF',
        example: 'Nama File PDF Kustom (Contoh)',
        address: 'Alamat Proyek',
        orderNo: 'No. Pesanan',
        firstFolder: 'Folder Level Pertama',
        customerName: 'Nama Pelanggan'
        },
      paibanImgSetting: {
        title: 'Pengaturan Diagram Pengesahan',
        tip: 'Ekspor tipografi khusus diaktifkan, template tetap di bawah ini tidak dapat diekspor. Untuk mengekspor, tutup Ekspor tipografi khusus di halaman pengaturan lebih lanjut tipografi',
        reparation: 'Nomor tata letak akan dikompensasi secara otomatis',
        figure: 'Sedikit',
        inputTip: 'Harap masukkan nomor dari 1-99',
        paibanImg: {
          export: 'Tata letak ekspor',
          prefix: 'Awalan yang mengeset',
          size: 'Ukuran pengukur huruf',
          format: 'Format pengukur huruf',
          directional: 'Arah diagram yang memetik',
          vertical: 'Vertikal',
          horizontal: 'Horisontal'
          }
        },
      autolabel: 'Pengaturan Pesanan Pelabelan Otomatis',
      customTemp: 'Efektif untuk templat khusus saja',
      cuttingLabelOder: 'Label sesuai dengan urutan pemotongan',
      labelToUp: 'Label dari bawah ke atas sesuai dengan hasil tata letak',
      labelToDown: 'Label dari atas ke bawah sesuai dengan hasil tata letak',
      labelDodge: 'Penghindaran pelabelan otomatis',
      nolabelForsurplus: 'Tidak ada file pelabelan yang dibuat untuk papan sisa',
      settingValue: 'Pilih Nilai Set',
      enabelTip: 'Setelah dibuka, saat papan kecil memenuhi nilai pengaturan berikut, label berputar',
      fixedHori: 'Pilih tepi horizontal label agar sejajar dengan tepi tetap dari pelat kecil',
      fixedHoriTip: 'Hanya efektif untuk papan kecil tanpa tekstur. Setelah membuka, saat memberi label, label akan berputar ke paralel ke tepi horizontal label dan tepi tetap dari papan kecil.',
      tagHori: 'Tag Border Horizontal',
      effectiveTarget: 'Obyek yang berlaku',
      allPlank: 'Semua Papan',
      notcarePlank: 'Hanya Papan Bebas Tekstur'
      },
    drillSettings: {
      title: 'Pengaturan pengeboran',
      enable: 'Aktifkan paket pengeboran',
      toolTable: {
        use: 'Memungkinkan',
        number2: 'Workstation 2 Nomor Bor Baris',
        number: 'Nomor pengeboran',
        diameter: 'Bor sedikit diameter',
        xOffset: 'X Offset',
        yOffset: 'Y offset',
        moveZF: 'Z-Axis Fast Moving Speed',
        feedRate: 'Kecepatan pemesinan sumbu Z',
        moveF: 'Kecepatan Gerakan Cepat Sumbu XY',
        benchmarkDrill: 'BATURAN BENCHMARK',
        addKnife: 'Tambahkan alat',
        deleteKnife: 'Hapus alat'
        },
      prefix: 'Awalan pengeboran',
      suffix: 'Suffix Pengeboran',
      startCode: 'Kode Mulai Pengeboran',
      endCode: 'Kode akhir pengeboran',
      combineKnife: 'Pemotong kombinasi pengeboran',
      combineTable: {
        prefix: 'Awalan nomor bor',
        suffix: 'Suffix nomor bor',
        mainHole: 'Lubang utama',
        extraHole: 'Dari lubang',
        notes: 'Komentar Kombinasi',
        firstUseNotes: 'Aktifkan komentar untuk pertama kalinya',
        addExtraHole: 'Tambahkan dari lubang',
        deleteExtraHole: 'Hapus dari lubang',
        example: 'Mencicipi'
        },
      tagPool: {
        drillRowNumber: 'Nomor baris bor'
        },
      processSetting: {
        title: 'Pengaturan pemrosesan',
        mode: 'Mode Pemrosesan Pengeboran',
        processTip: 'Setelah memilih metode ini, fungsi pemotongan kombinasi pengeboran dan pengeboran tidak akan berlaku.',
        recentHole: 'Lubang pukulan di dekatnya (perubahan alat cepat)',
        groupHole: 'Lubang pukulan berdasarkan kategori (lengkapi jenis lubang pertama dan kemudian ubah alat)',
        drill_benchmark: 'Kombinasi pengaturan alat',
        drill_benchmark_Tip: '（Perhatian：Setelah memilih metode ini, fungsi pengaturan alat kombinasi pengeboran tidak akan berlaku）',
        mainHole: 'Lubang utama',
        secondaryHole: 'Lubang tambahan (Lubang ekor)'
        },
      changeBenchDrillTip: 'Harap masukkan nomor pengeboran sebelum memilih ini'
      },
    NCExportSettings: {
      jumpSkipTip2: 'Mengklasifikasikan ke dalam folder yang berbeda berdasarkan warna, ketebalan, dan material papan besar (termasuk file pelabelan), dan menempatkan file pemotongan material papan besar dengan ukuran yang sama dalam folder yang sama',
      title: 'Pengaturan Ekspor NC',
      tab1: 'Pengaturan Nama File Mesin Pemotongan',
      tab2: 'Gabungkan nama file pemotong',
      tab3: 'Catatan dalam file mesin pemotong',
      tab4: 'Jenis dalam file mesin pemotong',
      tab5: 'Folder mesin pemotong',
      tab6: 'Memproses Pengaturan Perintah',
      tab7: 'Pengaturan Format File',
      fileNameSettings: {
        twoStationAutoSort: 'Pemilahan Stasiun Ganda Otomatis',
        reparation: 'Jumlah nomor papan besar dikompensasi',
        figure: 'Sedikit',
        labelerBegin: 'Mulai mesin label',
        machineCenter: 'Mulai Pusat Pemesinan',
        front: 'depan:',
        back: 'Balik:',
        customizeName: 'Nama File Kustom (Format):',
        example: 'Nama File Kustom (Contoh):',
        emptyTip: 'Pengidentifikasi file depan dan belakang tidak dapat kosong pada saat yang sama',
        labelPool: 'Kumpulan tag data',
        dragTip: 'Anda dapat menyeret atau mengklik untuk menyalin tag di kumpulan tag ke kotak input'
        },
      fileMerge: {
        engravingMerge: 'Kombinasi file mesin pemotong',
        zfMerge: 'Gabungkan depan dan belakang',
        singleMerge: 'Penggabungan stasiun tunggal',
        doubleMerge: 'Penggabungan Stasiun Ganda',
        fEndCode: 'Kode akhir terbalik',
        zBeginCode: 'Kode Mulai Depan',
        displayfbInfo: 'Nama file menampilkan informasi depan dan belakang',
        fBeginCode: 'Kode Mulai Terbalik',
        zEndCode: 'Kode ujung depan'
        },
      marginalNotes: {
        addPlankInfo: 'Tambahkan informasi pelat besar saat ini di awal file pemotongan:',
        plankInfo: 'Informasi Papan Besar:',
        addStationCodeFirst: 'Tambahkan kode stasiun kerja di awal file pemotongan:',
        addStationCodeSecond: 'Tambahkan kode stasiun kerja sebelum mengubah alat saat memotong file materi:'
        },
      fileType: {
        zAddtion: 'Z Koordinat Suplemen:',
        addSemicolon: 'Tambahkan titik koma di akhir setiap baris NC:',
        semicolonTip: 'File pemrosesan pegangan tanduk juga akan berlaku setelah memeriksa',
        fileName: 'Nama file',
        defaultName: 'Nama file default',
        dedicatedName: 'Nama file khusus untuk peralatan starlight',
        xhNotes: 'Starlight E2-9 Komentar',
        format: 'Format file mesin ukiran ukiran',
        example: 'Contoh File: File NC',
        stillGenerate: 'Ketika sisi terbalik tidak diproses, itu masih menghasilkan file NC terbalik dengan hanya kode ujung terbalik.',
        generateTip: 'Fitur ini tidak mendukung penggunaan dengan fungsi penggabungan file',
        fileNameErrTip: 'Nama file tidak dapat berisi karakter berikut: /: *? "'
        },
      categorize: 'Menurut warna, bahan dan ketebalan papan besar, itu diklasifikasikan ke dalam folder yang berbeda (label file bersama):',
      simplifyG: 'Memproses singkatan instruksi G',
      ZToW: 'Kode diubah dari sumbu z ke sumbu W',
      knives: 'Alat pengeboran',
      lineBreakSetting: 'Pengaturan Format Line Break',
      codeFormatSetting: 'Pengaturan format pengkodean file',
      utf8bom: 'UTF-8 dengan bom',
      oneCodeSetting: 'Pengaturan Barcode Papan',
      simplifyOneCode: 'Hasilkan Barcode Tag Format Sederhana',
      codeLocation: 'Pengaturan Lokasi Kode',
      generateLocation: 'Kode akhir stasiun kerja dihasilkan sebelum kode akhir terbalik',
      emergencySetting: 'Pengaturan darurat',
      show: 'Tampilkan pengaturan darurat',
      emergencyCode: 'Kode darurat',
      params: 'parameter',
      emergencyTip: 'Beberapa fungsi niche dapat untuk sementara waktu diimplementasikan dengan kerja sama personel setelah penjualan',
      holeSetting: 'Pengaturan file meninju',
      holeFileCategorize: 'File meninju ditempatkan secara terpisah sesuai dengan pesanan yang berbeda',
      holeTip: 'Tata letak awan klien kabinet tertanam tidak berlaku',
      specialCodeErr: 'Input karakter khusus tidak didukung!',
      copySuccess: 'Salin dengan sukses!',
      copyErr: 'Menyalin gagal, coba seret dan menjatuhkan tag!',
      lengthLimit: 'Hanya 15 bit yang dimasukkan!',
      plankInfo: 'Informasi papan',
      otherInfo: 'Informasi tambahan',
      uniqueBarCode: 'Barcode yang unik',
      uniqueBarCodeForPack: 'Barcode papan unik (untuk kemasan)',
      machineOrder: 'Memotong nama file untuk menghasilkan nomor urutan pemrosesan',
      folderSetting: 'Tempatkan folder yang sama dengan piring besar dengan ukuran yang sama',
      labelImageINCFolder: 'Gambar pelabelan ditempatkan di folder NC dengan file pelabelan',
      custom: 'dibuat khusus',
      folderSettingTip: 'Catatan: Fitur ini belum didukung dalam pengaturan huruf tertanam',
      settingMoveTip: 'Fungsi "{func}" asli telah dipindahkan ke halaman "{Modul}"!',
      fileManagerFunction: 'File meninju ditempatkan secara terpisah sesuai dengan file pesanan yang berbeda',
      gotoSetting: 'Pergi ke Pengaturan',
      singleFileTitle: 'Pengaturan pemrosesan file tunggal',
      slectSingleProcess: 'Pilih proses keluaran tunggal',
      slectSingleProcessTip: 'Masih ada proses pemrosesan sekunder berbayar, hapus lalu simpan kembali',
      setSingleRegularSize: 'Atur ukuran lubang dan slot reguler untuk keluaran tunggal',
      holeRange: 'Rentang efektif lubang',
      slotRange: 'Rentang efektif slot',
      holeRangeTip: 'Rentang efektif lubang tidak boleh kosong, silakan isi!',
      slotRangeTip: 'Rentang efektif slot tidak boleh kosong, silakan isi!',
      yhzc: 'Slot lurus pada bagian lengkungan busur',
      xbgy: 'Sudut Haitang miring dan handle miring',
      nbyx: 'Bentuk tidak beraturan internal',
      secondaryProcessingMerge: 'Penggabungan file pemrosesan sekunder',
      secondaryProcessingMergeName: 'Nama file gabungan',
      secondaryProcessingMergeTip: 'Jika diaktifkan, saat panel ekspor memiliki beberapa proses sekunder, akan digabung ke satu file pemrosesan',
      singleFileSetting: 'Keluaran pemrosesan file tunggal dengan tepi bevel, sudut cherry blossom, dan sisi miring',
      straightArcSlot: 'Keluaran pemrosesan file tunggal dengan slot lurus dalam bagian yang dibengkokkan'
      },
    aioMachineSetting: {
      openFunction: 'Docking membutuhkan fungsi -fungsi berikut untuk diaktifkan',
      openCarving: 'Nyalakan mesin ukiran',
      xyReverseFunction: 'Fungsi pertukaran sumbu xy',
      carvingStartSet: 'Titik awal stasiun mesin ukiran diatur ke',
      rightTop: 'Sudut kanan atas',
      carvingEdgeSet: 'Bagian depan mesin ukiran disesuaikan',
      finalEdgeSame: 'Sama seperti nilai total selesai',
      beginCode: 'Kode Mulai Program',
      endCode: 'Kode Akhir Program',
      drillHole: 'Lubang meninju',
      pullTrough: 'Tarik slotnya',
      showDataTemp: 'Tampilkan sampel data',
      dataTemp: 'Sampel data',
      title: 'Pengaturan all-in-one',
      outputFile: 'Output file permesinan all-in-one',
      outputFileTips: 'Beberapa merek mesin all-in-one tidak sesuai dengan XY Exchange, penggabungan file, dan tidak ada lubang berbentuk khusus yang tertusuk. Harap gunakan dengan hati -hati.',
      fileType: 'Format file',
      select: 'Pilih',
      diameter: 'Diameter alat pemangkasan',
      jidongTip: 'Gunakan mesin jidong all-in-one, silakan atur titik awal stasiun mesin ukiran ke sudut kanan atas dan aktifkan fungsi A',
      skill: 'Fungsi',
      clampHandLength: 'Panjang klem tangan (l)',
      clampHandWidth: 'Lebar tangan penjepit (w)',
      clampHandMargin1: 'Klip Tangan 1 Tepi Jarak (H1)',
      clampHandMargin2: 'Klip Tangan 2 Tepi Jarak (H2)',
      duchClampHand: 'Slot lubang menghindari posisi penjepit tangan',
      clampHandDirection: 'Arah penjepit tangan',
      left: 'Sisi kiri',
      right: 'Sisi kanan',
      top: 'Sisi atas',
      bottom: 'Sisi bawah'
      },
    oneDragTwo: {
      title: 'Mesin ukiran satu-ke-dua',
      outputMachineFile: 'Output file pemrosesan mesin dua-drag-drag-drag',
      outputMachineFileTips: 'Setelah mengaktifkan mesin ukiran satu-ke-dua, tidak kompatibel dengan fungsi penggabungan file pemotong. Harap gunakan dengan hati -hati.',
      fileType: 'Format file',
      select: 'Pilih',
      machineStart: 'Titik awal stasiun',
      positionClose: 'Saat ditutup, pengaturan titik awal stasiun dalam parameter pemotongan akan diikuti.',
      engravingPlus: 'Mesin ukiran cepat'
      },
    sawEngraving: {
      title: 'Melihat mesin ukiran pemotongan',
      preLayNav: 'Pengaturan mesin ukiran gergaji',
      preLayKnifeInput: 'Diameter pemotong silang blade gergaji',
      enableSaw: 'Aktifkan mesin penggergajian dan ukiran',
      sawAioTip: 'Anda belum memiliki izin keluaran papan las AIO; silakan hubungi tim penjualan untuk mengaktifkan.',
      cutSet: 'Pengaturan pemotongan papan persegi panjang',
      weldingPlank: 'Papan las',
      doorFrame: 'Frame pintu',
      doorFrameTip1: 'Jari-jari pisau pemotong harus kurang dari atau sama dengan ketebalan pisau gergaji',
      doorFrameTip2: '2.Penyusunan plat tidak teratur tidak didukung 3.Spacing otomatis untuk layout',
      sawUsing: 'Penggunaan bilah gergaji',
      trim: 'Pemangkasan Perbatasan',
      cutBlank: 'Memotong',
      backTrimOblique: 'Pemangkasan sisi belakang',
      holeSlotOblique: 'Slot lubang',
      plankThicknessUnit: 'Satuan tebal papan',
      sawUseCond: 'Kondisi untuk penggunaan bilah gergaji',
      exportPartData: 'Keluaran file data papan kecil',
      sawAioTip2: 'Digunakan untuk mesin potong semua-dalam-satu',
      hasUsing: 'Gunakan jika tersedia',
      onlyUse: 'Gunakan hanya kapan',
      cutMethod: 'Metode pemotongan',
      oneKnifePull: 'Tarik melalui papan besar dengan satu pisau',
      onlyOneKnifePull: 'Tarik saja dengan satu pisau',
      enableSawThick: 'Aktifkan tata letak ketebalan blade gergaji',
      edgedDir: 'Tepi pelat besar yang telah disegel dan tidak lagi dipotong',
      sameWidthPart: 'Hanya papan kecil dengan lebar yang sama yang ditempatkan di setiap papan besar',
      emptyPath: 'Tidak ada jalur kosong yang dihasilkan ketika papan kecil dipotong',
      sawUsePlank: 'Menggunakan mata gergaji untuk memproses pelat las',
      paibanGap: 'Jarak tata letak pelat las',
      minSurplusWidthDiff: 'Perbedaan Lebar Pemasangan Sisa Minimum',
      minSurplusWidthDiffTip: 'Lembar kecil hanya akan diatur di atas sisa jika perbedaan lebar antara lembar kecil dan sisa lebih kecil dari nilai ini',
      sawReplaceEnable: 'Jalur pemotongan gergaji lurus diganti dengan gergaji',
      minSawLength: 'Jarak minimum untuk diganti dengan gergaji',
      keepDistance: 'Jarak untuk mempertahankan pemotongan gergaji lurus antara papan yang lebih lebar',
      keepDistanceTip: 'Catatan: Biarkan cukup ruang untuk menghindari memotong papan yang berdekatan',
      sortByLength: 'Mengurutkan berdasarkan panjang papan',
      sortByLengthTip: 'Mengurutkan berdasarkan panjang papan',
      plankAtTop: 'Papan kecil di atas',
      plankAtBottom: 'Papan kecil di bawah',
      useSawTipOne: 'Setelah diaktifkan, hanya papan kecil dengan properti "pelat las" dalam kabinet yang akan diproses menggunakan pisau gergaji, sedangkan papan non-las akan dipotong dengan pisau lurus',
      useSawTipTwo: 'Setelah diaktifkan, fungsi "Pengurutan Custom Papan Besar" tidak akan menggunakan papan besar standar. Jika ingin pengurutan campuran, tambahkan data material awal pelat las dan papan sarang lebah ke dalam Papan Besar Khusus',
      useSaiTipThree: 'Setelah mengaktifkan fungsi ini, solusi tata letak (nesting) harus menggunakan tata letak penggergajian',
      surplusStoreAndLabeling: 'Sisa material setelah pemotongan dapat disimpan dan dicetak label',
      surplusMinLength: 'Panjang minimum material sisa yang dapat digunakan',
      surplusMinSize: 'Ukuran minimum material sisa yang dapat digunakan',
      crossCutOnlyMinSurplusSize: 'Sisa bahan hanya akan dibuat jalur pemotongan silang jika ukuran minimum yang dapat digunakan terpenuhi',
      surplusStoreAndLabelingTip: '1、Pada setiap papan besar, sisa material akan dihasilkan di atas atau di bawah, sisa material dapat disimpan dan dicetak label',
      surplusStoreAndLabelingTip2: '2、Sisa material setelah pemotongan tidak dapat digunakan untuk papan las）',
      surplusStoreAndLabelingTip3: '（Setelah diaktifkan',
      backCutSurplus: 'Memotong sisa material dari sisi belakang',
      cutSurplusTip: 'Setelah mengaktifkan, silakan atur urutan pemangkasan sisi belakang ke "Pemangkasan setelah pemesinan alur sisi belakang"',
      top: 'Di atas',
      bottom: 'di bawah',
      left: 'kiri',
      right: 'Kanan',
      dockTip: 'Pemrosesan pelat pengelasan pantat membutuhkan penyegelan empat sisi pelat persegi panjang dan pemangkasan tepi keseluruhan, dan mengoperasikannya secara manual ke tata letak baris tunggal.',
      sawToLayoutTip: 'Pemotongan layout sementara tidak mendukung pisau pemotongan yang ditentukan',
      sawToLayoutTip2: 'Layout pemotongan gergaji untuk sementara tidak mendukung penunjukan pisau potong khusus',
      tempPaiabanTip: 'Setelah mengaktifkan pemotongan bilah gergaji, tidak didukung untuk menambahkan pelat berbentuk khusus secara langsung di tata letak. Jika Anda perlu menambahkan, silakan buka daftar pembuka untuk ditambahkan dan ketik!',
      generateCutSurplusPath: 'Hasilkan jalur potong melintang yang terlebih dahulu memotong sisa bahan',
      curSurplusPathTip: 'Setelah diaktifkan, atur urutan pemotongan sisi belakang dengan "potong setelah proses lubang/alur di sisi belakang"'
      },
    robotArmDocking: {
      autoLine: 'Docking garis otomatis',
      autoLineTip: 'Anda tidak memiliki izin untuk menggunakan garis otomatis atau jumlah garis otomatis yang dapat dibuka Anda tidak cukup',
      title: 'Lengan Robotik',
      enable: 'Aktifkan docking lengan robot',
      enableTip: 'Setelah dibuka, saat mengeluarkan dokumen produksi, dokumen docking lengan robot akan dikeluarkan'
      },
    laserCuttingMachine: {
      title: 'Mesin pemotong laser all-in-one',
      enable: 'Aktifkan mesin pemotong laser all-in-one',
      backSafeHeight: 'Tinggi Z saat sisi belakang kosong (H)',
      laserDistance: 'Jarak antara pisau laser dan permukaan papan saat memotong bagian depan/belakang',
      coordinateAxis: 'Sumbu koordinat',
      xAxis: 'X',
      yAxis: 'Y',
      zAxis: 'Z',
      cuttingSettings: 'Pengaturan pemotongan',
      backKnifeStore: 'Kumpulan pisau belakang',
      noSupportOriginalMaterialKnife: 'Fungsi "Pemilihan pisau pemotongan bahan asli" belum didukung',
      laserKnifeTip: 'Pemotongan buka: Digunakan untuk memproses bentuk internal yang belum menembus',
      laserKnifeTip2: 'Pisau laser: Memproses lubang/alur yang menembus, bentuk internal, pemotongan kontur luar',
      laserKnifeTip3: 'Perhatian: Sumbu Z belakang secara default menggunakan koordinat relatif yang sesuai dengan jarak ke permukaan meja',
      laserKnifeTip4: 'Jumlah pisau tidak boleh kurang dari 1',
      laserKnifeTip5: 'Tidak dapat menghapus pisau pemotongan buka',
      laserKnifeTip6: 'Terdeteksi tidak ada pisau yang dipilih untuk pemotongan buka, harap pilih setidaknya satu pisau',
      laserKnifeTip7: 'Pisau laser tidak dapat memproses bentuk internal yang belum terpotong menembus, opsi "Pemotongan buka" telah dibatalkan secara otomatis',
      laserKnifeTip8: 'Harap pilih pisau dengan opsi "Pemotongan buka" di gudang pisau, jika tidak tidak dapat memproses bentuk internal yang belum terpotong menembus',
      laserKnifeTip9: 'Diameter pisau laser di gudang pisau pemotongan buka tidak konsisten dengan diameter pisau laser mesin laser terintegrasi, harap periksa',
      laserKnifeTip10: 'Diameter pisau pemotongan buka di gudang pisau pemotongan buka tidak konsisten dengan diameter pisau pemotongan buka mesin laser terintegrasi, harap periksa',
      laserKnifeTip11: 'Parameter docking peralatan telah dimodifikasi, harap tata ulang',
      noLaserPermission: 'Tidak memiliki izin penggunaan mesin laser terintegrasi, silakan hubungi penjualan untuk membeli izin penggunaan mesin laser terintegrasi sebelum menggunakan',
      laserOpenCode: 'Kode Pembukaan Laser',
      laserCloseCode: 'Kode Penutupan Laser',
      laserToolSettings: 'Pengaturan Alat Laser'
      },
    firstSave: 'Terdeteksi bahwa ini adalah pertama kalinya pengguna menggunakan tata letak cloud. Setelah menyimpan pengaturan, harap perhatikan apakah arah pemangkasan dalam file tersebut masuk akal untuk menghindari kerugian yang tidak perlu.',
    knives: {
      xOffset1: 'X Offset Koordinat',
      yOffset1: 'Y Offset Koordinat',
      zOffset1: 'Z Offset Koordinat',
      insert: 'Masukkan baris',
      delete: 'Hapus baris',
      tip: '(Catatan: Setelah menyelesaikan modifikasi atau penyesuaian informasi majalah alat, pengguna yang berada dalam produksi tata letak kabinet perlu memulai kembali klien kabinet untuk menerapkan perubahan terbaru!)',
      number: 'nomor seri',
      name: 'nama',
      diameter: 'Diameter pisau φ',
      sawDiameter: 'Ketebalan Pisau GergajiΦ',
      cutting: 'Pembukaan',
      use: 'menggunakan',
      moveZF: 'Z-Axis Fast Moving Speed',
      axis_offset: 'Pengaturan Sumbu Offset',
      arc_radius: 'Pengaturan Radius Busur',
      cutZF: 'Kecepatan pemesinan sumbu Z',
      moveF: 'Kecepatan Gerakan Cepat Sumbu XY',
      cutF: 'Kecepatan permesinan sumbu xy',
      startCode: 'Kode Mulai Perubahan Alat',
      stopCode: 'Kode Akhir Perubahan Alat',
      startCode2: 'Kode Mulai Perubahan Alat Workstation 2',
      stopCode2: 'Workstation 2 Alat Ubah Kode Akhir',
      knifeLength: 'Ketebalan Pisau GergajiΦ',
      maximum_single_depth: 'Kedalaman maksimum per pisau',
      specialShapeKnifeTip: 'Hanya untuk bentuk internal yang tidak teratur',
      preStartCode: 'Kode pra-awal',
      punchHoles: 'Lubang meninju',
      pullSlots: 'Tarik slotnya',
      millHoles: 'Lubang penggilingan',
      millSlots: 'Slot penggilingan',
      sawBlade: 'Saw blade',
      doubleSaw: 'Aktifkan kode start perubahan alat yang berbeda untuk stasiun ganda',
      singleStation: 'Ruang kerja tunggal',
      doubleStation: 'Rangkap',
      sawBladeTip: 'Fungsi ini tidak berlaku pada mesin ukiran satu-ke-dua dan mesin all-in-one',
      serialNum: 'nomor seri',
      sawWidth: 'Lebar pisau',
      sawType: 'Jenis pisau gergaji',
      cutDirection: 'Arah pemotongan',
      moveSpeed: 'Kecepatan kosong',
      cutSpeed: 'Kecepatan pemrosesan',
      endCode: 'Kode Akhir Perubahan Alat',
      sawDownCode: 'Kode Potongan',
      sawUpCode: 'Kode pisau',
      abscissa: 'Awalan absis',
      ordinate: 'Awalan ordinat',
      sawHor: 'Pisau gergaji silang',
      sawVer: 'Pisau gergaji longitudinal',
      towardsZero: 'Potong ke 0 koordinat titik',
      awayFromZero: 'Jauh dari pemotongan koordinat 0-poin',
      diameterDesc: 'Diameter pisau φ',
      xOffset: 'Offset koordinat horizontal',
      yOffset: 'Offset koordinat vertikal',
      zOffset: 'Mengangkat Offset Koordinat',
      offsetX: 'Offset x',
      offsetY: 'Mengimbangi y',
      offsetZ: 'Offset Z.',
      offsetNo: 'Nomor offset',
      knifeWidth: 'Lebar pisau',
      drill: 'Melepaskan pisau',
      cut: 'Pengolahan',
      speed: 'Kecepatan',
      type: 'jenis',
      millHoleSlot: 'Lubang/slot penggilingan',
      rapidFeedSpeed: 'Kecepatan umpan cepat',
      typeOption1: 'Bor',
      typeOption2: 'Pemotong penggilingan',
      typeOption3: 'Pisau Bentuk',
      typeTip: 'Pengaturan jenis alat lubang belakang akan cocok dengan jenis alat yang sesuai untuk pemrosesan'
      },
    other: {
      title: 'lainnya',
      tip: '(Catatan: Peralatan stasiun tunggal memerlukan kode pemuatan otomatis yang sama untuk mengisi stasiun 1 dan stasiun 2)'
      }
    },
  sideHoleMachine: {
    moreSetting: 'Pengaturan tambahan',
    sideStartCode: 'Pemrosesan depan menghasilkan kode perubahan muka',
    useArcCode: 'Perintah interpolasi busur untuk memotong busur',
    coordSwitch: 'Koordinat Penyelarasan Referensi',
    updownCoordSwitch: 'Mengangkat penyesuaian referensi koordinat',
    xCoordSwitch: 'Tukar acuan koordinat horizontal',
    yCoordSwitch: 'Tukar acuan koordinat vertikal ',
    knifes: {
      number: 'nomor seri',
      diameter: 'Lebar pisau',
      type: 'jenis',
      moveSpeed: 'Kecepatan umpan cepat',
      doSpeed: 'Kecepatan pemrosesan',
      startCode: 'Kode Mulai Perubahan Alat',
      endCode: 'Kode Akhir Perubahan Alat'
      },
    ymSetting: 'Pengaturan Koneksi Easy-Mu',
    flanking: 'Pemrosesan samping',
    frontProcess: 'Pemrosesan frontal',
    oldSetting: 'Pengaturan versi lama',
    equipParamsSetting: 'Pengaturan Parameter Perangkat',
    holeSetting: 'Pengaturan meninju',
    raminoSetting: 'Pengaturan Koneksi Lamino',
    mortiseTenonSetting: 'Pengaturan Koneksi Monolitik dan Tenon',
    straight: 'Langsung',
    eccentric: 'Model ekstrasentrik',
    pbSize: 'Ukuran pelat pemecah atas dan bawah',
    slotOverlapRate: 'Tumpang Tindih Pemotongan Milling',
    breakingBoardDirection: 'Arah Papan yang Rusak (Vertikal dan Horizontal)',
    coordinateValue: 'Nilai koordinat',
    codeFormat: 'Format Pengkodean File',
    suffixSetting: 'Pengaturan Suffix File',
    insertRow: 'Masukkan baris',
    deleteRow: 'Hapus baris',
    equipmentParams: {
      equipPauseCode: 'Kode jeda perangkat',
      wiggleCode: 'Kode ayunan',
      equipStartCode: 'Kode startup perangkat',
      flipPauseCode: 'Balikkan kode',
      equipEndCode: 'Kode Akhir Perangkat',
      equipStartCodePlaceholder: 'Masukkan kode startup perangkat',
      retractingCode: 'Kode perintah penarikan alat',
      retractingCodePlaceholder: 'Masukkan kode perintah penarikan alat',
      flipPauseCodePlaceholder: 'Masukkan kode jeda flip',
      equipEndCodeTip: 'Masukkan Kode Akhir Perangkat',
      sideChangeSetting: 'Pengaturan facelift samping',
      workTip: 'Secara default, itu dimulai dari kiri ① di arah berlawanan arah jarum jam.',
      frontTurnCode: 'Mulai kode di atas',
      frontTurnEndCode: 'Kode akhir di atas',
      frontTurnCodePlaceholder: 'Masukkan kode mulai di atas',
      frontTurnEndCodePlaceholder: 'Masukkan kode akhir di atas',
      leftTurnCode: 'Mulai kode di sebelah kiri',
      leftTurnEndCode: 'Kode akhir di sebelah kiri',
      leftTurnCodePlaceholder: 'Masukkan kode start di sebelah kiri',
      leftTurnEndCodePlaceholder: 'Masukkan kode akhir di sebelah kiri',
      downTurnCode: 'Mulai kode di bawah ini',
      downTurnEndCode: 'Kode akhir berikut',
      downTurnCodePlaceholder: 'Masukkan kode mulai berikut',
      downTurnEndCodePlaceholder: 'Masukkan kode akhir berikut',
      rightTurnCode: 'Mulai kode di sebelah kanan',
      rightTurnEndCode: 'Kode akhir di sebelah kanan',
      rightTurnCodePlaceholder: 'Masukkan kode start di sebelah kanan',
      rightTurnEndCodePlaceholder: 'Masukkan kode akhir di sebelah kanan',
      topFlipCode: 'Kode Flip - Top',
      downFlipCode: 'Kode Flip - Berikutnya',
      leftFlipCode: 'Kode flip - kiri',
      rightFlipCode: 'Kode Flip - Benar',
      cylinderOutCode: 'Kode peluncuran silinder',
      cylinderbackCode: 'Kode Pengambilan Silinder',
      cylinderbackDirective: 'Instruksi retraksi silinder',
      moveDirective: 'Pindahkan perintah',
      moveAxisCode: 'Pindahkan sumbu',
      pushAxisCode: 'Poros dorong silinder',
      swingAxisCode: 'Poros ayunan',
      moveCode: 'Kode seluler',
      punchCode: 'Kode pemrosesan',
      free: 'Jalan kosong',
      punchPart: 'Bagian pemrosesan',
      cutFaceCode: 'Memproses kode pesawat',
      horVerCutFace: 'Bidang horizontal',
      horCutFace: 'Pesawat pengangkat silang',
      verCutFace: 'Pesawat pengangkat longitudinal',
      specifySmallBoardMaterialNoCut: 'Tentukan bahan papan kecil tidak memotong',
      specifySmallBoardMaterialNoCutTip: 'Papan yang mengandung kata kunci yang sesuai dalam bahan hanya akan menghasilkan file lubang dan slot yang diproses oleh bor 5/6 sisi, tidak memotong',
      addMaterialKeyword: 'Tambah kata kunci bahan',
      keyword: 'Kata kunci'
      },
    tagPool: 'Kumpulan tag data',
    dragTip: 'Tag drag-drop di tag pool',
    knives: 'Alat pemrosesan:',
    directives: 'Instruksi Pemrosesan:',
    slot: 'Pemrosesan alur lurus',
    cirWork: 'Permesinan busur',
    cirInter: 'Interpolasi busur',
    cirOption1: 'Searah jarum jam: g03 berlawanan arah jarum jam: g02',
    cirOption2: 'Searah jarum jam: G02 berlawanan arah jarum jam: G03',
    coordinate: {
      xPointSymbol: 'Koordinat horizontal:',
      yPointSymbol: 'Koordinat vertikal:',
      zPointSymbol: 'Koordinat pengangkat:',
      upright: 'Nilai positif',
      negative: 'Nilai negatif'
      },
    encodeFormat: {
      format: 'Format pengkodean file:',
      wrap: 'Pengaturan Format Line Break:',
      formatOption1: 'Format UTF-8',
      formatOption2: 'Format ANSI'
      },
    suffix: 'Pengaturan Suffix File:',
    enableFP: 'Aktifkan pemrosesan frontal',
    slotSetting: 'Tarik pengaturan slot',
    slotMillSetting: 'Pengaturan tarik alur / penggilingan / pengeboran',
    millSlot: 'Mendukung penggilingan lubang dan alur',
    millingSlotOverlapRate: 'Tingkat tumpang tindih alur penggilingan',
    millingHoleSlotOverlapRate: 'Tingkat tumpang tindih lubang dan alur penggilingan',
    takeUpDirective: 'Perintah Knife-Collection',
    workSeparately: 'Alur maju/terbalik diproses dalam dua bagian',
    secondSlotLong: 'Panjang slot kedua',
    enableOld: 'Aktifkan Pengaturan Mesin Lubang Sisi Lama',
    default: 'Pengaturan default',
    customizable1: 'Sesuaikan satu',
    customizable2: 'Kustom Dua',
    customizable3: 'Tiga Kustom',
    customizable4: 'Kustom empat',
    knifeSetting: 'Pengaturan Alat',
    soltTip: '(Termasuk lubang/slot penggilingan)',
    specialSetting: 'Pengaturan Khusus',
    ramino: 'RAMINO',
    sun: 'Raja dan mortise',
    please: 'Pantau terus',
    designatedKnives: 'Pisau yang ditunjuk',
    designated: 'Menentukan',
    workOrder: 'Perintah pemrosesan',
    other: 'lainnya',
    nameSetting: 'Pengaturan Nama Suffix',
    repeatErr: 'Ulangi nomor, harap setel ulang'
    },
  electronicSaw: {
    importMaterial: 'Impor Daftar Bahan Baku',
    formSetting: 'Pengaturan bentuk gergaji elektronik',
    fileFormat: 'Bill output Format file daftar material:',
    isSmallFile: 'Ekspor File Gambar Papan Kecil:',
    fileGroupRule: 'File gergaji elektronik dibagi menjadi tabel yang berbeda sesuai dengan warna, material, dan ketebalan papan:',
    roomsByCategory: 'File gergaji elektronik dibagi menjadi berbagai tabel sesuai dengan ruangan:',
    delimiter: 'Pembatas:',
    fileName: 'Nama file Bill of Material:',
    fineNameTip: 'Nama file Bill of Material tidak bisa kosong!',
    fileNamePlaceholder: 'Kustomisasi Bill of Material',
    outputFileEncoding: 'Format Pengkodean Daftar Output:',
    utf8: 'UTF-8 dengan bom',
    cellTab: 'Hasilkan Tab Sel:',
    texture: 'Representasi Tekstur:',
    special: 'Representasi ekstra berbentuk:',
    notSpecial: 'Bukan alien',
    genSimpleLabelBarcode: 'Hasilkan Barcode Tag Format Sederhana',
    uniqueBarCode: 'Barcode yang unik',
    uniqueBarCodeTip: 'Fungsi menghasilkan barcode tag format sederhana setelah pembukaan tidak berlaku',
    roboticArmDocking: 'Robotic Arm Docking',
    customeForm: 'Formulir Kustom',
    tagPool: 'Kumpulan tag data',
    tagPoolTips: 'Anda dapat menyeret atau mengklik untuk menyalin tag di pool',
    displayHead: 'Jangan menampilkan header',
    addTableHead: 'Tambahkan header',
    deleteTableHead: 'Hapus tajuk meja',
    generateExample: 'Menghasilkan sampel formulir output',
    importExample: 'Sampel bentuk impor',
    importExampleTip: 'Contoh bentuk yang diimpor, hanya untuk referensi gergaji elektronik khusus',
    importExampleErrTip: 'Daftar bahan baku belum diimpor, harap impor daftar bahan baku',
    outputExample: 'Sampel formulir output',
    outputExampleTip: 'Contoh output formulir khusus',
    outputExampleErrTip: 'Sampel formulir output belum dihasilkan, harap hasilkan sampel formulir output',
    defaultTableHead: 'Header default',
    deleteHeadErrTip: 'Tidak ada header untuk dihapus!',
    genNonString: 'Menghasilkan tipe data format non-teks',
    genNonStringTip: 'Anda dapat mencoba mengaktifkan data tabel yang dihasilkan jika gergaji elektronik tidak dikenali.',
    revertWidth: 'Penyesuaian Panjang dan Lebar'
    },
  lockModal: {
    passwordInput: 'Harap masukkan kata sandi Anda',
    lockPassword: 'Kata sandi buka kunci',
    lockPasswordInput: 'Harap masukkan kata sandi buka kunci',
    passwordInputPlaceholder: 'Harap masukkan kata sandi empat digit',
    editPassword: 'Ubah Kata Sandi',
    confirmPassword: 'Konfirmasi Kata Sandi',
    setLockPwd: 'Setel Kata Sandi Buka Kunci',
    pwdFormatErr: 'Kesalahan format kata sandi',
    sendMessageTo: 'Kode verifikasi SMS akan dikirim ke',
    captchaPlaceholder: 'Harap masukkan kode verifikasi',
    sendCaptcha: 'Kirim kode verifikasi',
    sendSeccess: 'SMS berhasil dikirim',
    sendFail: 'SMS gagal, coba lagi nanti',
    updateSeccess: 'Pengaturan kata sandi berhasil',
    editSuccess: 'Modifikasi kata sandi berhasil',
    lockSeccess: 'Tidak terkunci dengan sukses',
    lock: 'Membuka kunci',
    lockSeccessTip: 'Terkunci dengan sukses',
    inputErrLimit: 'Jumlah kesalahan saat ini telah mencapai batas, silakan atur ulang kata sandi buka kunci!'
    },
  dock56Drill: {
    equipType: 'Jenis peralatan',
    equipment: 'peralatan',
    fiveDock: 'Berlian lima sisi',
    sixDock: 'Berlian enam sisi',
    fileType: 'Menghasilkan jenis file',
    templateOffline: 'Template yang digunakan telah offline!',
    showExample: 'Tampilkan sampel data',
    conNoticeTip: 'Tindakan Pencegahan Docking:',
    conNoticeTip1: '1. Mesin ukiran dengan "XY Axis Swap" yang diaktifkan perlu mengaktifkan fungsi "Pengaturan Perangkat Pengolahan Lubang dan Slot Otomatis Sesuai Pertukaran" di mesin ukiran.',
    conNoticeTip2: '2. Untuk menampilkan atau memproses bagian berbentuk pelat pada latihan lima dan enam sisi, data bagian yang dibentuk perlu dikonfigurasi dalam templat.',
    conNoticeTip3: '3. Setelah menggunakan bor lima dan enam untuk pertama kalinya atau mengganti templat, silakan <span style = "Color:#f00"> Untuk produksi uji coba kabinet </span>, dan kemudian melakukan produksi reguler setelah mengkonfirmasi bahwa itu benar.',
    conNoticeTip4: '4. Selama produksi percobaan, silakan periksa apakah ukuran, kedalaman, permukaan, dan lokasi slot wajah depan dan belakang benar, dan hindari masalah mirroring kabinet.',
    example: 'Sampel data',
    commonSetting: 'Pengaturan Parameter Umum',
    throughHoleSetting: 'Lubang melalui dibuka di kedua sisi',
    throughSlotSetting: 'Buka slot di kedua sisi',
    nonHolesNotFiles: 'Pelat persegi panjang tidak memiliki lubang dan tidak ada file output:',
    frontFileIdentifier: 'Identifikasi file depan:',
    oppositeFileIdentifier: 'Pengidentifikasi File Terbalik:',
    oppositeFileIdentifierTips: 'Metode pembuatan adalah: Kode papan 13-bit asli + karakter identifikasi',
    arcDescription: 'Metode deskripsi busur',
    linePoints: 'Deskripsi cetakan segmen garis',
    arcCommand: 'Deskripsi instruksi busur',
    slotWidthSplit: 'Alur lebar dibongkar menjadi beberapa alur sempit untuk diproses:',
    slotSplitWidth: 'Lebar slot tunggal setelah pembongkaran:',
    mm: 'CATATAN: Objek yang dibongkar adalah slot persegi panjang normal',
    isNotMergeSlot: 'Proses penarik lebaran dan kedalaman yang sama berdekatan:',
    slotPunchTip: 'Fitur ini hanya berfungsi untuk slot panel belakang dan slot panel bawah laci menggunakan templat khusus',
    sizeRange: 'Ukuran yang berdekatan kurang dari atau sama dengan',
    enableWorningTip: 'Fungsi ini tidak dapat dihidupkan pada saat yang sama dengan arah penempatan tepi depan',
    longDirection: 'Arah penempatan sisi yang panjang',
    horizontal: 'Horisontal',
    vertical: 'Vertikal',
    slotDirection: 'Lima/enam sisi pengeboran atau arah penempatan berbentuk khusus',
    default: 'Default Sistem',
    frontLeft: 'Depan dan kiri',
    frontRight: 'Depan dan kanan',
    backLeft: 'Kembali dan kiri',
    backRight: 'Kembali dan kanan',
    frontDirection: 'Arah penempatan tepi depan',
    enableTip: 'Catatan: Hanya efektif untuk pengaturan huruf cloud',
    fixedOn: 'Diperbaiki di:',
    front: 'Sebelum',
    back: 'di belakang',
    left: 'kiri',
    right: 'Kanan',
    coordinateValue: 'Jumlah digit yang ditahan dari nilai koordinat:',
    decimalPlaces: 'Sedikit',
    slotLengthCompensation: 'Kompensasi panjang slot',
    curveholesLengthCompensation: 'Kompensasi bentuk dalam',
    slotCompensationEqualZero: 'Kompensasi tepi slot ketika jarak adalah nol',
    slotCompensationNotEqualZero: 'Kompensasi tepi slot ketika jarak tidak nol',
    slotCompensationTip: 'Gunakan fungsi ini ketika pemrosesan menunjukkan sudut bulat kecil yang tidak lengkap atau panjang yang tidak mencukupi',
    curveholesCompensationEqualZero: 'Kompensasi panjang tepi siku ketika jarak adalah nol',
    curveholesCompensationTip: 'Masukkan nilai: Jari-jari alat pemotongan bentuk khusus',
    curveholesCompensationTip2: 'Ketika memotong internal alien di luar sisi persegi panjang, semua sisi yang berisi alien akan dipotong secara bersamaan',
    specialParameter: 'Pengaturan Parameter Khusus',
    output5FDrillSlotKnifeCode: 'XML2 Slot Milling Alat Nomor',
    output5FDrillShapeKnifeCode: 'Nomor alat penggilingan xml2',
    plankTexture: 'Tekstur papan XML2',
    offset: 'Kompensasi Alat Penggilingan XML2',
    mprConHoleDir: 'Lima/Enam Sisi Pengeboran Sisi File MPR Wajah Z Koordinat Permukaan Referensi',
    plankTop: 'Permukaan atas pelat',
    plankBottom: 'Permukaan pelat bawah',
    codeInfo: 'File format larangan berisi informasi kode:',
    bomFile: 'File format BOM output:',
    plankHeight: 'Deskripsi Tinggi Piring:',
    plankNum: 'Nomor Dewan Deskripsi:',
    backZpoint: 'Reverse Groove Z Koordinat:',
    plankThick: 'Ketebalan',
    slotDeep: 'Kedalaman alur',
    outputMprFile: 'Jenis file',
    oldMPR: 'Versi lama MPR',
    newMPR: 'Versi baru MPR',
    mprFileZside: 'Lima/Enam Sisi Pengeboran Sisi File MPR Wajah Z Koordinat Permukaan Referensi',
    fileTypeOffline: 'Jenis file bor lima dan enam sisi yang saat ini dipilih telah offline, harap konfirmasi!',
    permissionErr: 'Informasi identitas telah hilang, buka halaman ini lagi dari kabinet!',
    banFileSetting: 'Pengaturan file format larangan',
    banFileCodeInfo: 'File format larangan berisi informasi kode:',
    huahuaLine: 'Birch Automatic Line',
    huahuaLineTip: '(Tidak kompatibel dengan standar penempatan label)',
    huahuaPartFlag: {
      longSide: 'Sisi panjang kurang dari',
      shortSide: 'atau sisi pendek kurang dari',
      partFlag: 'menghasilkan penanda papan kecil untuk papan',
      tip: '（Tampilan pada label perlu menambahkan data "papan identifikasi - papan tanda", data yang sesuai akan secara otomatis ditambahkan ke berkas baris tersinggung）'
      },
    plankPutWay: 'Metode penempatan papan',
    plankPutWayTip: 'Jika jalur produksi saat ini membuka jalur otomatis birch, tidak didukung untuk mengatur metode penempatan panel secara terpisah',
    autoHandle: 'Pengelakan otomatis klem',
    manualHandle: 'Pengaturan pengelakan manual',
    fixedFront: 'Pengelakan tetap muka',
    plankNamePlacement: 'Penempatan berdasarkan nama papan',
    plankNamePlacementTip1: '1. Setelah diatur, jika nama papan mengandung field yang ditetapkan, sisi papan yang sesuai akan dipasang ke sisi perangkat yang ditentukan sesuai pengaturan',
    plankNamePlacementTip2: '2. Prioritas pengaturan ini lebih tinggi daripada pengaturan metode penempatan papan di atas',
    plankNamePlacementTip3: '3. Fitur ini hanya berlaku untuk tata letak cloud; jika jalur produksi saat ini mengaktifkan jalur otomatis Huahua, pengaturan penempatan papan terpisah tidak didukung',
    addRow: 'Tambah baris',
    plankNameTip: 'Silakan masukkan nama papan',
    plankSide: 'Sisi papan',
    deviceSide: 'Tetap di perangkat',
    weldingPlatePlacementEnable: 'Pengelakan papan las tetap klem',
    onlyBluen: 'Hanya efektif untuk tata letak awan',
    fixedEdge: 'Pengelakan panjang tetap klem',
    fixedEdgeRule: 'Aturan: Tentukan penempatan papan',
    fixedEdgeRuleItem1: 'Panjang tepi dekat dengan klem',
    fixedEdgeRuleItem2: 'Tepi dekat dengan klem',
    fixedEdgeRuleItem3: 'Slot lubang menghindari',
    fixedEdgeRuleItem4: 'Urutan prioritas',
    satisfiedCondition: 'Kondisi terpenuhi',
    handDirection: 'Arah posisi klem',
    handleMachineTip: 'Dengan memutar, slot dan bentuk khusus akan secara otomatis menghindari sisi klem, memudahkan pemrosesan papan',
    handleWidth: 'Lebar klem',
    handleLength: 'Panjang klem',
    handleMaxWidth: 'Lebar maksimum yang dapat diproses',
    usefulRange: 'Rentang efektif',
    plankLongSide: 'Sisi panjang papan',
    usefulRangeTip: 'Ketika pemposisi papan sisi panjang diaktifkan dan sisi panjang papan berada dalam rentang efektif ini, pemposisi slot dan bentuk khusus akan diprioritaskan',
    moveTip: 'Pengaturan identifikasi file depan dan belakang telah dipindahkan ke',
    millingOuter: 'Penggilingan Alien',
    millingInner: 'Alien dalam penggilingan',
    drilling: 'Pemrosesan lubang',
    slotting: 'Slot pemrosesan',
    knivesTip1: '1, Mengatur jalur pemotongan setelah penggilingan pisau asing akan mengkompensasi radius pisau',
    knivesTip2: '2, Pemotongan asing sementara tidak mendukung mesin ukiran pertukaran sumbu xy',
    internalCutting: 'Pemotongan bentuk tidak beraturan internal, baik pemotongan awal maupun akhir, dilakukan di bagian dalam pelat.',
    externalCutting: 'Pemotongan bentuk tidak beraturan eksternal, baik pemotongan awal maupun akhir, dilakukan di bagian luar pelat.',
    externalCuttingDirection: 'Pemotongan bentuk tidak beraturan eksternal, termasuk semua tepi bentuk tidak beraturan, akan diproses secara bersamaan.',
    allExternalCutting: 'Semua bentuk luar',
    onlyArcExternalCutting: 'Hanya bentuk lingkaran luar'
    },
  doorWallCabinet: {
    tempErrTip: 'Terdeteksi bahwa Anda belum menambahkan template yang digunakan oleh mesin pintu-dinding-lemari, sehingga file pemrosesan tidak dapat diekspor. Catatan: setelah menambahkan, Anda perlu melakukan tata letak ulang.',
    title: 'Mesin pintu dinding lemari',
    guifang: 'Penguadratan',
    processingTechnology: 'Teknologi Pengolahan',
    longPlateSecondarySquaring: 'Pemotongan kedua',
    slotOnDoorPlate: 'Lubang pada papan pintu',
    setting: 'Pengaturan Mesin Pintu Dinding Lemari'
    },
  PTP: {
    title: 'PTP',
    outputFileFormat: 'Format file output',
    outputDefaultFileFormat: 'File format default output',
    outputMPRFormat: 'File format MPR output',
    fileFormatSettings: 'Pengaturan Format File',
    wrapSettings: 'Pengaturan Format Line Break:',
    enCodeSettings: 'Pengaturan Format Pengkodean File:',
    utf8bom: 'UTF-8 dengan bom',
    partCoordinate: 'Koordinat papan kecil',
    xPointSymbol: 'Koordinat horizontal:',
    yPointSymbol: 'Koordinat vertikal:',
    zPointSymbol: 'Koordinat pengangkat:',
    upRight: 'Nilai positif',
    negative: 'Nilai negatif',
    plankMirroring: 'Cermin papan',
    plankMirrorSetting: 'Pengaturan Mirroring Papan:',
    xAxis: 'Mirroring X-Axis',
    yAxis: 'Cermin sumbu y',
    mirrorTip: '(Fungsi ini digunakan saat mencerminkan papan)',
    knifeTable: {
      type: 'jenis',
      diameter: 'Diameter φ',
      offsetX: 'Offset x',
      offsetY: 'Mengimbangi y',
      offsetZ: 'Offset Z.',
      offsetNo: 'Nomor offset',
      drillVelocity: 'Memotong [f] mm/mnt',
      cutVelocity: 'Memproses [f] mm/mnt',
      rotationSeep: 'Kecepatan R/Min',
      insertRow: 'Masukkan baris',
      deleteRow: 'Hapus baris'
      },
    labelPool: 'Kumpulan tag data',
    dragTip: 'Anda dapat menyeret atau mengklik untuk menyalin tag di kumpulan tag ke kotak input',
    procedure: 'program',
    beginCode: 'Kode Mulai Program:',
    endCode: 'Kode Akhir Program:',
    zzdKnifeBeginCode: 'SPINDLE TOOD Ubah Kode Mulai:',
    spindleCutter: 'Alat spindel',
    zzdKnifeEndCode: 'Alat spindle mengubah kode akhir:',
    verticalDrill: 'Bor vertikal',
    czzBeginCode: 'Kode startup bor vertikal:',
    czzEndCode: 'Kode ujung bor vertikal:',
    czzKnifeBeginCode: 'Alat bor vertikal Ubah Kode Mulai:',
    czzKnifeEndCode: 'Alat bor vertikal Ubah kode akhir:',
    sidetrack: 'Bor samping',
    czBeginCode: 'Kode startup bor samping:',
    czEndCode: 'Kode akhir pengeboran samping:',
    czKnifeBeginCode: 'Perubahan Alat Bor Samping Kode Mulai:',
    czKnifeEndCode: 'Alat bor samping Ubah Kode Akhir:',
    pauseCode: 'Kode jeda:',
    zSafeHeight: 'Jarak yang aman',
    spindleKnife: 'Alat spindle dan bor vertikal ketinggian keamanan sumbu z',
    sideDrillZ: 'Pengeboran samping ketinggian keamanan sumbu z',
    sideDrillXY: 'Pengeboran samping X/Y Jarak Keselamatan Sumbu',
    auxiliaryFunction: 'Fungsi tambahan',
    xhDedicatedInfo: 'Hasilkan Informasi Khusus untuk Peralatan Starlight',
    xhCheckBox: 'data:',
    outputSettings: 'Pengaturan Output:',
    partExegesis: 'Menghasilkan komentar ukuran papan kecil dalam file',
    knifeNo: 'Nomor Alat',
    specailKnifeNo: 'Memproses Nomor Alat Berbentuk Khusus:',
    slotKnifeNo: 'Nomor Alat Grooving:',
    fileNamePlaceholder: 'Kustomisasi Bill of Material',
    slotDrill: 'Pisau pelurus'
    },
  glassEquip: {
    title: 'Mesin pemotong kaca',
    fileType: 'Memproses Jenis File:',
    sizeReparation: 'Kompensasi Ukuran Plat:',
    cutPreSpace: 'Jarak yang dipesan untuk cutting piring:',
    divideIntoFolders: 'Mengklasifikasikannya menjadi folder yang berbeda sesuai dengan warna, bahan, dan ketebalan kaca:'
    },
  translate: {
    search: 'Harap masukkan terjemahan Cina atau resmi untuk menemukan entri',
    en: 'Bahasa inggris',
    es: 'Spanyol',
    ar: 'Arab',
    kz: 'Kazakh',
    vi: 'Vietnam',
    th: 'Bahasa Thailand',
    id: 'Indonesian',
    ug: 'Bahasa Uyghur',
    customTranslate: 'Klik untuk menambahkan terjemahan khusus',
    customText: 'Terjemahan khusus',
    text: 'Cina',
    targetLang: 'Terjemahan resmi',
    zh_hant: 'Cina Tradisional'
    },
  preLayoutSetting: {
    title: 'Pengaturan pra-tipe',
    titleTip: 'Anda dapat mengatur parameter tata letak terlebih dahulu, ketik terlebih dahulu, dan kemudian pilih jalur produksi.',
    settingTip: 'Parameter yang diatur dalam jalur produksi harus konsisten dengan parameter pra-tipe berikut sebelum mengeluarkan file produksi, dan hanya akan efektif untuk mesin pemotong',
    emptyKnife: 'Alat tidak diisi',
    noModify: 'Pengaturan tidak dimodifikasi dan tidak perlu menyimpannya',
    reSet: 'pemulihan',
    gayPosition: 'Kotak abu -abu dapat mengganti penempatan bahan residu',
    surplusPosition: 'Penempatan bahan residu saat ini',
    click: 'Klik',
    grayStart: 'Kotak abu -abu dapat mengganti titik awal stasiun',
    currentStart: 'Ini adalah titik awal dari stasiun saat ini',
    holeSlotSetting: 'Pengaturan pemrosesan slot pelurus dan lubang',
    knifeDiameter: 'Diameter alat pemotongan',
    currentVersion: 'Versi saat ini',
    on: 'Membuka',
    off: 'penutup',
    firstShort: 'Volume tepi tiang pangkas pertama',
    firstLong: 'Beban samping cut-length pertama',
    cuttingSplitLong: 'Piring panjang dipotong dalam dua kali - sisi panjang melebihi',
    cuttingSplitShort: 'Piring panjang dipotong dalam dua kali - sisi pendek melebihi',
    plankThick: 'Ketebalan panel non-pintu ≥ ',
    singleDoorThick: 'Ketebalan panel pintu ≥ ',
    normalPlank: 'Dewan reguler',
    confilictTip: 'Ada konflik dalam pengaturan: {confilicttotal}',
    selectLine: 'Pilih Jalur Produksi',
    selectLinePlaceholder: 'Pilih jalur produksi',
    lineConfilictTip: 'Ada konflik antara memilih jalur produksi dan {line}',
    preWay: 'Solusi pra-typesetting',
    paibanErrTip: 'Ketika ada perubahan dalam pemrosesan papan panjang [tepi panjang dan pendek meningkatkan volume], itu dapat menyebabkan kegagalan tata letak.',
    paibanTip: 'Tata letak ini memiliki pemotong yang ditunjuk untuk bahan pelat besar, sehingga perlu diketik ulang',
    reLayout: 'Diatur ulang dengan jalur produksi saat ini',
    fetchErr: 'Gagal mendapatkan pengaturan pra-tipe',
    resetSuccess: 'Kembalikan dengan sukses',
    resetConfirm: 'Konfirmasi untuk memulihkan ke versi historis?',
    prolineName: 'Nama Jalur Produksi',
    layoutGap: 'Kesenjangan pengaturan huruf',
    generalThickness: 'Ketebalan pelat objek pemotongan sekunder',
    cutGeneralPlank: 'Papan Pengaturan Objek Pemotongan Sekunder',
    cutSingleDoor: 'Panel pintu objek pemotongan sekunder',
    secondary_cutting_board_list: 'Tentukan nama papan Daftar nama potongan papan',
    changeProline: 'Beralih Jalur Produksi',
    backTip: 'Harap kembali ke jalur produksi seleksi tata letak global',
    preLayout: 'Ketik sesuai dengan skema tata letak pra-tipe',
    preWayEmpty: '(Kosong) Skema Pra-Jenis',
    specialConfilictTip: 'Proses penggilingan bawah busur mempengaruhi hasil tata letak dan perlu diketik ulang'
    },
  lunbo: {
    tips: 'Tip Operasi',
    introduction: 'Pendahuluan Fungsional',
    qtDownloadText: 'Warm Reminder: Jika ada file unduhan yang tidak lengkap, silakan buka halaman web Cloud Layout untuk diunduh!'
    },
  sendModal: {
    paibanImgType: 'Jenis file tata letak grafis'
    },
  authenticationModal: {
    title: 'Pemindaian QR Code untuk verifikasi',
    tip: 'Harap jangan menutup kotak dialog sebelum verifikasi berhasil!',
    countdownTip: '{countdown} setelah kedaluwarsa',
    refreshTip: 'Segarkan QR Code',
    qrcodeTip: 'Silakan pemindaian QR Code dengan WeChat untuk menyelesaikan operasi',
    qrcodeTip2: 'Jika pemindaian QR Code gagal, silakan izinkan akses ke sistem dalam pengaturan umum kabinet - pengaturan izin akses pengguna.',
    waiting: 'Menunggu pemindaian QR Code',
    scanning: 'Sedang memindaian QR Code, menunggu verifikasi',
    success: 'Verifikasi berhasil',
    error: 'Verifikasi gagal',
    expired: 'QR Code telah kedaluwarsa',
    tip2: 'Demi keamanan data akun Anda, harap verifikasi informasi operator yang sedang melakukan tindakan',
    tip3: 'Kabinet untuk produksi uji harus, {fontStyleStart}tidak simetris, untuk menghindari masalah pencerminan kabinet{fontStyleEnd}'
    },
  printTag: {
    dualLanguageTip: 'Anda belum memiliki izin untuk membuat label dwibahasa Tionghoa-Inggris; saat ini hanya dapat pratinjau. Hubungi tim penjualan untuk mengaktifkan penggunaan penuh~',
    generateDualLanguageTagTip: 'Buat label dwibahasa Tionghoa-Inggris',
    dualLanguageTip2: 'Fitur ini berbayar. Silakan hubungi tim sales untuk mengaktifkannya sebelum digunakan~',
    effectiveDataSource: 'Sumber Data yang Efektif',
    partName: 'Nama papan'
    },
  userAccessToken: {
    createTime: 'Waktu pembuatan',
    lastUsedTime: 'Waktu terakhir digunakan',
    expireTime: 'Waktu kedaluwarsa',
    status: 'Status',
    tokenNamePlaceholder: 'Harap masukkan nama token',
    expireTimeSelectPlaceholder: 'Harap pilih waktu kedaluwarsa',
    securityBannerTip: 'Jangan bagikan token akses pribadi Anda kepada orang lain atau mengeksposnya di browser atau kode klien lain. Untuk keamanan akun, token yang bocor di tempat umum dapat dinonaktifkan secara otomatis.',
    expired: 'Kedaluwarsa',
    valid: 'Berlaku',
    remove: 'Hapus',
    previewOnceWarning: 'Token ini hanya ditampilkan sekali. Simpan rahasia ini di tempat yang aman dan dapat diakses. Jangan bagikan kepada orang lain atau mengeksposnya di browser atau kode klien lain.',
    token: 'Token',
    deleteConfirm: 'Yakin ingin menghapus token ini?',
    userAccessToken: 'Token Akses Pengguna',
    dayUnit: 'hari',
    custom: 'Kustom',
    previewModalTitle: 'Token akses pribadi baru',
    addModalTitle: 'Tambahkan token akses pribadi baru'
    },
  bujianStore: {
    inputPlaceholder: 'Masukkan kode plank untuk mencari papan tambahan',
    noData: 'Tidak ada data',
    loadingErr: 'Pembangunan papan tambahan gagal',
    bujianStore: 'Toko papan tambahan',
    awaitStore: 'Toko papan tambahan',
    noDrag: 'Tidak dapat ditempatkan, klik tombol untuk meletakkan papan ke dalam toko papan tambahan',
    outOfCanvas: 'Tidak dapat ditempatkan, silakan periksa properti material, warna dan ketebalan papan'
    },
  alginTexture: {
    tip: 'Operasi ini akan menghapus informasi penyelarasan tekstur papan. Apakah Anda yakin ingin melanjutkan?',
    tip2: 'Operasi ini akan mempengaruhi celah antara bagian, menyebabkan masalah pemrosesan. Apakah Anda yakin ingin melanjutkan?',
    group: 'Grup Teks',
    groupTemp: 'Grup Teks Satu',
    textureAlignmentPlank: 'Tidak dapat memindahkan plang perataan tekstur'
    },
  customizeFolder: {
    customizeFolder: 'Kustomisasi Folder',
    customizeFolderTip: 'Catatan: Setelah mengaktifkan kustomisasi folder, aturan pembagian folder yang diatur sebelumnya tidak akan berlaku lagi',
    processingFilesTitle: 'Memproses data file',
    dragToFolderTip: 'Bisa diseret ke folder kiri sebagai subfolder atau file',
    folderNameEmpty: 'Nama folder tidak boleh kosong',
    folderNameExists: 'Folder dengan nama yang sama sudah ada',
    fileNotFound: 'Gagal mendapatkan file yang benar',
    fileCannotBeClassified: 'Jenis file ini tidak dapat ditempatkan di bawah folder klasifikasi apa pun',
    cannotAddAtThisPosition: 'Tidak dapat menambahkan di posisi ini',
    fileAlreadyExists: '【{name}】sudah ada di folder ini',
    confirmDeleteFolder: 'Apakah Anda yakin ingin menghapus folder ini?',
    confirmDeleteItem: 'Apakah Anda yakin ingin menghapus 【{name}】?',
    confirmDeleteFolderWithChildren: 'Ada folder/file lain di bawah folder ini, apakah Anda yakin ingin menghapusnya?',
    deleteFile: 'Hapus file',
    addSubFolder: 'Tambahkan subfolder',
    editFolder: 'Edit folder',
    deleteFolder: 'Hapus folder',
    rootCannotDelete: 'Direktori root tidak dapat dihapus',
    newFolder: 'Folder baru',
    fileUsedCanDrag: 'Digunakan - Bisa diseret berulang kali',
    fileDraggable: 'Bisa diseret',
    addFileToFolder: 'Tambahkan 【{fileName}】 ke {folderName}',
    addFolderTitle: 'Tambahkan folder',
    editFolderTitle: 'Edit folder',
    folderNameLabel: 'Nama folder',
    folderNamePlaceholder: 'Silakan masukkan nama folder',
    sequenceStartLabel: 'Nilai awal urutan bertambah',
    classifyMethodLabel: 'Metode klasifikasi',
    nameLengthLimitLabel: 'Batas panjang karakter',
    tagInsertTip: 'Klik tag untuk memasukkan ke nama folder',
    classifyTagInsertTip: 'Klik tag untuk memasukkan ke nama folder, file akan diklasifikasikan sesuai tag yang ditentukan',
    engraving_front: 'File depan mesin ukir',
    engraving_opposite: 'File reverse mesin ukir',
    engraving_merge: 'File gabungan mesin ukir',
    engraving_mill: 'Pemotongan alur tanduk pengolahan sekunder',
    engraving_haitang: 'File sudut Haitang miring pengolahan sekunder',
    engraving_arc_slot: 'Slot busur dasar penggilingan pengolahan sekunder',
    engraving_line_slot: 'Pemrosesan sekunder jalur alat kustom',
    engraving_straight_arc_slot: 'Pemrosesan sekunder bagian tikungan busur slot lurus',
    engraving_frame_door: 'Pemrosesan sekunder file pintu tulang',
    engraving_inner_shape: 'Pemrosesan sekunder bagian dalam bentuk',
    engraving_hole: 'Pemrosesan sekunder lubang biasa',
    engraving_slot: 'Pemrosesan sekunder slot biasa',
    engraving_single_file_merge: 'Pemrosesan sekunder file merge',
    electronic_saw: 'File gergaji elektronik',
    glass: 'File mesin potong kaca',
    glass_machine: 'Mesin potong kaca',
    side_machine: 'File mesin lubang samping',
    side_machine_xml3: 'File XML3 mesin lubang samping versi lama',
    side_machine_txt: 'File TXT mesin lubang samping versi lama',
    side_machine_nc: 'File NC mesin lubang samping versi lama',
    dock56F: 'File bor lima/enam sisi',
    ptp: 'File PTP',
    aio: 'File mesin all-in-one',
    aio_anc: 'File ANC bagian depan mesin serba guna',
    labeling_1: 'File mesin pelabelan 1',
    labeling_2: 'File mesin pelabelan 2',
    labeling_3: 'File mesin pelabelan 3',
    robotic_arm: 'File lengan robot',
    label_image: 'File gambar label',
    label_pdf: 'File PDF label',
    paiban_image: 'File gambar penataan',
    paiban_pdf: 'File PDF gambar penataan',
    engraving: 'Mesin ukir',
    electronic: 'Gergaji elektronik',
    side_hole: 'Mesin lubang samping',
    drilling: 'Pengeboran lima/enam sisi',
    labeling: 'Mesin pelabelan',
    robotic: 'Lengan robot',
    label: 'Label',
    warningTip: 'Harap catat: Kurung kurawal 【{}】 dan isinya harus tetap utuh, jangan hapus/tambah secara manual!',
    fileClassifyError: 'File ini tidak dapat diklasifikasikan menurut {classifyNames}',
    folderClassifyByTextureColorThickSize: 'Klasifikasikan ke dalam folder berbeda menurut warna, material, ketebalan, dan ukuran papan besar (file label bersama)',
    unnamed: 'Tanpa nama',
    specialText: 'Khusus',
    surplusText: 'Bahan surplus',
    normalText: 'Normal',
    plankText1: 'Papan',
    resetTemplate: 'Reset template',
    resetTemplateConfirm: 'Apakah Anda yakin ingin mereset template?',
    clearTemplate: 'Hapus template',
    clearTemplateConfirm: 'Apakah Anda yakin ingin menghapus template?',
    legendFixedFolder: 'Folder tetap',
    legendClassifyFolder: 'Folder klasifikasi',
    legendFixedTag: 'Data tetap',
    legendNormalTag: 'Data dinamis',
    legendClassifyTag: 'Data dinamis klasifikasi',
    door_wall_aio: 'Mesin pintu dinding lemari',
    noPermission: 'Anda belum memiliki izin folder kustom. Silakan hubungi tim sales untuk membeli fitur ini sebelum digunakan.',
    enableCustomFolder: 'Aktifkan folder kustom',
    exporttagTip: 'Saat mengekspor tag PDF dan gambar secara bersamaan, PDF dikirim secara default'
    },
  paibanTask: {
    pausedTip: 'Tugas yang Ditangguhkan',
    deleteTip: 'Apakah Anda yakin ingin menghapus tugas "{taskBatch}"? Tugas ini tidak dapat dipulihkan setelah dihapus.',
    continueTip: 'Lanjutkan Tugas',
    completed: 'Selesai',
    failed: 'Tugas Gagal',
    paused: 'Ditangguhkan',
    pending: 'Menunggu',
    running: 'Berjalan',
    extraTip: 'Tugas tata letak hanya menampilkan data minggu lalu. Silakan simpan tugas ke riwayat setelah selesai!',
    taskStatus: 'Status Tugas',
    createTaskTip: 'Buat tugas tata letak, masuk ke tata letak belakang',
    taskBatchTitle: 'Batch tugas',
    relatedOrderNosTitle: 'Nomor pesanan terkait',
    progressTitle: 'Kemajuan tata letak',
    boardCountTitle: 'Estimasi penggunaan papan',
    optimizedAreaTitle: 'Estimasi area yang dioptimalkan',
    productionLineTitle: 'Lini produksi',
    operationTitle: 'Operasi',
    optimizeRateTitle: 'Estimasi tingkat optimasi',
    optimizeRateTip: 'Tingkat optimasi material sisa yang dipotong secara otomatis tidak dihitung.',
    optimizeRateTip2: 'Tingkat optimasi yang spesifik didasarkan pada halaman tata letak',
    boardCountTip: 'Penggunaan papan yang spesifik didasarkan pada halaman tata letak',
    optimizedAreaTip: 'Area yang dioptimalkan yang spesifik didasarkan pada halaman tata letak',
    paibanSettingTip: 'Pengaturan produksi garis untuk tugas saat ini telah diubah. Hasil tata letak saat ini mungkin bertentangan dengan file ekspor produksi yang sebenarnya. Disarankan untuk meletakkan ulang produksi.',
    dataException: 'Kesalahan data, silakan perbarui halaman dan coba lagi'
    },
  paibanSetting: {
    advancedSetting: 'Pengaturan lanjutan',
    advancedFeature: 'Fitur lanjutan',
    surplusCutSpeedUp: 'Peningkatan kecepatan potongan sisa',
    surplusCutSpeedUpTip4: 'Pengembangan fitur sedang berlangsung, mohon tunggu',
    surplusCutSpeedUpTip: 'Jarak tata letak sisa secara otomatis diatur ke 0',
    surplusCutSpeedUpTip2: 'Pemotongan sisa secara otomatis melewati jalur yang sudah dipotong dan jalur trimming tepi untuk meningkatkan efisiensi',
    surplusCutSpeedUpTip3: 'Fitur ini hanya berfungsi untuk mesin engraving dan mesin engraving satu putaran (jangan gunakan bersama dengan pemotongan tepi umum atau percepatan tepi umum)',
    surplusCutSpeedUpTip5: 'Hanya efektif untuk mesin engraving dan mesin engraving satu putaran',
    featureDisplay: 'Tampilan fitur',
    featureDisplayTip: 'Halaman ini hanya mengontrol apakah pintu masuk fitur ditampilkan, tidak mengubah status aktif maupun konfigurasi parameter fitur itu sendiri'
    },
  alignedPlan: {
    deepSearch: 'Pencarian Mendalam',
    deepSearchTip: 'Fitur eksklusif: tingkatkan kedalaman perhitungan dengan menyusun ulang untuk hasil nesting yang lebih baik',
    deepSearchTip2: 'Setelah upgrade Deep Search, susun ulang untuk meningkatkan kedalaman perhitungan. Saat ini dapat dicoba',
    deepSearchTip3: 'Deep Search memberikan skema nesting yang lebih hemat papan',
    deepSearchTip4: 'Anda belum memiliki izin nesting Deep Search. Silakan hubungi sales untuk membeli.',
    deepSearchTip5: 'Setelah upgrade Deep Search, nikmati daya komputasi server khusus untuk kualitas nesting lebih baik. Saat ini dapat dipratinjau'
    },
  assistant: {
    title: 'Asisten AI',
    welcome: 'Saya Asisten Penataan Cloud. Saya dapat menjelaskan fitur perangkat lunak, mencari data, dan mengarahkan Anda ke halaman yang sesuai.',
    close: 'Tutup panel'
    }
  }